import * as b from "react";
import z, { useEffect as le, useState as Ue, forwardRef as We, memo as vi, createContext as xt, useMemo as Be, isValidElement as qr, useContext as rt, useLayoutEffect as Rs, Fragment as vt, useRef as ae, useReducer as gi, createRef as Pd, useCallback as bi, cloneElement as Ad, createElement as Ld } from "react";
import * as Os from "react-dom";
import Id, { flushSync as Dd } from "react-dom";
function yi(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Ns = { exports: {} }, Vr = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Fd = z, Md = Symbol.for("react.element"), $d = Symbol.for("react.fragment"), Bd = Object.prototype.hasOwnProperty, zd = Fd.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, Ud = { key: !0, ref: !0, __self: !0, __source: !0 };
function Cs(e, t, n) {
  var r, o = {}, i = null, a = null;
  n !== void 0 && (i = "" + n), t.key !== void 0 && (i = "" + t.key), t.ref !== void 0 && (a = t.ref);
  for (r in t) Bd.call(t, r) && !Ud.hasOwnProperty(r) && (o[r] = t[r]);
  if (e && e.defaultProps) for (r in t = e.defaultProps, t) o[r] === void 0 && (o[r] = t[r]);
  return { $$typeof: Md, type: e, key: i, ref: a, props: o, _owner: zd.current };
}
Vr.Fragment = $d;
Vr.jsx = Cs;
Vr.jsxs = Cs;
Ns.exports = Vr;
var R = Ns.exports, Ts = { exports: {} }, Wd = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED", Hd = Wd, Kd = Hd;
function js() {
}
function ks() {
}
ks.resetWarningCache = js;
var qd = function() {
  function e(r, o, i, a, s, l) {
    if (l !== Kd) {
      var c = new Error(
        "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
      );
      throw c.name = "Invariant Violation", c;
    }
  }
  e.isRequired = e;
  function t() {
    return e;
  }
  var n = {
    array: e,
    bigint: e,
    bool: e,
    func: e,
    number: e,
    object: e,
    string: e,
    symbol: e,
    any: e,
    arrayOf: t,
    element: e,
    elementType: e,
    instanceOf: t,
    node: e,
    objectOf: t,
    oneOf: t,
    oneOfType: t,
    shape: t,
    exact: t,
    checkPropTypes: ks,
    resetWarningCache: js
  };
  return n.PropTypes = n, n;
};
Ts.exports = qd();
var Vd = Ts.exports;
const x = /* @__PURE__ */ yi(Vd);
var Ps = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function n() {
      for (var i = "", a = 0; a < arguments.length; a++) {
        var s = arguments[a];
        s && (i = o(i, r(s)));
      }
      return i;
    }
    function r(i) {
      if (typeof i == "string" || typeof i == "number")
        return i;
      if (typeof i != "object")
        return "";
      if (Array.isArray(i))
        return n.apply(null, i);
      if (i.toString !== Object.prototype.toString && !i.toString.toString().includes("[native code]"))
        return i.toString();
      var a = "";
      for (var s in i)
        t.call(i, s) && i[s] && (a = o(a, s));
      return a;
    }
    function o(i, a) {
      return a ? i ? i + " " + a : i + a : i;
    }
    e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
  })();
})(Ps);
var Gd = Ps.exports;
const _e = /* @__PURE__ */ yi(Gd);
function Yd(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var As = { exports: {} }, hn = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ga;
function Xd() {
  if (ga) return hn;
  ga = 1;
  var e = z, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function a(s, l, c) {
    var u, d = {}, h = null, p = null;
    c !== void 0 && (h = "" + c), l.key !== void 0 && (h = "" + l.key), l.ref !== void 0 && (p = l.ref);
    for (u in l) r.call(l, u) && !i.hasOwnProperty(u) && (d[u] = l[u]);
    if (s && s.defaultProps) for (u in l = s.defaultProps, l) d[u] === void 0 && (d[u] = l[u]);
    return { $$typeof: t, type: s, key: h, ref: p, props: d, _owner: o.current };
  }
  return hn.Fragment = n, hn.jsx = a, hn.jsxs = a, hn;
}
As.exports = Xd();
var Zd = As.exports, Ls = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function n() {
      for (var i = "", a = 0; a < arguments.length; a++) {
        var s = arguments[a];
        s && (i = o(i, r(s)));
      }
      return i;
    }
    function r(i) {
      if (typeof i == "string" || typeof i == "number")
        return i;
      if (typeof i != "object")
        return "";
      if (Array.isArray(i))
        return n.apply(null, i);
      if (i.toString !== Object.prototype.toString && !i.toString.toString().includes("[native code]"))
        return i.toString();
      var a = "";
      for (var s in i)
        t.call(i, s) && i[s] && (a = o(a, s));
      return a;
    }
    function o(i, a) {
      return a ? i ? i + " " + a : i + a : i;
    }
    e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
  })();
})(Ls);
var Jd = Ls.exports;
const Qd = /* @__PURE__ */ Yd(Jd);
var On = /* @__PURE__ */ ((e) => (e.brand = "brand", e.regular = "regular", e.solid = "solid", e))(On || {});
const mt = ({
  className: e,
  family: t = On.solid,
  fixedWidth: n = !1,
  flip: r,
  icon: o,
  inverse: i = !1,
  pulse: a = !1,
  rotate: s,
  size: l,
  spin: c = !1,
  stack: u,
  title: d,
  variant: h,
  ...p
}) => {
  le(() => {
    console.warn(
      "This component is deprecated. Please use the individual icon imports from @fastnorth/react-cerberus/Icons."
    );
  }, []);
  const m = Qd(e, `fa-${o}`, {
    fab: t === On.brand,
    far: t === On.regular,
    fas: t === On.solid,
    "fa-fw": n,
    "fa-spin": c,
    "fa-pulse": a,
    "fa-inverse": i,
    [`fa-${l}`]: l,
    [`fa-rotate-${s}`]: s,
    [`fa-flip-${r}`]: r,
    [`fa-stack-${u}`]: u,
    [`text-${h}`]: h
  });
  return /* @__PURE__ */ Zd.jsx(
    "span",
    {
      ...p,
      className: m,
      title: d,
      "aria-hidden": d ? void 0 : !0
    }
  );
}, Is = ({
  event: e = void 0,
  locale: t = "en-US",
  showEventDate: n = !0,
  timingByLabel: r = "Timing by",
  className: o = "",
  useEventBranding: i = !1,
  children: a = null,
  eventDetailsAdditionalActions: s = null
}) => {
  var S;
  if (e == null)
    return !1;
  const { association: l, branding: c, location: u, name: d, provider: h } = e, p = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric"
  };
  u != null && u.timezone && (p.timeZone = u.timezone);
  const m = new Intl.DateTimeFormat(t, p).format(
    new Date(e.eventDate)
  ), v = c.logo && c.logo !== "" ? /* @__PURE__ */ R.jsx(
    "img",
    {
      src: c.logo,
      alt: d,
      "data-testid": "event-details-event-logo",
      className: "eventDetails__logo"
    }
  ) : null;
  let f = null, y = null;
  return h && ((h.logo ?? !1) && (f = h.logo), (h.label ?? !1) && (y = h.label)), l && (f == null && (l.logo ?? !1) && (f = l.logo), y == null && (l.title ?? !1) && (y = l.title)), /* @__PURE__ */ R.jsx(
    "div",
    {
      className: _e(o, "eventDetails", {
        "custom-primary-color": i
      }),
      "data-testid": "event-details-component",
      children: /* @__PURE__ */ R.jsxs("div", { className: "resultsContainer flex-column flex-lg-row align-items-lg-stretch", children: [
        /* @__PURE__ */ R.jsx("div", { className: "eventDetails__meta p-3", children: /* @__PURE__ */ R.jsxs("div", { className: "eventDetails__heading-container d-flex flex-wrap flex-md-nowrap flex-grow-1 justify-content-between", children: [
          /* @__PURE__ */ R.jsxs("div", { className: "d-flex mr-md-3 w-100", children: [
            v,
            /* @__PURE__ */ R.jsxs("div", { className: "eventDetails__heading", children: [
              /* @__PURE__ */ R.jsx(
                "p",
                {
                  className: _e("eventDetails__eventName h4 mb-md-1", {
                    "custom-primary-text-color": i
                  }),
                  children: e.name
                }
              ),
              /* @__PURE__ */ R.jsxs("div", { className: "metaDetails mb-2 mb-md-0 d-flex flex-column", children: [
                n && /* @__PURE__ */ R.jsxs(
                  "div",
                  {
                    className: _e("metaDetails__item", {
                      "custom-primary-text-color": i
                    }),
                    "data-testid": "event-details-date",
                    children: [
                      /* @__PURE__ */ R.jsx(mt, { icon: "calendar", className: "metaDetails__item-icon mr-2" }),
                      /* @__PURE__ */ R.jsx("p", { children: m })
                    ]
                  }
                ),
                u && ((S = u.address) == null ? void 0 : S.locality) != null && u.address.locality !== "" && /* @__PURE__ */ R.jsxs(
                  "div",
                  {
                    className: _e("metaDetails__item", {
                      "custom-primary-text-color": i
                    }),
                    children: [
                      /* @__PURE__ */ R.jsx(mt, { icon: "tag", className: "metaDetails__item-icon mr-2" }),
                      /* @__PURE__ */ R.jsxs("p", { children: [
                        u.address.locality,
                        u.address.administrativeArea != null && u.address.administrativeArea !== "" && /* @__PURE__ */ R.jsxs("span", { children: [
                          ", ",
                          u.address.administrativeArea
                        ] }),
                        u.address.countryCode != null && u.address.countryCode !== "" && /* @__PURE__ */ R.jsxs("span", { children: [
                          ", ",
                          u.address.countryCode
                        ] })
                      ] })
                    ]
                  }
                )
              ] })
            ] })
          ] }),
          /* @__PURE__ */ R.jsx("div", { className: "d-flex flex-grow-1 align-items-center mt-2 mt-lg-0", children: s })
        ] }) }),
        y && /* @__PURE__ */ R.jsx("div", { className: "eventDetails__provider pt-lg-3 px-3 pb-3 d-flex", children: /* @__PURE__ */ R.jsxs("div", { className: "eventDetails__provider-container d-flex flex-column flex-lg-row", children: [
          f && /* @__PURE__ */ R.jsx(
            "img",
            {
              src: f,
              className: "eventDetails__logo d-none d-lg-block ml-lg-1 bg-white",
              "data-testid": "event-details-provider-logo",
              alt: `${y} logo`
            }
          ),
          y && /* @__PURE__ */ R.jsxs(
            "div",
            {
              className: _e(
                "eventDetails__provider-info justify-content-between flex-lg-column"
              ),
              children: [
                /* @__PURE__ */ R.jsxs(
                  "div",
                  {
                    className: _e("d-flex flex-wrap flex-lg-column", {
                      "custom-primary-text-color": i
                    }),
                    children: [
                      /* @__PURE__ */ R.jsx("span", { className: "mr-1 text-nowrap", children: r }),
                      /* @__PURE__ */ R.jsx("p", { className: "font-weight-semi-bold mb-0 mb-lg-2", children: y })
                    ]
                  }
                ),
                a
              ]
            }
          )
        ] }) })
      ] })
    }
  );
};
Is.propTypes = {
  event: x.shape({
    branding: x.shape({
      logo: x.string
    }),
    name: x.string,
    city: x.string,
    location: x.shape({
      address: x.shape({
        adiministrativeArea: x.string,
        countryCode: x.string,
        locality: x.string
      })
    }),
    facebookUrl: x.string,
    twitter: x.string,
    eventDate: x.string,
    provider: x.shape({
      label: x.string,
      logo: x.string
    }),
    association: x.shape({
      id: x.number,
      title: x.string,
      logo: x.string
    }),
    relatedEvents: x.arrayOf(
      x.shape({
        year: x.number,
        resultsUrl: x.string
      })
    )
  }),
  locale: x.string,
  showEventDate: x.bool,
  timingByLabel: x.string,
  shareLabel: x.string,
  className: x.string,
  useEventBranding: x.bool,
  eventDetailsAdditionalActions: x.element
};
const Uo = "#51545d", wi = ({ fillColor: e = Uo }) => /* @__PURE__ */ R.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 849.43 154.58",
    "data-testid": "race-roster-logo",
    children: [
      /* @__PURE__ */ R.jsx(
        "path",
        {
          fill: e,
          className: "navbar__svg-logo-fill",
          d: "M125.31 127.15a13.85 13.85 0 0 0-2.39.57l-35.24-39a13.78 13.78 0 1 0-24.9.52l-20.21 24.29a13.79 13.79 0 0 0-8.39.4l-7.82-8.64a13.8 13.8 0 1 0-8.21 7.44l8.08 8.92a13.78 13.78 0 1 0 25-1.18L71.3 96.34a13.74 13.74 0 0 0 8.13-.17l35.24 39a13.78 13.78 0 1 0 10.64-8.02zM129.87.14a13.78 13.78 0 0 0-10 20.56l-12.26 14.83a13.76 13.76 0 0 0-9.42.19l-9.92-11a13.78 13.78 0 1 0-24.32.46l-13 15.53a13.78 13.78 0 1 0 7.67 6.18l12.89-15.36a13.76 13.76 0 0 0 9.46-.18l9.91 11a13.78 13.78 0 1 0 24.3-.5l12.39-14.9a13.78 13.78 0 1 0 2.3-26.81z"
        }
      ),
      /* @__PURE__ */ R.jsx(
        "path",
        {
          fill: Uo,
          className: "logo-text-fill",
          d: "M235.43 67c0-9.84-7-20.48-22.27-20.57h-29.17v61.32h12.88v-20h9.62l17.37 19.92h14.57v-1.9l-17.34-19.55c9.15-2.38 14.34-9.32 14.34-19.22zm-12.87.26c0 4-2.46 8.72-9.4 8.72h-16.28V58.53h16.29c6.95 0 9.41 4.71 9.41 8.73zm52.18-20.83l-27.47 61.24h14l5.11-11.24h30.05l5 11.24h14.1l-27.47-61.24h-13.32zm16.48 37.89h-19.64l9.85-22.51zm75.05 6.62a21 21 0 0 1-14.41 5.81c-14.4 0-19.62-10-19.7-19.37a20.35 20.35 0 0 1 5.53-14.51c3.47-3.5 8.37-5.36 14.17-5.36a19.54 19.54 0 0 1 13.81 5.39l.57.56 8.67-8.37-.6-.59a31.45 31.45 0 0 0-22.46-9.35c-9.49 0-17.56 3.08-23.35 8.9s-9.07 14.35-9.07 23.34c.08 14.55 8.61 31.55 32.41 31.55 9.16 0 17.19-3.14 23.22-9.09l.58-.58-8.82-8.92zm22.15 16.73h46.25V94.96h-33.46V83.15h32.27V71.04h-32.27V58.97h33.46V46.43h-46.25v61.24zm135.26-40.41c0-9.84-7-20.48-22.27-20.57h-29.18v61.32h12.88V88h9.62l17.37 19.92h14.56v-1.9l-17.35-19.54c9.12-2.38 14.37-9.32 14.37-19.22zm-12.88.27c0 4-2.46 8.72-9.4 8.72h-16.29V58.8h16.32c6.91 0 9.37 4.73 9.37 8.73zm56.17-22c-21.62 0-31.47 16.71-31.47 32.24 0 15.71 9.73 31.55 31.47 31.55 21.44 0 31.21-15.89 31.39-31.63a32.86 32.86 0 0 0-9-23.45c-5.66-5.71-13.39-8.71-22.39-8.71zm0 51.85c-13.46 0-18.52-10.06-18.76-19.47a21.23 21.23 0 0 1 5.51-15.38c3.33-3.42 7.78-5.15 13.24-5.15s9.82 1.69 13.11 5c3.64 3.71 5.67 9.32 5.57 15.41-.16 9.46-5.15 19.56-18.67 19.56zm67.95-27.53c-7.54-.9-12.56-2.38-12.56-6.68s4.42-7.1 11.53-7.1c6.29 0 11.61 3.22 13.43 6.24l.39.66 10.34-5.31-.35-.72c-3.95-8-12.29-12.29-24.15-12.29s-23.89 5.75-23.89 18.19c0 14.09 12.2 17.45 24.14 18.86 8.91 1 13.06 3.49 13.06 8 0 7.53-9.87 8.12-12.89 8.12-7.77 0-13.76-3.34-16-8.94l-.34-.84-10.83 5.61.28.69c4.14 10.2 12.89 15.15 26.73 15.15 12.5 0 25.85-5.2 25.85-19.81s-11.89-18.24-24.74-19.83zm34.78-11.31h18.9v49.38h12.87V58.54h18.91V46.69H669.7v11.85zm63.83 49.38h46.25v-12.7h-33.46V83.4h32.27V71.29h-32.27V59.22h33.46V46.69h-46.25v61.23zm98.56-21.44c9.15-2.38 14.34-9.32 14.34-19.22s-7-20.48-22.27-20.57h-29.17v61.32h12.88V88h9.62l17.13 19.64.24.28h14.57v-1.9zm1.49-19c0 4-2.46 8.72-9.4 8.72h-16.3V58.8h16.29c6.94 0 9.41 4.73 9.41 8.73z"
        }
      )
    ]
  }
);
wi.propTypes = {
  fillColor: x.string
};
wi.defaultProps = {
  fillColor: Uo
};
function ef(e) {
  le(() => {
    const t = ({ key: r }) => {
      r === "Escape" && e();
    }, n = () => {
      e();
    };
    return document.addEventListener("keydown", t), document.addEventListener("click", n), () => {
      document.removeEventListener("keydown", t), document.removeEventListener("click", n);
    };
  }, [e]);
}
const Gr = ({ locale: e, locales: t, changeLocaleLabel: n, className: r = "" }) => {
  const [o, i] = Ue(!1), a = t.find((s) => s.code === e);
  return ef(() => i(!1)), t.length < 2 ? null : /* @__PURE__ */ R.jsxs(
    "div",
    {
      className: _e("locale_selector", "locale_selector__dropdown", r, {
        locale_selector__show: o
      }),
      "data-testid": "locale-selector",
      children: [
        /* @__PURE__ */ R.jsxs(
          "button",
          {
            type: "button",
            className: "locale_selector__button",
            onClick: (s) => {
              i(!o), s.nativeEvent.type === "click" && s.stopPropagation();
            },
            "data-testid": "locale-selector-button",
            "aria-haspopup": "true",
            "aria-expanded": o ? "true" : "false",
            children: [
              a && /* @__PURE__ */ R.jsx("span", { className: "locale_selector__code", children: a.short }),
              n,
              /* @__PURE__ */ R.jsx("span", { className: "locale_selector__caret" })
            ]
          }
        ),
        o && /* @__PURE__ */ R.jsx("ul", { className: "locale_selector__menu", "data-testid": "locale-switcher-menu", children: t.map((s, l) => /* @__PURE__ */ R.jsx("li", { children: /* @__PURE__ */ R.jsxs("a", { href: s.url, className: "locale_selector__item", children: [
          s.short && /* @__PURE__ */ R.jsx("span", { className: "locale_selector__code", children: s.short }),
          s.label
        ] }, Math.random()) })) })
      ]
    }
  );
};
Gr.propTypes = {
  changeLocaleLabel: x.string,
  locale: x.string,
  locales: x.array,
  className: x.string
};
const tf = ({ show: e, wrapper: t, children: n }) => e ? t(n) : n, Ds = ({
  changeLocaleLabel: e = "Change language",
  children: t = null,
  className: n = "",
  color: r,
  eventDetailsClassName: o = "",
  eventDetailsLabel: i = "Event details",
  eventUrl: a,
  isEventLive: s = !1,
  locale: l = "",
  localeSelectorClassName: c = "",
  locales: u = [],
  logoUrl: d,
  logoAriaLabel: h = "All results",
  resultsUrl: p,
  resultsLinkLabel: m = "Results"
}) => {
  let v = null, f = null, y = /* @__PURE__ */ R.jsx(
    Gr,
    {
      className: c,
      locales: u,
      locale: l,
      changeLocaleLabel: e
    }
  );
  return a && s && (v = /* @__PURE__ */ R.jsx(
    "a",
    {
      href: a,
      className: _e(o, "btn_event_details btn btn-secondary mr-2"),
      children: i
    }
  )), p && (f = /* @__PURE__ */ R.jsx("a", { href: p, className: "btn_results btn btn-secondary", children: m })), /* @__PURE__ */ R.jsx("div", { className: _e("top_navigation", n), "data-testid": "page-header-component", children: /* @__PURE__ */ R.jsxs("header", { className: "resultsContainer page-header__container", children: [
    /* @__PURE__ */ R.jsx("div", { className: "page-header__logo", children: /* @__PURE__ */ R.jsx(
      tf,
      {
        show: d != null,
        wrapper: (S) => /* @__PURE__ */ R.jsx("a", { href: d, "aria-label": h, children: S }),
        children: /* @__PURE__ */ R.jsx(wi, { fillColor: r })
      }
    ) }),
    (v || f) && /* @__PURE__ */ R.jsxs("div", { className: "ml-4 d-none d-sm-block", children: [
      v,
      f
    ] }),
    /* @__PURE__ */ R.jsxs("div", { className: "page-header__actions", children: [
      y,
      t
    ] })
  ] }) });
};
Ds.propTypes = {
  color: x.string,
  eventUrl: x.string,
  changeLocaleLabel: x.string,
  eventDetailsLabel: x.string,
  locale: x.string,
  locales: x.array,
  children: x.node,
  className: x.string,
  localeSelectorClassName: x.string,
  eventDetailsClassName: x.string,
  isEventLive: x.bool
};
const Fs = ({
  changeLocaleLabel: e = "Change language",
  children: t = null,
  className: n = "",
  event: r,
  eventDetailsClassName: o = "",
  eventDetailsLabel: i = "Event details",
  locale: a = "en-US",
  localeSelectorClassName: s = "",
  locales: l = [],
  logoUrl: c,
  pageTitle: u = "Results",
  raceTitle: d = null,
  relatedResultsClassName: h = "",
  relatedResultsItemLabel: p = "%year% results",
  relatedResultsLabel: m = "Related results",
  resultsLinkLabel: v = "Results",
  resultsUrl: f,
  shareLabel: y = "Share",
  showDetailsClassName: S = "",
  showDetailsLabel: C = "Show details",
  showEventDate: T = !0,
  timingByLabel: A = "Timing by"
}) => /* @__PURE__ */ R.jsxs(z.Fragment, { children: [
  /* @__PURE__ */ R.jsx(
    Ds,
    {
      changeLocaleLabel: e,
      className: n,
      color: r && r.branding ? r.branding.secondaryColor : null,
      eventDetailsClassName: o,
      eventDetailsLabel: i,
      eventUrl: r && r.eventUrl ? r.eventUrl : "",
      isEventLive: r && r.status === "live",
      locale: a,
      localeSelectorClassName: s,
      locales: l,
      logoUrl: c,
      resultsLinkLabel: v,
      resultsUrl: f,
      children: t
    }
  ),
  /* @__PURE__ */ R.jsx(
    Gr,
    {
      className: "locale_selector__mobile",
      locales: l,
      locale: a,
      changeLocaleLabel: e
    }
  ),
  r && r.name && /* @__PURE__ */ R.jsx(
    Is,
    {
      event: r,
      locale: a,
      showEventDate: T,
      timingByLabel: A,
      shareLabel: y,
      showDetailsLabel: C,
      raceTitle: d,
      pageTitle: u,
      className: S,
      relatedResultsClassName: h,
      relatedResultsLabel: m,
      relatedResultsItemLabel: p
    }
  )
] });
Fs.propTypes = {
  event: x.object,
  changeLocaleLabel: x.string,
  eventDetailsLabel: x.string,
  locale: x.string,
  locales: x.array,
  showEventDate: x.bool,
  children: x.node,
  className: x.string,
  localeSelectorClassName: x.string,
  eventDetailsClassName: x.string,
  timingByLabel: x.string,
  shareLabel: x.string,
  showDetailsLabel: x.string,
  pageTitle: x.string,
  raceTitle: x.string,
  showDetailsClassName: x.string,
  relatedResultsClassName: x.string,
  relatedResultsLabel: x.string,
  relatedResultsItemLabel: x.string
};
function nf(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Ms = { exports: {} }, mn = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ba;
function rf() {
  if (ba) return mn;
  ba = 1;
  var e = z, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function a(s, l, c) {
    var u, d = {}, h = null, p = null;
    c !== void 0 && (h = "" + c), l.key !== void 0 && (h = "" + l.key), l.ref !== void 0 && (p = l.ref);
    for (u in l) r.call(l, u) && !i.hasOwnProperty(u) && (d[u] = l[u]);
    if (s && s.defaultProps) for (u in l = s.defaultProps, l) d[u] === void 0 && (d[u] = l[u]);
    return { $$typeof: t, type: s, key: h, ref: p, props: d, _owner: o.current };
  }
  return mn.Fragment = n, mn.jsx = a, mn.jsxs = a, mn;
}
Ms.exports = rf();
var et = Ms.exports, $s = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function n() {
      for (var i = "", a = 0; a < arguments.length; a++) {
        var s = arguments[a];
        s && (i = o(i, r(s)));
      }
      return i;
    }
    function r(i) {
      if (typeof i == "string" || typeof i == "number")
        return i;
      if (typeof i != "object")
        return "";
      if (Array.isArray(i))
        return n.apply(null, i);
      if (i.toString !== Object.prototype.toString && !i.toString.toString().includes("[native code]"))
        return i.toString();
      var a = "";
      for (var s in i)
        t.call(i, s) && i[s] && (a = o(a, s));
      return a;
    }
    function o(i, a) {
      return a ? i ? i + " " + a : i + a : i;
    }
    e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
  })();
})($s);
var of = $s.exports;
const Nr = /* @__PURE__ */ nf(of);
var Bs = /* @__PURE__ */ ((e) => (e.primary = "primary", e.secondary = "secondary", e.success = "success", e.danger = "danger", e.warning = "warning", e.info = "info", e.light = "light", e.dark = "dark", e.link = "link", e.unstyled = "unstyled", e.text = "text", e))(Bs || {}), xr = /* @__PURE__ */ ((e) => (e.xsmall = "xs", e.small = "sm", e.medium = "md", e.large = "lg", e.xlarge = "xl", e))(xr || {}), Nn = /* @__PURE__ */ ((e) => (e.brand = "brand", e.regular = "regular", e.solid = "solid", e))(Nn || {});
const ya = ({
  className: e,
  family: t = Nn.solid,
  fixedWidth: n = !1,
  flip: r,
  icon: o,
  inverse: i = !1,
  pulse: a = !1,
  rotate: s,
  size: l,
  spin: c = !1,
  stack: u,
  title: d,
  variant: h,
  ...p
}) => {
  le(() => {
    console.warn(
      "This component is deprecated. Please use the individual icon imports from @fastnorth/react-cerberus/Icons."
    );
  }, []);
  const m = Nr(e, `fa-${o}`, {
    fab: t === Nn.brand,
    far: t === Nn.regular,
    fas: t === Nn.solid,
    "fa-fw": n,
    "fa-spin": c,
    "fa-pulse": a,
    "fa-inverse": i,
    [`fa-${l}`]: l,
    [`fa-rotate-${s}`]: s,
    [`fa-flip-${r}`]: r,
    [`fa-stack-${u}`]: u,
    [`text-${h}`]: h
  });
  return /* @__PURE__ */ et.jsx(
    "span",
    {
      ...p,
      className: m,
      title: d,
      "aria-hidden": d ? void 0 : !0
    }
  );
}, af = "_container_1g94w_1", sf = "_stack_1g94w_14", lf = "_circle_1g94w_24", cf = "_svg_1g94w_40", uf = "_spin_1g94w_47", vn = {
  container: af,
  stack: sf,
  circle: lf,
  svg: cf,
  spin: uf
}, df = ({ size: e = xr.small, variant: t, stack: n = !1, spin: r = !0, title: o, ...i }, a) => {
  le(() => {
    if (!Object.values(xr).includes(e))
      throw new Error(
        `You must provide a valid size from the SIZES enum: ${Object.keys(xr).join(", ")}`
      );
  }, [e]);
  const s = Nr(i.className, vn.container, n && vn.stack, {
    [`text-${t}`]: !n && t !== "secondary",
    "text-gray-900": t === "secondary",
    [vn.spin]: r
  }), l = Nr(vn.circle, {
    [`bg-${t}`]: n && t !== "secondary",
    "bg-gray-100": n && t === "secondary"
  }), c = { "--size": `var(--icon-size-${e})` };
  return /* @__PURE__ */ et.jsxs(
    "div",
    {
      className: s,
      style: c,
      title: o,
      "aria-hidden": o ? void 0 : !0,
      children: [
        n && /* @__PURE__ */ et.jsx("span", { className: l, "aria-hidden": "true", "data-circle": !0 }),
        /* @__PURE__ */ et.jsx(
          "svg",
          {
            viewBox: "0 0 512 512",
            xmlns: "http://www.w3.org/2000/svg",
            ...i,
            className: vn.svg,
            ref: a,
            children: /* @__PURE__ */ et.jsx(
              "path",
              {
                fill: "currentColor",
                d: "m304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm-368 48c0-26.51-21.49-48-48-48s-48 21.49-48 48 21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zm-294.156-294.156c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"
              }
            )
          }
        )
      ]
    }
  );
}, ff = We(df), pf = vi(ff), Wo = z.forwardRef(
  ({
    tag: e = "button",
    block: t = !1,
    btn: n = !0,
    busy: r = !1,
    children: o = null,
    className: i = null,
    disabled: a = !1,
    iconLeft: s = null,
    iconRight: l = null,
    outline: c = !1,
    size: u = null,
    text: d = null,
    type: h = e === "button" ? "button" : null,
    variant: p = Bs.primary,
    href: m,
    ...v
  }, f) => {
    const y = Nr(i, {
      btn: n,
      [`btn-outline-${p}`]: p && c,
      [`btn-${p}`]: n && p && !c,
      [`btn-${u}`]: u,
      "btn-block": t,
      disabled: a
    });
    return /* @__PURE__ */ et.jsx(et.Fragment, { children: z.createElement(
      e,
      {
        ...v,
        disabled: e === "button" && (a || r),
        href: e === "a" ? m : void 0,
        ref: f,
        type: h,
        className: y
      },
      r && /* @__PURE__ */ et.jsx(pf, { spin: !0, className: "mr-2" }),
      typeof s == "string" ? /* @__PURE__ */ et.jsx(ya, { icon: s, className: "mr-2", "data-testid": "button-icon-left" }) : s,
      d,
      typeof l == "string" ? /* @__PURE__ */ et.jsx(ya, { icon: l, className: "ml-2", "data-testid": "button-icon-right" }) : l,
      o
    ) });
  }
);
function hf(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var zs = { exports: {} }, gn = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var wa;
function mf() {
  if (wa) return gn;
  wa = 1;
  var e = z, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function a(s, l, c) {
    var u, d = {}, h = null, p = null;
    c !== void 0 && (h = "" + c), l.key !== void 0 && (h = "" + l.key), l.ref !== void 0 && (p = l.ref);
    for (u in l) r.call(l, u) && !i.hasOwnProperty(u) && (d[u] = l[u]);
    if (s && s.defaultProps) for (u in l = s.defaultProps, l) d[u] === void 0 && (d[u] = l[u]);
    return { $$typeof: t, type: s, key: h, ref: p, props: d, _owner: o.current };
  }
  return gn.Fragment = n, gn.jsx = a, gn.jsxs = a, gn;
}
zs.exports = mf();
var k = zs.exports, Us = { exports: {} }, te = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var xa;
function vf() {
  if (xa) return te;
  xa = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), a = Symbol.for("react.context"), s = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), p = Symbol.for("react.offscreen"), m;
  m = Symbol.for("react.module.reference");
  function v(f) {
    if (typeof f == "object" && f !== null) {
      var y = f.$$typeof;
      switch (y) {
        case e:
          switch (f = f.type, f) {
            case n:
            case o:
            case r:
            case c:
            case u:
              return f;
            default:
              switch (f = f && f.$$typeof, f) {
                case s:
                case a:
                case l:
                case h:
                case d:
                case i:
                  return f;
                default:
                  return y;
              }
          }
        case t:
          return y;
      }
    }
  }
  return te.ContextConsumer = a, te.ContextProvider = i, te.Element = e, te.ForwardRef = l, te.Fragment = n, te.Lazy = h, te.Memo = d, te.Portal = t, te.Profiler = o, te.StrictMode = r, te.Suspense = c, te.SuspenseList = u, te.isAsyncMode = function() {
    return !1;
  }, te.isConcurrentMode = function() {
    return !1;
  }, te.isContextConsumer = function(f) {
    return v(f) === a;
  }, te.isContextProvider = function(f) {
    return v(f) === i;
  }, te.isElement = function(f) {
    return typeof f == "object" && f !== null && f.$$typeof === e;
  }, te.isForwardRef = function(f) {
    return v(f) === l;
  }, te.isFragment = function(f) {
    return v(f) === n;
  }, te.isLazy = function(f) {
    return v(f) === h;
  }, te.isMemo = function(f) {
    return v(f) === d;
  }, te.isPortal = function(f) {
    return v(f) === t;
  }, te.isProfiler = function(f) {
    return v(f) === o;
  }, te.isStrictMode = function(f) {
    return v(f) === r;
  }, te.isSuspense = function(f) {
    return v(f) === c;
  }, te.isSuspenseList = function(f) {
    return v(f) === u;
  }, te.isValidElementType = function(f) {
    return typeof f == "string" || typeof f == "function" || f === n || f === o || f === r || f === c || f === u || f === p || typeof f == "object" && f !== null && (f.$$typeof === h || f.$$typeof === d || f.$$typeof === i || f.$$typeof === a || f.$$typeof === l || f.$$typeof === m || f.getModuleId !== void 0);
  }, te.typeOf = v, te;
}
Us.exports = vf();
var Ws = Us.exports;
function Q(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(r) {
    if (e == null || e(r), n === !1 || !r.defaultPrevented)
      return t == null ? void 0 : t(r);
  };
}
function gf(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function Yr(...e) {
  return (t) => e.forEach((n) => gf(n, t));
}
function je(...e) {
  return b.useCallback(Yr(...e), e);
}
function Hs(e, t = []) {
  let n = [];
  function r(i, a) {
    const s = b.createContext(a), l = n.length;
    n = [...n, a];
    const c = (d) => {
      var h;
      const { scope: p, children: m, ...v } = d, f = ((h = p == null ? void 0 : p[e]) == null ? void 0 : h[l]) || s, y = b.useMemo(() => v, Object.values(v));
      return /* @__PURE__ */ k.jsx(f.Provider, { value: y, children: m });
    };
    c.displayName = i + "Provider";
    function u(d, h) {
      var p;
      const m = ((p = h == null ? void 0 : h[e]) == null ? void 0 : p[l]) || s, v = b.useContext(m);
      if (v) return v;
      if (a !== void 0) return a;
      throw new Error(`\`${d}\` must be used within \`${i}\``);
    }
    return [c, u];
  }
  const o = () => {
    const i = n.map((a) => b.createContext(a));
    return function(a) {
      const s = (a == null ? void 0 : a[e]) || i;
      return b.useMemo(
        () => ({ [`__scope${e}`]: { ...a, [e]: s } }),
        [a, s]
      );
    };
  };
  return o.scopeName = e, [r, bf(o, ...t)];
}
function bf(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(o) {
      const i = r.reduce((a, { useScope: s, scopeName: l }) => {
        const c = s(o)[`__scope${l}`];
        return { ...a, ...c };
      }, {});
      return b.useMemo(() => ({ [`__scope${t.scopeName}`]: i }), [i]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function Ge(e) {
  const t = b.useRef(e);
  return b.useEffect(() => {
    t.current = e;
  }), b.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
function Ks({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  }
}) {
  const [r, o] = yf({ defaultProp: t, onChange: n }), i = e !== void 0, a = i ? e : r, s = Ge(n), l = b.useCallback(
    (c) => {
      if (i) {
        const u = typeof c == "function" ? c(e) : c;
        u !== e && s(u);
      } else
        o(c);
    },
    [i, e, o, s]
  );
  return [a, l];
}
function yf({
  defaultProp: e,
  onChange: t
}) {
  const n = b.useState(e), [r] = n, o = b.useRef(r), i = Ge(t);
  return b.useEffect(() => {
    o.current !== r && (i(r), o.current = r);
  }, [r, o, i]), n;
}
var Ln = b.forwardRef((e, t) => {
  const { children: n, ...r } = e, o = b.Children.toArray(n), i = o.find(xf);
  if (i) {
    const a = i.props.children, s = o.map((l) => l === i ? b.Children.count(a) > 1 ? b.Children.only(null) : b.isValidElement(a) ? a.props.children : null : l);
    return /* @__PURE__ */ k.jsx(Ho, { ...r, ref: t, children: b.isValidElement(a) ? b.cloneElement(a, void 0, s) : null });
  }
  return /* @__PURE__ */ k.jsx(Ho, { ...r, ref: t, children: n });
});
Ln.displayName = "Slot";
var Ho = b.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (b.isValidElement(n)) {
    const o = Sf(n);
    return b.cloneElement(n, {
      ...Ef(r, n.props),
      // @ts-ignore
      ref: t ? Yr(t, o) : o
    });
  }
  return b.Children.count(n) > 1 ? b.Children.only(null) : null;
});
Ho.displayName = "SlotClone";
var wf = ({ children: e }) => /* @__PURE__ */ k.jsx(k.Fragment, { children: e });
function xf(e) {
  return b.isValidElement(e) && e.type === wf;
}
function Ef(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...a) => {
      i(...a), o(...a);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function Sf(e) {
  var t, n;
  let r = (t = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : t.get, o = r && "isReactWarning" in r && r.isReactWarning;
  return o ? e.ref : (r = (n = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : n.get, o = r && "isReactWarning" in r && r.isReactWarning, o ? e.props.ref : e.props.ref || e.ref);
}
var _f = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Oe = _f.reduce((e, t) => {
  const n = b.forwardRef((r, o) => {
    const { asChild: i, ...a } = r, s = i ? Ln : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ k.jsx(s, { ...a, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function qs(e, t) {
  e && Os.flushSync(() => e.dispatchEvent(t));
}
function Rf(e, t = []) {
  let n = [];
  function r(i, a) {
    const s = b.createContext(a), l = n.length;
    n = [...n, a];
    function c(d) {
      const { scope: h, children: p, ...m } = d, v = (h == null ? void 0 : h[e][l]) || s, f = b.useMemo(() => m, Object.values(m));
      return /* @__PURE__ */ k.jsx(v.Provider, { value: f, children: p });
    }
    function u(d, h) {
      const p = (h == null ? void 0 : h[e][l]) || s, m = b.useContext(p);
      if (m) return m;
      if (a !== void 0) return a;
      throw new Error(`\`${d}\` must be used within \`${i}\``);
    }
    return c.displayName = i + "Provider", [c, u];
  }
  const o = () => {
    const i = n.map((a) => b.createContext(a));
    return function(a) {
      const s = (a == null ? void 0 : a[e]) || i;
      return b.useMemo(
        () => ({ [`__scope${e}`]: { ...a, [e]: s } }),
        [a, s]
      );
    };
  };
  return o.scopeName = e, [r, Of(o, ...t)];
}
function Of(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(o) {
      const i = r.reduce((a, { useScope: s, scopeName: l }) => {
        const c = s(o)[`__scope${l}`];
        return { ...a, ...c };
      }, {});
      return b.useMemo(() => ({ [`__scope${t.scopeName}`]: i }), [i]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function Vs(e) {
  const t = e + "CollectionProvider", [n, r] = Rf(t), [o, i] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), a = (p) => {
    const { scope: m, children: v } = p, f = z.useRef(null), y = z.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ k.jsx(o, { scope: m, itemMap: y, collectionRef: f, children: v });
  };
  a.displayName = t;
  const s = e + "CollectionSlot", l = z.forwardRef(
    (p, m) => {
      const { scope: v, children: f } = p, y = i(s, v), S = je(m, y.collectionRef);
      return /* @__PURE__ */ k.jsx(Ln, { ref: S, children: f });
    }
  );
  l.displayName = s;
  const c = e + "CollectionItemSlot", u = "data-radix-collection-item", d = z.forwardRef(
    (p, m) => {
      const { scope: v, children: f, ...y } = p, S = z.useRef(null), C = je(m, S), T = i(c, v);
      return z.useEffect(() => (T.itemMap.set(S, { ref: S, ...y }), () => void T.itemMap.delete(S))), /* @__PURE__ */ k.jsx(Ln, { [u]: "", ref: C, children: f });
    }
  );
  d.displayName = c;
  function h(p) {
    const m = i(e + "CollectionConsumer", p);
    return z.useCallback(() => {
      const v = m.collectionRef.current;
      if (!v) return [];
      const f = Array.from(v.querySelectorAll(`[${u}]`));
      return Array.from(m.itemMap.values()).sort(
        (y, S) => f.indexOf(y.ref.current) - f.indexOf(S.ref.current)
      );
    }, [m.collectionRef, m.itemMap]);
  }
  return [
    { Provider: a, Slot: l, ItemSlot: d },
    h,
    r
  ];
}
var Nf = b.createContext(void 0);
function Gs(e) {
  const t = b.useContext(Nf);
  return e || t || "ltr";
}
function Cf(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Ge(e);
  b.useEffect(() => {
    const r = (o) => {
      o.key === "Escape" && n(o);
    };
    return t.addEventListener("keydown", r, { capture: !0 }), () => t.removeEventListener("keydown", r, { capture: !0 });
  }, [n, t]);
}
var Tf = "DismissableLayer", Ko = "dismissableLayer.update", jf = "dismissableLayer.pointerDownOutside", kf = "dismissableLayer.focusOutside", Ea, Ys = b.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Xs = b.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: o,
      onFocusOutside: i,
      onInteractOutside: a,
      onDismiss: s,
      ...l
    } = e, c = b.useContext(Ys), [u, d] = b.useState(null), h = (u == null ? void 0 : u.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, p] = b.useState({}), m = je(t, (L) => d(L)), v = Array.from(c.layers), [f] = [...c.layersWithOutsidePointerEventsDisabled].slice(-1), y = v.indexOf(f), S = u ? v.indexOf(u) : -1, C = c.layersWithOutsidePointerEventsDisabled.size > 0, T = S >= y, A = Lf((L) => {
      const H = L.target, G = [...c.branches].some((W) => W.contains(H));
      !T || G || (o == null || o(L), a == null || a(L), L.defaultPrevented || s == null || s());
    }, h), U = If((L) => {
      const H = L.target;
      [...c.branches].some((G) => G.contains(H)) || (i == null || i(L), a == null || a(L), L.defaultPrevented || s == null || s());
    }, h);
    return Cf((L) => {
      S === c.layers.size - 1 && (r == null || r(L), !L.defaultPrevented && s && (L.preventDefault(), s()));
    }, h), b.useEffect(() => {
      if (u)
        return n && (c.layersWithOutsidePointerEventsDisabled.size === 0 && (Ea = h.body.style.pointerEvents, h.body.style.pointerEvents = "none"), c.layersWithOutsidePointerEventsDisabled.add(u)), c.layers.add(u), Sa(), () => {
          n && c.layersWithOutsidePointerEventsDisabled.size === 1 && (h.body.style.pointerEvents = Ea);
        };
    }, [u, h, n, c]), b.useEffect(() => () => {
      u && (c.layers.delete(u), c.layersWithOutsidePointerEventsDisabled.delete(u), Sa());
    }, [u, c]), b.useEffect(() => {
      const L = () => p({});
      return document.addEventListener(Ko, L), () => document.removeEventListener(Ko, L);
    }, []), /* @__PURE__ */ k.jsx(
      Oe.div,
      {
        ...l,
        ref: m,
        style: {
          pointerEvents: C ? T ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: Q(e.onFocusCapture, U.onFocusCapture),
        onBlurCapture: Q(e.onBlurCapture, U.onBlurCapture),
        onPointerDownCapture: Q(
          e.onPointerDownCapture,
          A.onPointerDownCapture
        )
      }
    );
  }
);
Xs.displayName = Tf;
var Pf = "DismissableLayerBranch", Af = b.forwardRef((e, t) => {
  const n = b.useContext(Ys), r = b.useRef(null), o = je(t, r);
  return b.useEffect(() => {
    const i = r.current;
    if (i)
      return n.branches.add(i), () => {
        n.branches.delete(i);
      };
  }, [n.branches]), /* @__PURE__ */ k.jsx(Oe.div, { ...e, ref: o });
});
Af.displayName = Pf;
function Lf(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Ge(e), r = b.useRef(!1), o = b.useRef(() => {
  });
  return b.useEffect(() => {
    const i = (s) => {
      if (s.target && !r.current) {
        let l = function() {
          Zs(
            jf,
            n,
            c,
            { discrete: !0 }
          );
        };
        const c = { originalEvent: s };
        s.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = l, t.addEventListener("click", o.current, { once: !0 })) : l();
      } else
        t.removeEventListener("click", o.current);
      r.current = !1;
    }, a = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(a), t.removeEventListener("pointerdown", i), t.removeEventListener("click", o.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function If(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Ge(e), r = b.useRef(!1);
  return b.useEffect(() => {
    const o = (i) => {
      i.target && !r.current && Zs(kf, n, { originalEvent: i }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function Sa() {
  const e = new CustomEvent(Ko);
  document.dispatchEvent(e);
}
function Zs(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, i = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), r ? qs(o, i) : o.dispatchEvent(i);
}
var Eo = 0;
function Df() {
  b.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? _a()), document.body.insertAdjacentElement("beforeend", e[1] ?? _a()), Eo++, () => {
      Eo === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), Eo--;
    };
  }, []);
}
function _a() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var So = "focusScope.autoFocusOnMount", _o = "focusScope.autoFocusOnUnmount", Ra = { bubbles: !1, cancelable: !0 }, Ff = "FocusScope", Js = b.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: o,
    onUnmountAutoFocus: i,
    ...a
  } = e, [s, l] = b.useState(null), c = Ge(o), u = Ge(i), d = b.useRef(null), h = je(t, (v) => l(v)), p = b.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  b.useEffect(() => {
    if (r) {
      let v = function(C) {
        if (p.paused || !s) return;
        const T = C.target;
        s.contains(T) ? d.current = T : ht(d.current, { select: !0 });
      }, f = function(C) {
        if (p.paused || !s) return;
        const T = C.relatedTarget;
        T !== null && (s.contains(T) || ht(d.current, { select: !0 }));
      }, y = function(C) {
        if (document.activeElement === document.body)
          for (const T of C)
            T.removedNodes.length > 0 && ht(s);
      };
      document.addEventListener("focusin", v), document.addEventListener("focusout", f);
      const S = new MutationObserver(y);
      return s && S.observe(s, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", v), document.removeEventListener("focusout", f), S.disconnect();
      };
    }
  }, [r, s, p.paused]), b.useEffect(() => {
    if (s) {
      Na.add(p);
      const v = document.activeElement;
      if (!s.contains(v)) {
        const f = new CustomEvent(So, Ra);
        s.addEventListener(So, c), s.dispatchEvent(f), f.defaultPrevented || (Mf(Wf(Qs(s)), { select: !0 }), document.activeElement === v && ht(s));
      }
      return () => {
        s.removeEventListener(So, c), setTimeout(() => {
          const f = new CustomEvent(_o, Ra);
          s.addEventListener(_o, u), s.dispatchEvent(f), f.defaultPrevented || ht(v ?? document.body, { select: !0 }), s.removeEventListener(_o, u), Na.remove(p);
        }, 0);
      };
    }
  }, [s, c, u, p]);
  const m = b.useCallback(
    (v) => {
      if (!n && !r || p.paused) return;
      const f = v.key === "Tab" && !v.altKey && !v.ctrlKey && !v.metaKey, y = document.activeElement;
      if (f && y) {
        const S = v.currentTarget, [C, T] = $f(S);
        C && T ? !v.shiftKey && y === T ? (v.preventDefault(), n && ht(C, { select: !0 })) : v.shiftKey && y === C && (v.preventDefault(), n && ht(T, { select: !0 })) : y === S && v.preventDefault();
      }
    },
    [n, r, p.paused]
  );
  return /* @__PURE__ */ k.jsx(Oe.div, { tabIndex: -1, ...a, ref: h, onKeyDown: m });
});
Js.displayName = Ff;
function Mf(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (ht(r, { select: t }), document.activeElement !== n) return;
}
function $f(e) {
  const t = Qs(e), n = Oa(t, e), r = Oa(t.reverse(), e);
  return [n, r];
}
function Qs(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function Oa(e, t) {
  for (const n of e)
    if (!Bf(n, { upTo: t })) return n;
}
function Bf(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function zf(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function ht(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && zf(e) && t && e.select();
  }
}
var Na = Uf();
function Uf() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = Ca(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = Ca(e, t), (n = e[0]) == null || n.resume();
    }
  };
}
function Ca(e, t) {
  const n = [...e], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function Wf(e) {
  return e.filter((t) => t.tagName !== "A");
}
var It = globalThis != null && globalThis.document ? b.useLayoutEffect : () => {
}, Hf = b.useId || (() => {
}), Kf = 0;
function qo(e) {
  const [t, n] = b.useState(Hf());
  return It(() => {
    n((r) => r ?? String(Kf++));
  }, [e]), t ? `radix-${t}` : "";
}
const qf = ["top", "right", "bottom", "left"], gt = Math.min, Ae = Math.max, Cr = Math.round, ur = Math.floor, bt = (e) => ({
  x: e,
  y: e
}), Vf = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Gf = {
  start: "end",
  end: "start"
};
function Vo(e, t, n) {
  return Ae(e, gt(t, n));
}
function lt(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function ct(e) {
  return e.split("-")[0];
}
function on(e) {
  return e.split("-")[1];
}
function xi(e) {
  return e === "x" ? "y" : "x";
}
function Ei(e) {
  return e === "y" ? "height" : "width";
}
function yt(e) {
  return ["top", "bottom"].includes(ct(e)) ? "y" : "x";
}
function Si(e) {
  return xi(yt(e));
}
function Yf(e, t, n) {
  n === void 0 && (n = !1);
  const r = on(e), o = Si(e), i = Ei(o);
  let a = o === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (a = Tr(a)), [a, Tr(a)];
}
function Xf(e) {
  const t = Tr(e);
  return [Go(e), t, Go(t)];
}
function Go(e) {
  return e.replace(/start|end/g, (t) => Gf[t]);
}
function Zf(e, t, n) {
  const r = ["left", "right"], o = ["right", "left"], i = ["top", "bottom"], a = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? o : r : t ? r : o;
    case "left":
    case "right":
      return t ? i : a;
    default:
      return [];
  }
}
function Jf(e, t, n, r) {
  const o = on(e);
  let i = Zf(ct(e), n === "start", r);
  return o && (i = i.map((a) => a + "-" + o), t && (i = i.concat(i.map(Go)))), i;
}
function Tr(e) {
  return e.replace(/left|right|bottom|top/g, (t) => Vf[t]);
}
function Qf(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function el(e) {
  return typeof e != "number" ? Qf(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function jr(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: o
  } = e;
  return {
    width: r,
    height: o,
    top: n,
    left: t,
    right: t + r,
    bottom: n + o,
    x: t,
    y: n
  };
}
function Ta(e, t, n) {
  let {
    reference: r,
    floating: o
  } = e;
  const i = yt(t), a = Si(t), s = Ei(a), l = ct(t), c = i === "y", u = r.x + r.width / 2 - o.width / 2, d = r.y + r.height / 2 - o.height / 2, h = r[s] / 2 - o[s] / 2;
  let p;
  switch (l) {
    case "top":
      p = {
        x: u,
        y: r.y - o.height
      };
      break;
    case "bottom":
      p = {
        x: u,
        y: r.y + r.height
      };
      break;
    case "right":
      p = {
        x: r.x + r.width,
        y: d
      };
      break;
    case "left":
      p = {
        x: r.x - o.width,
        y: d
      };
      break;
    default:
      p = {
        x: r.x,
        y: r.y
      };
  }
  switch (on(t)) {
    case "start":
      p[a] -= h * (n && c ? -1 : 1);
      break;
    case "end":
      p[a] += h * (n && c ? -1 : 1);
      break;
  }
  return p;
}
const ep = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: o = "absolute",
    middleware: i = [],
    platform: a
  } = n, s = i.filter(Boolean), l = await (a.isRTL == null ? void 0 : a.isRTL(t));
  let c = await a.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: u,
    y: d
  } = Ta(c, r, l), h = r, p = {}, m = 0;
  for (let v = 0; v < s.length; v++) {
    const {
      name: f,
      fn: y
    } = s[v], {
      x: S,
      y: C,
      data: T,
      reset: A
    } = await y({
      x: u,
      y: d,
      initialPlacement: r,
      placement: h,
      strategy: o,
      middlewareData: p,
      rects: c,
      platform: a,
      elements: {
        reference: e,
        floating: t
      }
    });
    u = S ?? u, d = C ?? d, p = {
      ...p,
      [f]: {
        ...p[f],
        ...T
      }
    }, A && m <= 50 && (m++, typeof A == "object" && (A.placement && (h = A.placement), A.rects && (c = A.rects === !0 ? await a.getElementRects({
      reference: e,
      floating: t,
      strategy: o
    }) : A.rects), {
      x: u,
      y: d
    } = Ta(c, h, l)), v = -1);
  }
  return {
    x: u,
    y: d,
    placement: h,
    strategy: o,
    middlewareData: p
  };
};
async function In(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: o,
    platform: i,
    rects: a,
    elements: s,
    strategy: l
  } = e, {
    boundary: c = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: d = "floating",
    altBoundary: h = !1,
    padding: p = 0
  } = lt(t, e), m = el(p), v = s[h ? d === "floating" ? "reference" : "floating" : d], f = jr(await i.getClippingRect({
    element: (n = await (i.isElement == null ? void 0 : i.isElement(v))) == null || n ? v : v.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(s.floating)),
    boundary: c,
    rootBoundary: u,
    strategy: l
  })), y = d === "floating" ? {
    x: r,
    y: o,
    width: a.floating.width,
    height: a.floating.height
  } : a.reference, S = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(s.floating)), C = await (i.isElement == null ? void 0 : i.isElement(S)) ? await (i.getScale == null ? void 0 : i.getScale(S)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, T = jr(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: y,
    offsetParent: S,
    strategy: l
  }) : y);
  return {
    top: (f.top - T.top + m.top) / C.y,
    bottom: (T.bottom - f.bottom + m.bottom) / C.y,
    left: (f.left - T.left + m.left) / C.x,
    right: (T.right - f.right + m.right) / C.x
  };
}
const tp = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: o,
      rects: i,
      platform: a,
      elements: s,
      middlewareData: l
    } = t, {
      element: c,
      padding: u = 0
    } = lt(e, t) || {};
    if (c == null)
      return {};
    const d = el(u), h = {
      x: n,
      y: r
    }, p = Si(o), m = Ei(p), v = await a.getDimensions(c), f = p === "y", y = f ? "top" : "left", S = f ? "bottom" : "right", C = f ? "clientHeight" : "clientWidth", T = i.reference[m] + i.reference[p] - h[p] - i.floating[m], A = h[p] - i.reference[p], U = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(c));
    let L = U ? U[C] : 0;
    (!L || !await (a.isElement == null ? void 0 : a.isElement(U))) && (L = s.floating[C] || i.floating[m]);
    const H = T / 2 - A / 2, G = L / 2 - v[m] / 2 - 1, W = gt(d[y], G), K = gt(d[S], G), F = W, N = L - v[m] - K, O = L / 2 - v[m] / 2 + H, E = Vo(F, O, N), M = !l.arrow && on(o) != null && O !== E && i.reference[m] / 2 - (O < F ? W : K) - v[m] / 2 < 0, $ = M ? O < F ? O - F : O - N : 0;
    return {
      [p]: h[p] + $,
      data: {
        [p]: E,
        centerOffset: O - E - $,
        ...M && {
          alignmentOffset: $
        }
      },
      reset: M
    };
  }
}), np = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        middlewareData: i,
        rects: a,
        initialPlacement: s,
        platform: l,
        elements: c
      } = t, {
        mainAxis: u = !0,
        crossAxis: d = !0,
        fallbackPlacements: h,
        fallbackStrategy: p = "bestFit",
        fallbackAxisSideDirection: m = "none",
        flipAlignment: v = !0,
        ...f
      } = lt(e, t);
      if ((n = i.arrow) != null && n.alignmentOffset)
        return {};
      const y = ct(o), S = yt(s), C = ct(s) === s, T = await (l.isRTL == null ? void 0 : l.isRTL(c.floating)), A = h || (C || !v ? [Tr(s)] : Xf(s)), U = m !== "none";
      !h && U && A.push(...Jf(s, v, m, T));
      const L = [s, ...A], H = await In(t, f), G = [];
      let W = ((r = i.flip) == null ? void 0 : r.overflows) || [];
      if (u && G.push(H[y]), d) {
        const O = Yf(o, a, T);
        G.push(H[O[0]], H[O[1]]);
      }
      if (W = [...W, {
        placement: o,
        overflows: G
      }], !G.every((O) => O <= 0)) {
        var K, F;
        const O = (((K = i.flip) == null ? void 0 : K.index) || 0) + 1, E = L[O];
        if (E)
          return {
            data: {
              index: O,
              overflows: W
            },
            reset: {
              placement: E
            }
          };
        let M = (F = W.filter(($) => $.overflows[0] <= 0).sort(($, I) => $.overflows[1] - I.overflows[1])[0]) == null ? void 0 : F.placement;
        if (!M)
          switch (p) {
            case "bestFit": {
              var N;
              const $ = (N = W.filter((I) => {
                if (U) {
                  const P = yt(I.placement);
                  return P === S || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  P === "y";
                }
                return !0;
              }).map((I) => [I.placement, I.overflows.filter((P) => P > 0).reduce((P, q) => P + q, 0)]).sort((I, P) => I[1] - P[1])[0]) == null ? void 0 : N[0];
              $ && (M = $);
              break;
            }
            case "initialPlacement":
              M = s;
              break;
          }
        if (o !== M)
          return {
            reset: {
              placement: M
            }
          };
      }
      return {};
    }
  };
};
function ja(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function ka(e) {
  return qf.some((t) => e[t] >= 0);
}
const rp = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: r = "referenceHidden",
        ...o
      } = lt(e, t);
      switch (r) {
        case "referenceHidden": {
          const i = await In(t, {
            ...o,
            elementContext: "reference"
          }), a = ja(i, n.reference);
          return {
            data: {
              referenceHiddenOffsets: a,
              referenceHidden: ka(a)
            }
          };
        }
        case "escaped": {
          const i = await In(t, {
            ...o,
            altBoundary: !0
          }), a = ja(i, n.floating);
          return {
            data: {
              escapedOffsets: a,
              escaped: ka(a)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function op(e, t) {
  const {
    placement: n,
    platform: r,
    elements: o
  } = e, i = await (r.isRTL == null ? void 0 : r.isRTL(o.floating)), a = ct(n), s = on(n), l = yt(n) === "y", c = ["left", "top"].includes(a) ? -1 : 1, u = i && l ? -1 : 1, d = lt(t, e);
  let {
    mainAxis: h,
    crossAxis: p,
    alignmentAxis: m
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: d.mainAxis || 0,
    crossAxis: d.crossAxis || 0,
    alignmentAxis: d.alignmentAxis
  };
  return s && typeof m == "number" && (p = s === "end" ? m * -1 : m), l ? {
    x: p * u,
    y: h * c
  } : {
    x: h * c,
    y: p * u
  };
}
const ip = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: o,
        y: i,
        placement: a,
        middlewareData: s
      } = t, l = await op(t, e);
      return a === ((n = s.offset) == null ? void 0 : n.placement) && (r = s.arrow) != null && r.alignmentOffset ? {} : {
        x: o + l.x,
        y: i + l.y,
        data: {
          ...l,
          placement: a
        }
      };
    }
  };
}, ap = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: o
      } = t, {
        mainAxis: i = !0,
        crossAxis: a = !1,
        limiter: s = {
          fn: (f) => {
            let {
              x: y,
              y: S
            } = f;
            return {
              x: y,
              y: S
            };
          }
        },
        ...l
      } = lt(e, t), c = {
        x: n,
        y: r
      }, u = await In(t, l), d = yt(ct(o)), h = xi(d);
      let p = c[h], m = c[d];
      if (i) {
        const f = h === "y" ? "top" : "left", y = h === "y" ? "bottom" : "right", S = p + u[f], C = p - u[y];
        p = Vo(S, p, C);
      }
      if (a) {
        const f = d === "y" ? "top" : "left", y = d === "y" ? "bottom" : "right", S = m + u[f], C = m - u[y];
        m = Vo(S, m, C);
      }
      const v = s.fn({
        ...t,
        [h]: p,
        [d]: m
      });
      return {
        ...v,
        data: {
          x: v.x - n,
          y: v.y - r,
          enabled: {
            [h]: i,
            [d]: a
          }
        }
      };
    }
  };
}, sp = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: r,
        placement: o,
        rects: i,
        middlewareData: a
      } = t, {
        offset: s = 0,
        mainAxis: l = !0,
        crossAxis: c = !0
      } = lt(e, t), u = {
        x: n,
        y: r
      }, d = yt(o), h = xi(d);
      let p = u[h], m = u[d];
      const v = lt(s, t), f = typeof v == "number" ? {
        mainAxis: v,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...v
      };
      if (l) {
        const C = h === "y" ? "height" : "width", T = i.reference[h] - i.floating[C] + f.mainAxis, A = i.reference[h] + i.reference[C] - f.mainAxis;
        p < T ? p = T : p > A && (p = A);
      }
      if (c) {
        var y, S;
        const C = h === "y" ? "width" : "height", T = ["top", "left"].includes(ct(o)), A = i.reference[d] - i.floating[C] + (T && ((y = a.offset) == null ? void 0 : y[d]) || 0) + (T ? 0 : f.crossAxis), U = i.reference[d] + i.reference[C] + (T ? 0 : ((S = a.offset) == null ? void 0 : S[d]) || 0) - (T ? f.crossAxis : 0);
        m < A ? m = A : m > U && (m = U);
      }
      return {
        [h]: p,
        [d]: m
      };
    }
  };
}, lp = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        rects: i,
        platform: a,
        elements: s
      } = t, {
        apply: l = () => {
        },
        ...c
      } = lt(e, t), u = await In(t, c), d = ct(o), h = on(o), p = yt(o) === "y", {
        width: m,
        height: v
      } = i.floating;
      let f, y;
      d === "top" || d === "bottom" ? (f = d, y = h === (await (a.isRTL == null ? void 0 : a.isRTL(s.floating)) ? "start" : "end") ? "left" : "right") : (y = d, f = h === "end" ? "top" : "bottom");
      const S = v - u.top - u.bottom, C = m - u.left - u.right, T = gt(v - u[f], S), A = gt(m - u[y], C), U = !t.middlewareData.shift;
      let L = T, H = A;
      if ((n = t.middlewareData.shift) != null && n.enabled.x && (H = C), (r = t.middlewareData.shift) != null && r.enabled.y && (L = S), U && !h) {
        const W = Ae(u.left, 0), K = Ae(u.right, 0), F = Ae(u.top, 0), N = Ae(u.bottom, 0);
        p ? H = m - 2 * (W !== 0 || K !== 0 ? W + K : Ae(u.left, u.right)) : L = v - 2 * (F !== 0 || N !== 0 ? F + N : Ae(u.top, u.bottom));
      }
      await l({
        ...t,
        availableWidth: H,
        availableHeight: L
      });
      const G = await a.getDimensions(s.floating);
      return m !== G.width || v !== G.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Xr() {
  return typeof window < "u";
}
function an(e) {
  return tl(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Le(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function ot(e) {
  var t;
  return (t = (tl(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function tl(e) {
  return Xr() ? e instanceof Node || e instanceof Le(e).Node : !1;
}
function Ye(e) {
  return Xr() ? e instanceof Element || e instanceof Le(e).Element : !1;
}
function nt(e) {
  return Xr() ? e instanceof HTMLElement || e instanceof Le(e).HTMLElement : !1;
}
function Pa(e) {
  return !Xr() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Le(e).ShadowRoot;
}
function Kn(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: o
  } = Xe(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(o);
}
function cp(e) {
  return ["table", "td", "th"].includes(an(e));
}
function Zr(e) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function _i(e) {
  const t = Ri(), n = Ye(e) ? Xe(e) : e;
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function up(e) {
  let t = wt(e);
  for (; nt(t) && !rn(t); ) {
    if (_i(t))
      return t;
    if (Zr(t))
      return null;
    t = wt(t);
  }
  return null;
}
function Ri() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function rn(e) {
  return ["html", "body", "#document"].includes(an(e));
}
function Xe(e) {
  return Le(e).getComputedStyle(e);
}
function Jr(e) {
  return Ye(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function wt(e) {
  if (an(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Pa(e) && e.host || // Fallback.
    ot(e)
  );
  return Pa(t) ? t.host : t;
}
function nl(e) {
  const t = wt(e);
  return rn(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : nt(t) && Kn(t) ? t : nl(t);
}
function Dn(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const o = nl(e), i = o === ((r = e.ownerDocument) == null ? void 0 : r.body), a = Le(o);
  if (i) {
    const s = Yo(a);
    return t.concat(a, a.visualViewport || [], Kn(o) ? o : [], s && n ? Dn(s) : []);
  }
  return t.concat(o, Dn(o, [], n));
}
function Yo(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function rl(e) {
  const t = Xe(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const o = nt(e), i = o ? e.offsetWidth : n, a = o ? e.offsetHeight : r, s = Cr(n) !== i || Cr(r) !== a;
  return s && (n = i, r = a), {
    width: n,
    height: r,
    $: s
  };
}
function Oi(e) {
  return Ye(e) ? e : e.contextElement;
}
function tn(e) {
  const t = Oi(e);
  if (!nt(t))
    return bt(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: o,
    $: i
  } = rl(t);
  let a = (i ? Cr(n.width) : n.width) / r, s = (i ? Cr(n.height) : n.height) / o;
  return (!a || !Number.isFinite(a)) && (a = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: a,
    y: s
  };
}
const dp = /* @__PURE__ */ bt(0);
function ol(e) {
  const t = Le(e);
  return !Ri() || !t.visualViewport ? dp : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function fp(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== Le(e) ? !1 : t;
}
function Dt(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const o = e.getBoundingClientRect(), i = Oi(e);
  let a = bt(1);
  t && (r ? Ye(r) && (a = tn(r)) : a = tn(e));
  const s = fp(i, n, r) ? ol(i) : bt(0);
  let l = (o.left + s.x) / a.x, c = (o.top + s.y) / a.y, u = o.width / a.x, d = o.height / a.y;
  if (i) {
    const h = Le(i), p = r && Ye(r) ? Le(r) : r;
    let m = h, v = Yo(m);
    for (; v && r && p !== m; ) {
      const f = tn(v), y = v.getBoundingClientRect(), S = Xe(v), C = y.left + (v.clientLeft + parseFloat(S.paddingLeft)) * f.x, T = y.top + (v.clientTop + parseFloat(S.paddingTop)) * f.y;
      l *= f.x, c *= f.y, u *= f.x, d *= f.y, l += C, c += T, m = Le(v), v = Yo(m);
    }
  }
  return jr({
    width: u,
    height: d,
    x: l,
    y: c
  });
}
function pp(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: o
  } = e;
  const i = o === "fixed", a = ot(r), s = t ? Zr(t.floating) : !1;
  if (r === a || s && i)
    return n;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = bt(1);
  const u = bt(0), d = nt(r);
  if ((d || !d && !i) && ((an(r) !== "body" || Kn(a)) && (l = Jr(r)), nt(r))) {
    const h = Dt(r);
    c = tn(r), u.x = h.x + r.clientLeft, u.y = h.y + r.clientTop;
  }
  return {
    width: n.width * c.x,
    height: n.height * c.y,
    x: n.x * c.x - l.scrollLeft * c.x + u.x,
    y: n.y * c.y - l.scrollTop * c.y + u.y
  };
}
function hp(e) {
  return Array.from(e.getClientRects());
}
function Xo(e, t) {
  const n = Jr(e).scrollLeft;
  return t ? t.left + n : Dt(ot(e)).left + n;
}
function mp(e) {
  const t = ot(e), n = Jr(e), r = e.ownerDocument.body, o = Ae(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), i = Ae(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let a = -n.scrollLeft + Xo(e);
  const s = -n.scrollTop;
  return Xe(r).direction === "rtl" && (a += Ae(t.clientWidth, r.clientWidth) - o), {
    width: o,
    height: i,
    x: a,
    y: s
  };
}
function vp(e, t) {
  const n = Le(e), r = ot(e), o = n.visualViewport;
  let i = r.clientWidth, a = r.clientHeight, s = 0, l = 0;
  if (o) {
    i = o.width, a = o.height;
    const c = Ri();
    (!c || c && t === "fixed") && (s = o.offsetLeft, l = o.offsetTop);
  }
  return {
    width: i,
    height: a,
    x: s,
    y: l
  };
}
function gp(e, t) {
  const n = Dt(e, !0, t === "fixed"), r = n.top + e.clientTop, o = n.left + e.clientLeft, i = nt(e) ? tn(e) : bt(1), a = e.clientWidth * i.x, s = e.clientHeight * i.y, l = o * i.x, c = r * i.y;
  return {
    width: a,
    height: s,
    x: l,
    y: c
  };
}
function Aa(e, t, n) {
  let r;
  if (t === "viewport")
    r = vp(e, n);
  else if (t === "document")
    r = mp(ot(e));
  else if (Ye(t))
    r = gp(t, n);
  else {
    const o = ol(e);
    r = {
      ...t,
      x: t.x - o.x,
      y: t.y - o.y
    };
  }
  return jr(r);
}
function il(e, t) {
  const n = wt(e);
  return n === t || !Ye(n) || rn(n) ? !1 : Xe(n).position === "fixed" || il(n, t);
}
function bp(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = Dn(e, [], !1).filter((s) => Ye(s) && an(s) !== "body"), o = null;
  const i = Xe(e).position === "fixed";
  let a = i ? wt(e) : e;
  for (; Ye(a) && !rn(a); ) {
    const s = Xe(a), l = _i(a);
    !l && s.position === "fixed" && (o = null), (i ? !l && !o : !l && s.position === "static" && o && ["absolute", "fixed"].includes(o.position) || Kn(a) && !l && il(e, a)) ? r = r.filter((c) => c !== a) : o = s, a = wt(a);
  }
  return t.set(e, r), r;
}
function yp(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: o
  } = e;
  const i = [...n === "clippingAncestors" ? Zr(t) ? [] : bp(t, this._c) : [].concat(n), r], a = i[0], s = i.reduce((l, c) => {
    const u = Aa(t, c, o);
    return l.top = Ae(u.top, l.top), l.right = gt(u.right, l.right), l.bottom = gt(u.bottom, l.bottom), l.left = Ae(u.left, l.left), l;
  }, Aa(t, a, o));
  return {
    width: s.right - s.left,
    height: s.bottom - s.top,
    x: s.left,
    y: s.top
  };
}
function wp(e) {
  const {
    width: t,
    height: n
  } = rl(e);
  return {
    width: t,
    height: n
  };
}
function xp(e, t, n) {
  const r = nt(t), o = ot(t), i = n === "fixed", a = Dt(e, !0, i, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = bt(0);
  if (r || !r && !i)
    if ((an(t) !== "body" || Kn(o)) && (s = Jr(t)), r) {
      const p = Dt(t, !0, i, t);
      l.x = p.x + t.clientLeft, l.y = p.y + t.clientTop;
    } else o && (l.x = Xo(o));
  let c = 0, u = 0;
  if (o && !r && !i) {
    const p = o.getBoundingClientRect();
    u = p.top + s.scrollTop, c = p.left + s.scrollLeft - // RTL <body> scrollbar.
    Xo(o, p);
  }
  const d = a.left + s.scrollLeft - l.x - c, h = a.top + s.scrollTop - l.y - u;
  return {
    x: d,
    y: h,
    width: a.width,
    height: a.height
  };
}
function Ro(e) {
  return Xe(e).position === "static";
}
function La(e, t) {
  if (!nt(e) || Xe(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return ot(e) === n && (n = n.ownerDocument.body), n;
}
function al(e, t) {
  const n = Le(e);
  if (Zr(e))
    return n;
  if (!nt(e)) {
    let o = wt(e);
    for (; o && !rn(o); ) {
      if (Ye(o) && !Ro(o))
        return o;
      o = wt(o);
    }
    return n;
  }
  let r = La(e, t);
  for (; r && cp(r) && Ro(r); )
    r = La(r, t);
  return r && rn(r) && Ro(r) && !_i(r) ? n : r || up(e) || n;
}
const Ep = async function(e) {
  const t = this.getOffsetParent || al, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: xp(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function Sp(e) {
  return Xe(e).direction === "rtl";
}
const _p = {
  convertOffsetParentRelativeRectToViewportRelativeRect: pp,
  getDocumentElement: ot,
  getClippingRect: yp,
  getOffsetParent: al,
  getElementRects: Ep,
  getClientRects: hp,
  getDimensions: wp,
  getScale: tn,
  isElement: Ye,
  isRTL: Sp
};
function Rp(e, t) {
  let n = null, r;
  const o = ot(e);
  function i() {
    var s;
    clearTimeout(r), (s = n) == null || s.disconnect(), n = null;
  }
  function a(s, l) {
    s === void 0 && (s = !1), l === void 0 && (l = 1), i();
    const {
      left: c,
      top: u,
      width: d,
      height: h
    } = e.getBoundingClientRect();
    if (s || t(), !d || !h)
      return;
    const p = ur(u), m = ur(o.clientWidth - (c + d)), v = ur(o.clientHeight - (u + h)), f = ur(c), y = {
      rootMargin: -p + "px " + -m + "px " + -v + "px " + -f + "px",
      threshold: Ae(0, gt(1, l)) || 1
    };
    let S = !0;
    function C(T) {
      const A = T[0].intersectionRatio;
      if (A !== l) {
        if (!S)
          return a();
        A ? a(!1, A) : r = setTimeout(() => {
          a(!1, 1e-7);
        }, 1e3);
      }
      S = !1;
    }
    try {
      n = new IntersectionObserver(C, {
        ...y,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(C, y);
    }
    n.observe(e);
  }
  return a(!0), i;
}
function Op(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: i = !0,
    elementResize: a = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = r, c = Oi(e), u = o || i ? [...c ? Dn(c) : [], ...Dn(t)] : [];
  u.forEach((y) => {
    o && y.addEventListener("scroll", n, {
      passive: !0
    }), i && y.addEventListener("resize", n);
  });
  const d = c && s ? Rp(c, n) : null;
  let h = -1, p = null;
  a && (p = new ResizeObserver((y) => {
    let [S] = y;
    S && S.target === c && p && (p.unobserve(t), cancelAnimationFrame(h), h = requestAnimationFrame(() => {
      var C;
      (C = p) == null || C.observe(t);
    })), n();
  }), c && !l && p.observe(c), p.observe(t));
  let m, v = l ? Dt(e) : null;
  l && f();
  function f() {
    const y = Dt(e);
    v && (y.x !== v.x || y.y !== v.y || y.width !== v.width || y.height !== v.height) && n(), v = y, m = requestAnimationFrame(f);
  }
  return n(), () => {
    var y;
    u.forEach((S) => {
      o && S.removeEventListener("scroll", n), i && S.removeEventListener("resize", n);
    }), d == null || d(), (y = p) == null || y.disconnect(), p = null, l && cancelAnimationFrame(m);
  };
}
const Np = ip, Cp = ap, Tp = np, jp = lp, kp = rp, Ia = tp, Pp = sp, Ap = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), o = {
    platform: _p,
    ...n
  }, i = {
    ...o.platform,
    _c: r
  };
  return ep(e, t, {
    ...o,
    platform: i
  });
};
var Er = typeof document < "u" ? Rs : le;
function kr(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, o;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length) return !1;
      for (r = n; r-- !== 0; )
        if (!kr(e[r], t[r]))
          return !1;
      return !0;
    }
    if (o = Object.keys(e), n = o.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, o[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const i = o[r];
      if (!(i === "_owner" && e.$$typeof) && !kr(e[i], t[i]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function sl(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Da(e, t) {
  const n = sl(e);
  return Math.round(t * n) / n;
}
function Oo(e) {
  const t = b.useRef(e);
  return Er(() => {
    t.current = e;
  }), t;
}
function Lp(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: o,
    elements: {
      reference: i,
      floating: a
    } = {},
    transform: s = !0,
    whileElementsMounted: l,
    open: c
  } = e, [u, d] = b.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [h, p] = b.useState(r);
  kr(h, r) || p(r);
  const [m, v] = b.useState(null), [f, y] = b.useState(null), S = b.useCallback((I) => {
    I !== U.current && (U.current = I, v(I));
  }, []), C = b.useCallback((I) => {
    I !== L.current && (L.current = I, y(I));
  }, []), T = i || m, A = a || f, U = b.useRef(null), L = b.useRef(null), H = b.useRef(u), G = l != null, W = Oo(l), K = Oo(o), F = Oo(c), N = b.useCallback(() => {
    if (!U.current || !L.current)
      return;
    const I = {
      placement: t,
      strategy: n,
      middleware: h
    };
    K.current && (I.platform = K.current), Ap(U.current, L.current, I).then((P) => {
      const q = {
        ...P,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: F.current !== !1
      };
      O.current && !kr(H.current, q) && (H.current = q, Os.flushSync(() => {
        d(q);
      }));
    });
  }, [h, t, n, K, F]);
  Er(() => {
    c === !1 && H.current.isPositioned && (H.current.isPositioned = !1, d((I) => ({
      ...I,
      isPositioned: !1
    })));
  }, [c]);
  const O = b.useRef(!1);
  Er(() => (O.current = !0, () => {
    O.current = !1;
  }), []), Er(() => {
    if (T && (U.current = T), A && (L.current = A), T && A) {
      if (W.current)
        return W.current(T, A, N);
      N();
    }
  }, [T, A, N, W, G]);
  const E = b.useMemo(() => ({
    reference: U,
    floating: L,
    setReference: S,
    setFloating: C
  }), [S, C]), M = b.useMemo(() => ({
    reference: T,
    floating: A
  }), [T, A]), $ = b.useMemo(() => {
    const I = {
      position: n,
      left: 0,
      top: 0
    };
    if (!M.floating)
      return I;
    const P = Da(M.floating, u.x), q = Da(M.floating, u.y);
    return s ? {
      ...I,
      transform: "translate(" + P + "px, " + q + "px)",
      ...sl(M.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: P,
      top: q
    };
  }, [n, s, M.floating, u.x, u.y]);
  return b.useMemo(() => ({
    ...u,
    update: N,
    refs: E,
    elements: M,
    floatingStyles: $
  }), [u, N, E, M, $]);
}
const Ip = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: r,
        padding: o
      } = typeof e == "function" ? e(n) : e;
      return r && t(r) ? r.current != null ? Ia({
        element: r.current,
        padding: o
      }).fn(n) : {} : r ? Ia({
        element: r,
        padding: o
      }).fn(n) : {};
    }
  };
}, Dp = (e, t) => ({
  ...Np(e),
  options: [e, t]
}), Fp = (e, t) => ({
  ...Cp(e),
  options: [e, t]
}), Mp = (e, t) => ({
  ...Pp(e),
  options: [e, t]
}), $p = (e, t) => ({
  ...Tp(e),
  options: [e, t]
}), Bp = (e, t) => ({
  ...jp(e),
  options: [e, t]
}), zp = (e, t) => ({
  ...kp(e),
  options: [e, t]
}), Up = (e, t) => ({
  ...Ip(e),
  options: [e, t]
});
var Wp = "Arrow", ll = b.forwardRef((e, t) => {
  const { children: n, width: r = 10, height: o = 5, ...i } = e;
  return /* @__PURE__ */ k.jsx(
    Oe.svg,
    {
      ...i,
      ref: t,
      width: r,
      height: o,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : /* @__PURE__ */ k.jsx("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
ll.displayName = Wp;
var Hp = ll;
function Kp(e, t = []) {
  let n = [];
  function r(i, a) {
    const s = b.createContext(a), l = n.length;
    n = [...n, a];
    function c(d) {
      const { scope: h, children: p, ...m } = d, v = (h == null ? void 0 : h[e][l]) || s, f = b.useMemo(() => m, Object.values(m));
      return /* @__PURE__ */ k.jsx(v.Provider, { value: f, children: p });
    }
    function u(d, h) {
      const p = (h == null ? void 0 : h[e][l]) || s, m = b.useContext(p);
      if (m) return m;
      if (a !== void 0) return a;
      throw new Error(`\`${d}\` must be used within \`${i}\``);
    }
    return c.displayName = i + "Provider", [c, u];
  }
  const o = () => {
    const i = n.map((a) => b.createContext(a));
    return function(a) {
      const s = (a == null ? void 0 : a[e]) || i;
      return b.useMemo(
        () => ({ [`__scope${e}`]: { ...a, [e]: s } }),
        [a, s]
      );
    };
  };
  return o.scopeName = e, [r, qp(o, ...t)];
}
function qp(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(o) {
      const i = r.reduce((a, { useScope: s, scopeName: l }) => {
        const c = s(o)[`__scope${l}`];
        return { ...a, ...c };
      }, {});
      return b.useMemo(() => ({ [`__scope${t.scopeName}`]: i }), [i]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function Vp(e) {
  const [t, n] = b.useState(void 0);
  return It(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const r = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length)
          return;
        const i = o[0];
        let a, s;
        if ("borderBoxSize" in i) {
          const l = i.borderBoxSize, c = Array.isArray(l) ? l[0] : l;
          a = c.inlineSize, s = c.blockSize;
        } else
          a = e.offsetWidth, s = e.offsetHeight;
        n({ width: a, height: s });
      });
      return r.observe(e, { box: "border-box" }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
var Ni = "Popper", [cl, ul] = Kp(Ni), [Gp, dl] = cl(Ni), fl = (e) => {
  const { __scopePopper: t, children: n } = e, [r, o] = b.useState(null);
  return /* @__PURE__ */ k.jsx(Gp, { scope: t, anchor: r, onAnchorChange: o, children: n });
};
fl.displayName = Ni;
var pl = "PopperAnchor", hl = b.forwardRef(
  (e, t) => {
    const { __scopePopper: n, virtualRef: r, ...o } = e, i = dl(pl, n), a = b.useRef(null), s = je(t, a);
    return b.useEffect(() => {
      i.onAnchorChange((r == null ? void 0 : r.current) || a.current);
    }), r ? null : /* @__PURE__ */ k.jsx(Oe.div, { ...o, ref: s });
  }
);
hl.displayName = pl;
var Ci = "PopperContent", [Yp, Xp] = cl(Ci), ml = b.forwardRef(
  (e, t) => {
    var n, r, o, i, a, s;
    const {
      __scopePopper: l,
      side: c = "bottom",
      sideOffset: u = 0,
      align: d = "center",
      alignOffset: h = 0,
      arrowPadding: p = 0,
      avoidCollisions: m = !0,
      collisionBoundary: v = [],
      collisionPadding: f = 0,
      sticky: y = "partial",
      hideWhenDetached: S = !1,
      updatePositionStrategy: C = "optimized",
      onPlaced: T,
      ...A
    } = e, U = dl(Ci, l), [L, H] = b.useState(null), G = je(t, (Ke) => H(Ke)), [W, K] = b.useState(null), F = Vp(W), N = (F == null ? void 0 : F.width) ?? 0, O = (F == null ? void 0 : F.height) ?? 0, E = c + (d !== "center" ? "-" + d : ""), M = typeof f == "number" ? f : { top: 0, right: 0, bottom: 0, left: 0, ...f }, $ = Array.isArray(v) ? v : [v], I = $.length > 0, P = {
      padding: M,
      boundary: $.filter(Jp),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: I
    }, { refs: q, floatingStyles: J, placement: me, isPositioned: de, middlewareData: se } = Lp({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: E,
      whileElementsMounted: (...Ke) => Op(...Ke, {
        animationFrame: C === "always"
      }),
      elements: {
        reference: U.anchor
      },
      middleware: [
        Dp({ mainAxis: u + O, alignmentAxis: h }),
        m && Fp({
          mainAxis: !0,
          crossAxis: !1,
          limiter: y === "partial" ? Mp() : void 0,
          ...P
        }),
        m && $p({ ...P }),
        Bp({
          ...P,
          apply: ({ elements: Ke, rects: tr, availableWidth: uo, availableHeight: fo }) => {
            const { width: po, height: ho } = tr.reference, Vt = Ke.floating.style;
            Vt.setProperty("--radix-popper-available-width", `${uo}px`), Vt.setProperty("--radix-popper-available-height", `${fo}px`), Vt.setProperty("--radix-popper-anchor-width", `${po}px`), Vt.setProperty("--radix-popper-anchor-height", `${ho}px`);
          }
        }),
        W && Up({ element: W, padding: p }),
        Qp({ arrowWidth: N, arrowHeight: O }),
        S && zp({ strategy: "referenceHidden", ...P })
      ]
    }), [Y, He] = bl(me), Ee = Ge(T);
    It(() => {
      de && (Ee == null || Ee());
    }, [de, Ee]);
    const ve = (n = se.arrow) == null ? void 0 : n.x, V = (r = se.arrow) == null ? void 0 : r.y, ee = ((o = se.arrow) == null ? void 0 : o.centerOffset) !== 0, [ye, Je] = b.useState();
    return It(() => {
      L && Je(window.getComputedStyle(L).zIndex);
    }, [L]), /* @__PURE__ */ k.jsx(
      "div",
      {
        ref: q.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...J,
          transform: de ? J.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: ye,
          "--radix-popper-transform-origin": [
            (i = se.transformOrigin) == null ? void 0 : i.x,
            (a = se.transformOrigin) == null ? void 0 : a.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((s = se.hide) == null ? void 0 : s.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ k.jsx(
          Yp,
          {
            scope: l,
            placedSide: Y,
            onArrowChange: K,
            arrowX: ve,
            arrowY: V,
            shouldHideArrow: ee,
            children: /* @__PURE__ */ k.jsx(
              Oe.div,
              {
                "data-side": Y,
                "data-align": He,
                ...A,
                ref: G,
                style: {
                  ...A.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: de ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
ml.displayName = Ci;
var vl = "PopperArrow", Zp = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, gl = b.forwardRef(function(e, t) {
  const { __scopePopper: n, ...r } = e, o = Xp(vl, n), i = Zp[o.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ k.jsx(
      "span",
      {
        ref: o.onArrowChange,
        style: {
          position: "absolute",
          left: o.arrowX,
          top: o.arrowY,
          [i]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[o.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[o.placedSide],
          visibility: o.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ k.jsx(
          Hp,
          {
            ...r,
            ref: t,
            style: {
              ...r.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
gl.displayName = vl;
function Jp(e) {
  return e !== null;
}
var Qp = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var n, r, o;
    const { placement: i, rects: a, middlewareData: s } = t, l = ((n = s.arrow) == null ? void 0 : n.centerOffset) !== 0, c = l ? 0 : e.arrowWidth, u = l ? 0 : e.arrowHeight, [d, h] = bl(i), p = { start: "0%", center: "50%", end: "100%" }[h], m = (((r = s.arrow) == null ? void 0 : r.x) ?? 0) + c / 2, v = (((o = s.arrow) == null ? void 0 : o.y) ?? 0) + u / 2;
    let f = "", y = "";
    return d === "bottom" ? (f = l ? p : `${m}px`, y = `${-u}px`) : d === "top" ? (f = l ? p : `${m}px`, y = `${a.floating.height + u}px`) : d === "right" ? (f = `${-u}px`, y = l ? p : `${v}px`) : d === "left" && (f = `${a.floating.width + u}px`, y = l ? p : `${v}px`), { data: { x: f, y } };
  }
});
function bl(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var eh = fl, th = hl, nh = ml, rh = gl, oh = "Portal", yl = b.forwardRef((e, t) => {
  var n;
  const { container: r, ...o } = e, [i, a] = b.useState(!1);
  It(() => a(!0), []);
  const s = r || i && ((n = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : n.body);
  return s ? Id.createPortal(/* @__PURE__ */ k.jsx(Oe.div, { ...o, ref: t }), s) : null;
});
yl.displayName = oh;
function ih(e, t) {
  return b.useReducer((n, r) => t[n][r] ?? n, e);
}
var qn = (e) => {
  const { present: t, children: n } = e, r = ah(t), o = typeof n == "function" ? n({ present: r.isPresent }) : b.Children.only(n), i = je(r.ref, sh(o));
  return typeof n == "function" || r.isPresent ? b.cloneElement(o, { ref: i }) : null;
};
qn.displayName = "Presence";
function ah(e) {
  const [t, n] = b.useState(), r = b.useRef({}), o = b.useRef(e), i = b.useRef("none"), a = e ? "mounted" : "unmounted", [s, l] = ih(a, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return b.useEffect(() => {
    const c = dr(r.current);
    i.current = s === "mounted" ? c : "none";
  }, [s]), It(() => {
    const c = r.current, u = o.current;
    if (u !== e) {
      const d = i.current, h = dr(c);
      e ? l("MOUNT") : h === "none" || (c == null ? void 0 : c.display) === "none" ? l("UNMOUNT") : l(u && d !== h ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, l]), It(() => {
    if (t) {
      let c;
      const u = t.ownerDocument.defaultView ?? window, d = (p) => {
        const m = dr(r.current).includes(p.animationName);
        if (p.target === t && m && (l("ANIMATION_END"), !o.current)) {
          const v = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", c = u.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = v);
          });
        }
      }, h = (p) => {
        p.target === t && (i.current = dr(r.current));
      };
      return t.addEventListener("animationstart", h), t.addEventListener("animationcancel", d), t.addEventListener("animationend", d), () => {
        u.clearTimeout(c), t.removeEventListener("animationstart", h), t.removeEventListener("animationcancel", d), t.removeEventListener("animationend", d);
      };
    } else
      l("ANIMATION_END");
  }, [t, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: b.useCallback((c) => {
      c && (r.current = getComputedStyle(c)), n(c);
    }, [])
  };
}
function dr(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function sh(e) {
  var t, n;
  let r = (t = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : t.get, o = r && "isReactWarning" in r && r.isReactWarning;
  return o ? e.ref : (r = (n = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : n.get, o = r && "isReactWarning" in r && r.isReactWarning, o ? e.props.ref : e.props.ref || e.ref);
}
function lh(e, t = []) {
  let n = [];
  function r(i, a) {
    const s = b.createContext(a), l = n.length;
    n = [...n, a];
    function c(d) {
      const { scope: h, children: p, ...m } = d, v = (h == null ? void 0 : h[e][l]) || s, f = b.useMemo(() => m, Object.values(m));
      return /* @__PURE__ */ k.jsx(v.Provider, { value: f, children: p });
    }
    function u(d, h) {
      const p = (h == null ? void 0 : h[e][l]) || s, m = b.useContext(p);
      if (m) return m;
      if (a !== void 0) return a;
      throw new Error(`\`${d}\` must be used within \`${i}\``);
    }
    return c.displayName = i + "Provider", [c, u];
  }
  const o = () => {
    const i = n.map((a) => b.createContext(a));
    return function(a) {
      const s = (a == null ? void 0 : a[e]) || i;
      return b.useMemo(
        () => ({ [`__scope${e}`]: { ...a, [e]: s } }),
        [a, s]
      );
    };
  };
  return o.scopeName = e, [r, ch(o, ...t)];
}
function ch(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(o) {
      const i = r.reduce((a, { useScope: s, scopeName: l }) => {
        const c = s(o)[`__scope${l}`];
        return { ...a, ...c };
      }, {});
      return b.useMemo(() => ({ [`__scope${t.scopeName}`]: i }), [i]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
var No = "rovingFocusGroup.onEntryFocus", uh = { bubbles: !1, cancelable: !0 }, Qr = "RovingFocusGroup", [Zo, wl, dh] = Vs(Qr), [fh, xl] = lh(
  Qr,
  [dh]
), [ph, hh] = fh(Qr), El = b.forwardRef(
  (e, t) => /* @__PURE__ */ k.jsx(Zo.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ k.jsx(Zo.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ k.jsx(mh, { ...e, ref: t }) }) })
);
El.displayName = Qr;
var mh = b.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: n,
    orientation: r,
    loop: o = !1,
    dir: i,
    currentTabStopId: a,
    defaultCurrentTabStopId: s,
    onCurrentTabStopIdChange: l,
    onEntryFocus: c,
    preventScrollOnEntryFocus: u = !1,
    ...d
  } = e, h = b.useRef(null), p = je(t, h), m = Gs(i), [v = null, f] = Ks({
    prop: a,
    defaultProp: s,
    onChange: l
  }), [y, S] = b.useState(!1), C = Ge(c), T = wl(n), A = b.useRef(!1), [U, L] = b.useState(0);
  return b.useEffect(() => {
    const H = h.current;
    if (H)
      return H.addEventListener(No, C), () => H.removeEventListener(No, C);
  }, [C]), /* @__PURE__ */ k.jsx(
    ph,
    {
      scope: n,
      orientation: r,
      dir: m,
      loop: o,
      currentTabStopId: v,
      onItemFocus: b.useCallback(
        (H) => f(H),
        [f]
      ),
      onItemShiftTab: b.useCallback(() => S(!0), []),
      onFocusableItemAdd: b.useCallback(
        () => L((H) => H + 1),
        []
      ),
      onFocusableItemRemove: b.useCallback(
        () => L((H) => H - 1),
        []
      ),
      children: /* @__PURE__ */ k.jsx(
        Oe.div,
        {
          tabIndex: y || U === 0 ? -1 : 0,
          "data-orientation": r,
          ...d,
          ref: p,
          style: { outline: "none", ...e.style },
          onMouseDown: Q(e.onMouseDown, () => {
            A.current = !0;
          }),
          onFocus: Q(e.onFocus, (H) => {
            const G = !A.current;
            if (H.target === H.currentTarget && G && !y) {
              const W = new CustomEvent(No, uh);
              if (H.currentTarget.dispatchEvent(W), !W.defaultPrevented) {
                const K = T().filter((E) => E.focusable), F = K.find((E) => E.active), N = K.find((E) => E.id === v), O = [F, N, ...K].filter(
                  Boolean
                ).map((E) => E.ref.current);
                Rl(O, u);
              }
            }
            A.current = !1;
          }),
          onBlur: Q(e.onBlur, () => S(!1))
        }
      )
    }
  );
}), Sl = "RovingFocusGroupItem", _l = b.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: n,
      focusable: r = !0,
      active: o = !1,
      tabStopId: i,
      ...a
    } = e, s = qo(), l = i || s, c = hh(Sl, n), u = c.currentTabStopId === l, d = wl(n), { onFocusableItemAdd: h, onFocusableItemRemove: p } = c;
    return b.useEffect(() => {
      if (r)
        return h(), () => p();
    }, [r, h, p]), /* @__PURE__ */ k.jsx(
      Zo.ItemSlot,
      {
        scope: n,
        id: l,
        focusable: r,
        active: o,
        children: /* @__PURE__ */ k.jsx(
          Oe.span,
          {
            tabIndex: u ? 0 : -1,
            "data-orientation": c.orientation,
            ...a,
            ref: t,
            onMouseDown: Q(e.onMouseDown, (m) => {
              r ? c.onItemFocus(l) : m.preventDefault();
            }),
            onFocus: Q(e.onFocus, () => c.onItemFocus(l)),
            onKeyDown: Q(e.onKeyDown, (m) => {
              if (m.key === "Tab" && m.shiftKey) {
                c.onItemShiftTab();
                return;
              }
              if (m.target !== m.currentTarget) return;
              const v = bh(m, c.orientation, c.dir);
              if (v !== void 0) {
                if (m.metaKey || m.ctrlKey || m.altKey || m.shiftKey) return;
                m.preventDefault();
                let f = d().filter((y) => y.focusable).map((y) => y.ref.current);
                if (v === "last") f.reverse();
                else if (v === "prev" || v === "next") {
                  v === "prev" && f.reverse();
                  const y = f.indexOf(m.currentTarget);
                  f = c.loop ? yh(f, y + 1) : f.slice(y + 1);
                }
                setTimeout(() => Rl(f));
              }
            })
          }
        )
      }
    );
  }
);
_l.displayName = Sl;
var vh = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function gh(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function bh(e, t, n) {
  const r = gh(e.key, n);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(r)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(r)))
    return vh[r];
}
function Rl(e, t = !1) {
  const n = document.activeElement;
  for (const r of e)
    if (r === n || (r.focus({ preventScroll: t }), document.activeElement !== n)) return;
}
function yh(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var wh = El, xh = _l, Eh = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, Yt = /* @__PURE__ */ new WeakMap(), fr = /* @__PURE__ */ new WeakMap(), pr = {}, Co = 0, Ol = function(e) {
  return e && (e.host || Ol(e.parentNode));
}, Sh = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = Ol(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, _h = function(e, t, n, r) {
  var o = Sh(t, Array.isArray(e) ? e : [e]);
  pr[n] || (pr[n] = /* @__PURE__ */ new WeakMap());
  var i = pr[n], a = [], s = /* @__PURE__ */ new Set(), l = new Set(o), c = function(d) {
    !d || s.has(d) || (s.add(d), c(d.parentNode));
  };
  o.forEach(c);
  var u = function(d) {
    !d || l.has(d) || Array.prototype.forEach.call(d.children, function(h) {
      if (s.has(h))
        u(h);
      else
        try {
          var p = h.getAttribute(r), m = p !== null && p !== "false", v = (Yt.get(h) || 0) + 1, f = (i.get(h) || 0) + 1;
          Yt.set(h, v), i.set(h, f), a.push(h), v === 1 && m && fr.set(h, !0), f === 1 && h.setAttribute(n, "true"), m || h.setAttribute(r, "true");
        } catch (y) {
          console.error("aria-hidden: cannot operate on ", h, y);
        }
    });
  };
  return u(t), s.clear(), Co++, function() {
    a.forEach(function(d) {
      var h = Yt.get(d) - 1, p = i.get(d) - 1;
      Yt.set(d, h), i.set(d, p), h || (fr.has(d) || d.removeAttribute(r), fr.delete(d)), p || d.removeAttribute(n);
    }), Co--, Co || (Yt = /* @__PURE__ */ new WeakMap(), Yt = /* @__PURE__ */ new WeakMap(), fr = /* @__PURE__ */ new WeakMap(), pr = {});
  };
}, Rh = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), o = Eh(e);
  return o ? (r.push.apply(r, Array.from(o.querySelectorAll("[aria-live]"))), _h(r, o, n, "aria-hidden")) : function() {
    return null;
  };
}, tt = function() {
  return tt = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var o in t) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, tt.apply(this, arguments);
};
function Nl(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
function Oh(e, t, n) {
  for (var r = 0, o = t.length, i; r < o; r++)
    (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return e.concat(i || Array.prototype.slice.call(t));
}
var Sr = "right-scroll-bar-position", _r = "width-before-scroll-bar", Nh = "with-scroll-bars-hidden", Ch = "--removed-body-scroll-bar-size";
function To(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function Th(e, t) {
  var n = Ue(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var o = n.value;
          o !== r && (n.value = r, n.callback(r, o));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var jh = typeof window < "u" ? b.useLayoutEffect : b.useEffect, Fa = /* @__PURE__ */ new WeakMap();
function kh(e, t) {
  var n = Th(null, function(r) {
    return e.forEach(function(o) {
      return To(o, r);
    });
  });
  return jh(function() {
    var r = Fa.get(n);
    if (r) {
      var o = new Set(r), i = new Set(e), a = n.current;
      o.forEach(function(s) {
        i.has(s) || To(s, null);
      }), i.forEach(function(s) {
        o.has(s) || To(s, a);
      });
    }
    Fa.set(n, e);
  }, [e]), n;
}
function Ph(e) {
  return e;
}
function Ah(e, t) {
  t === void 0 && (t = Ph);
  var n = [], r = !1, o = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(i) {
      var a = t(i, r);
      return n.push(a), function() {
        n = n.filter(function(s) {
          return s !== a;
        });
      };
    },
    assignSyncMedium: function(i) {
      for (r = !0; n.length; ) {
        var a = n;
        n = [], a.forEach(i);
      }
      n = {
        push: function(s) {
          return i(s);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(i) {
      r = !0;
      var a = [];
      if (n.length) {
        var s = n;
        n = [], s.forEach(i), a = n;
      }
      var l = function() {
        var u = a;
        a = [], u.forEach(i);
      }, c = function() {
        return Promise.resolve().then(l);
      };
      c(), n = {
        push: function(u) {
          a.push(u), c();
        },
        filter: function(u) {
          return a = a.filter(u), n;
        }
      };
    }
  };
  return o;
}
function Lh(e) {
  e === void 0 && (e = {});
  var t = Ah(null);
  return t.options = tt({ async: !0, ssr: !1 }, e), t;
}
var Cl = function(e) {
  var t = e.sideCar, n = Nl(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return b.createElement(r, tt({}, n));
};
Cl.isSideCarExport = !0;
function Ih(e, t) {
  return e.useMedium(t), Cl;
}
var Tl = Lh(), jo = function() {
}, eo = b.forwardRef(function(e, t) {
  var n = b.useRef(null), r = b.useState({
    onScrollCapture: jo,
    onWheelCapture: jo,
    onTouchMoveCapture: jo
  }), o = r[0], i = r[1], a = e.forwardProps, s = e.children, l = e.className, c = e.removeScrollBar, u = e.enabled, d = e.shards, h = e.sideCar, p = e.noIsolation, m = e.inert, v = e.allowPinchZoom, f = e.as, y = f === void 0 ? "div" : f, S = e.gapMode, C = Nl(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), T = h, A = kh([n, t]), U = tt(tt({}, C), o);
  return b.createElement(
    b.Fragment,
    null,
    u && b.createElement(T, { sideCar: Tl, removeScrollBar: c, shards: d, noIsolation: p, inert: m, setCallbacks: i, allowPinchZoom: !!v, lockRef: n, gapMode: S }),
    a ? b.cloneElement(b.Children.only(s), tt(tt({}, U), { ref: A })) : b.createElement(y, tt({}, U, { className: l, ref: A }), s)
  );
});
eo.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
eo.classNames = {
  fullWidth: _r,
  zeroRight: Sr
};
var Dh = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function Fh() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = Dh();
  return t && e.setAttribute("nonce", t), e;
}
function Mh(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function $h(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var Bh = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = Fh()) && (Mh(t, n), $h(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, zh = function() {
  var e = Bh();
  return function(t, n) {
    b.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, jl = function() {
  var e = zh(), t = function(n) {
    var r = n.styles, o = n.dynamic;
    return e(r, o), null;
  };
  return t;
}, Uh = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, ko = function(e) {
  return parseInt(e || "", 10) || 0;
}, Wh = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], o = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [ko(n), ko(r), ko(o)];
}, Hh = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return Uh;
  var t = Wh(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, Kh = jl(), nn = "data-scroll-locked", qh = function(e, t, n, r) {
  var o = e.left, i = e.top, a = e.right, s = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(Nh, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(s, "px ").concat(r, `;
  }
  body[`).concat(nn, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(i, `px;
    padding-right: `).concat(a, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(s, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(s, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Sr, ` {
    right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(_r, ` {
    margin-right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(Sr, " .").concat(Sr, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(_r, " .").concat(_r, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(nn, `] {
    `).concat(Ch, ": ").concat(s, `px;
  }
`);
}, Ma = function() {
  var e = parseInt(document.body.getAttribute(nn) || "0", 10);
  return isFinite(e) ? e : 0;
}, Vh = function() {
  b.useEffect(function() {
    return document.body.setAttribute(nn, (Ma() + 1).toString()), function() {
      var e = Ma() - 1;
      e <= 0 ? document.body.removeAttribute(nn) : document.body.setAttribute(nn, e.toString());
    };
  }, []);
}, Gh = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, o = r === void 0 ? "margin" : r;
  Vh();
  var i = b.useMemo(function() {
    return Hh(o);
  }, [o]);
  return b.createElement(Kh, { styles: qh(i, !t, o, n ? "" : "!important") });
}, Jo = !1;
if (typeof window < "u")
  try {
    var hr = Object.defineProperty({}, "passive", {
      get: function() {
        return Jo = !0, !0;
      }
    });
    window.addEventListener("test", hr, hr), window.removeEventListener("test", hr, hr);
  } catch {
    Jo = !1;
  }
var Xt = Jo ? { passive: !1 } : !1, Yh = function(e) {
  return e.tagName === "TEXTAREA";
}, kl = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !Yh(e) && n[t] === "visible")
  );
}, Xh = function(e) {
  return kl(e, "overflowY");
}, Zh = function(e) {
  return kl(e, "overflowX");
}, $a = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var o = Pl(e, r);
    if (o) {
      var i = Al(e, r), a = i[1], s = i[2];
      if (a > s)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, Jh = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, Qh = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, Pl = function(e, t) {
  return e === "v" ? Xh(t) : Zh(t);
}, Al = function(e, t) {
  return e === "v" ? Jh(t) : Qh(t);
}, em = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, tm = function(e, t, n, r, o) {
  var i = em(e, window.getComputedStyle(t).direction), a = i * r, s = n.target, l = t.contains(s), c = !1, u = a > 0, d = 0, h = 0;
  do {
    var p = Al(e, s), m = p[0], v = p[1], f = p[2], y = v - f - i * m;
    (m || y) && Pl(e, s) && (d += y, h += m), s instanceof ShadowRoot ? s = s.host : s = s.parentNode;
  } while (
    // portaled content
    !l && s !== document.body || // self content
    l && (t.contains(s) || t === s)
  );
  return (u && (Math.abs(d) < 1 || !o) || !u && (Math.abs(h) < 1 || !o)) && (c = !0), c;
}, mr = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, Ba = function(e) {
  return [e.deltaX, e.deltaY];
}, za = function(e) {
  return e && "current" in e ? e.current : e;
}, nm = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, rm = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, om = 0, Zt = [];
function im(e) {
  var t = b.useRef([]), n = b.useRef([0, 0]), r = b.useRef(), o = b.useState(om++)[0], i = b.useState(jl)[0], a = b.useRef(e);
  b.useEffect(function() {
    a.current = e;
  }, [e]), b.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var v = Oh([e.lockRef.current], (e.shards || []).map(za)).filter(Boolean);
      return v.forEach(function(f) {
        return f.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), v.forEach(function(f) {
          return f.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = b.useCallback(function(v, f) {
    if ("touches" in v && v.touches.length === 2 || v.type === "wheel" && v.ctrlKey)
      return !a.current.allowPinchZoom;
    var y = mr(v), S = n.current, C = "deltaX" in v ? v.deltaX : S[0] - y[0], T = "deltaY" in v ? v.deltaY : S[1] - y[1], A, U = v.target, L = Math.abs(C) > Math.abs(T) ? "h" : "v";
    if ("touches" in v && L === "h" && U.type === "range")
      return !1;
    var H = $a(L, U);
    if (!H)
      return !0;
    if (H ? A = L : (A = L === "v" ? "h" : "v", H = $a(L, U)), !H)
      return !1;
    if (!r.current && "changedTouches" in v && (C || T) && (r.current = A), !A)
      return !0;
    var G = r.current || A;
    return tm(G, f, v, G === "h" ? C : T, !0);
  }, []), l = b.useCallback(function(v) {
    var f = v;
    if (!(!Zt.length || Zt[Zt.length - 1] !== i)) {
      var y = "deltaY" in f ? Ba(f) : mr(f), S = t.current.filter(function(A) {
        return A.name === f.type && (A.target === f.target || f.target === A.shadowParent) && nm(A.delta, y);
      })[0];
      if (S && S.should) {
        f.cancelable && f.preventDefault();
        return;
      }
      if (!S) {
        var C = (a.current.shards || []).map(za).filter(Boolean).filter(function(A) {
          return A.contains(f.target);
        }), T = C.length > 0 ? s(f, C[0]) : !a.current.noIsolation;
        T && f.cancelable && f.preventDefault();
      }
    }
  }, []), c = b.useCallback(function(v, f, y, S) {
    var C = { name: v, delta: f, target: y, should: S, shadowParent: am(y) };
    t.current.push(C), setTimeout(function() {
      t.current = t.current.filter(function(T) {
        return T !== C;
      });
    }, 1);
  }, []), u = b.useCallback(function(v) {
    n.current = mr(v), r.current = void 0;
  }, []), d = b.useCallback(function(v) {
    c(v.type, Ba(v), v.target, s(v, e.lockRef.current));
  }, []), h = b.useCallback(function(v) {
    c(v.type, mr(v), v.target, s(v, e.lockRef.current));
  }, []);
  b.useEffect(function() {
    return Zt.push(i), e.setCallbacks({
      onScrollCapture: d,
      onWheelCapture: d,
      onTouchMoveCapture: h
    }), document.addEventListener("wheel", l, Xt), document.addEventListener("touchmove", l, Xt), document.addEventListener("touchstart", u, Xt), function() {
      Zt = Zt.filter(function(v) {
        return v !== i;
      }), document.removeEventListener("wheel", l, Xt), document.removeEventListener("touchmove", l, Xt), document.removeEventListener("touchstart", u, Xt);
    };
  }, []);
  var p = e.removeScrollBar, m = e.inert;
  return b.createElement(
    b.Fragment,
    null,
    m ? b.createElement(i, { styles: rm(o) }) : null,
    p ? b.createElement(Gh, { gapMode: e.gapMode }) : null
  );
}
function am(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const sm = Ih(Tl, im);
var Ll = b.forwardRef(function(e, t) {
  return b.createElement(eo, tt({}, e, { ref: t, sideCar: sm }));
});
Ll.classNames = eo.classNames;
var Qo = ["Enter", " "], lm = ["ArrowDown", "PageUp", "Home"], Il = ["ArrowUp", "PageDown", "End"], cm = [...lm, ...Il], um = {
  ltr: [...Qo, "ArrowRight"],
  rtl: [...Qo, "ArrowLeft"]
}, dm = {
  ltr: ["ArrowLeft"],
  rtl: ["ArrowRight"]
}, Vn = "Menu", [Fn, fm, pm] = Vs(Vn), [Bt, Dl] = Hs(Vn, [
  pm,
  ul,
  xl
]), to = ul(), Fl = xl(), [hm, zt] = Bt(Vn), [mm, Gn] = Bt(Vn), Ml = (e) => {
  const { __scopeMenu: t, open: n = !1, children: r, dir: o, onOpenChange: i, modal: a = !0 } = e, s = to(t), [l, c] = b.useState(null), u = b.useRef(!1), d = Ge(i), h = Gs(o);
  return b.useEffect(() => {
    const p = () => {
      u.current = !0, document.addEventListener("pointerdown", m, { capture: !0, once: !0 }), document.addEventListener("pointermove", m, { capture: !0, once: !0 });
    }, m = () => u.current = !1;
    return document.addEventListener("keydown", p, { capture: !0 }), () => {
      document.removeEventListener("keydown", p, { capture: !0 }), document.removeEventListener("pointerdown", m, { capture: !0 }), document.removeEventListener("pointermove", m, { capture: !0 });
    };
  }, []), /* @__PURE__ */ k.jsx(eh, { ...s, children: /* @__PURE__ */ k.jsx(
    hm,
    {
      scope: t,
      open: n,
      onOpenChange: d,
      content: l,
      onContentChange: c,
      children: /* @__PURE__ */ k.jsx(
        mm,
        {
          scope: t,
          onClose: b.useCallback(() => d(!1), [d]),
          isUsingKeyboardRef: u,
          dir: h,
          modal: a,
          children: r
        }
      )
    }
  ) });
};
Ml.displayName = Vn;
var vm = "MenuAnchor", Ti = b.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e, o = to(n);
    return /* @__PURE__ */ k.jsx(th, { ...o, ...r, ref: t });
  }
);
Ti.displayName = vm;
var ji = "MenuPortal", [gm, $l] = Bt(ji, {
  forceMount: void 0
}), Bl = (e) => {
  const { __scopeMenu: t, forceMount: n, children: r, container: o } = e, i = zt(ji, t);
  return /* @__PURE__ */ k.jsx(gm, { scope: t, forceMount: n, children: /* @__PURE__ */ k.jsx(qn, { present: n || i.open, children: /* @__PURE__ */ k.jsx(yl, { asChild: !0, container: o, children: r }) }) });
};
Bl.displayName = ji;
var ze = "MenuContent", [bm, ki] = Bt(ze), zl = b.forwardRef(
  (e, t) => {
    const n = $l(ze, e.__scopeMenu), { forceMount: r = n.forceMount, ...o } = e, i = zt(ze, e.__scopeMenu), a = Gn(ze, e.__scopeMenu);
    return /* @__PURE__ */ k.jsx(Fn.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ k.jsx(qn, { present: r || i.open, children: /* @__PURE__ */ k.jsx(Fn.Slot, { scope: e.__scopeMenu, children: a.modal ? /* @__PURE__ */ k.jsx(ym, { ...o, ref: t }) : /* @__PURE__ */ k.jsx(wm, { ...o, ref: t }) }) }) });
  }
), ym = b.forwardRef(
  (e, t) => {
    const n = zt(ze, e.__scopeMenu), r = b.useRef(null), o = je(t, r);
    return b.useEffect(() => {
      const i = r.current;
      if (i) return Rh(i);
    }, []), /* @__PURE__ */ k.jsx(
      Pi,
      {
        ...e,
        ref: o,
        trapFocus: n.open,
        disableOutsidePointerEvents: n.open,
        disableOutsideScroll: !0,
        onFocusOutside: Q(
          e.onFocusOutside,
          (i) => i.preventDefault(),
          { checkForDefaultPrevented: !1 }
        ),
        onDismiss: () => n.onOpenChange(!1)
      }
    );
  }
), wm = b.forwardRef((e, t) => {
  const n = zt(ze, e.__scopeMenu);
  return /* @__PURE__ */ k.jsx(
    Pi,
    {
      ...e,
      ref: t,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      disableOutsideScroll: !1,
      onDismiss: () => n.onOpenChange(!1)
    }
  );
}), Pi = b.forwardRef(
  (e, t) => {
    const {
      __scopeMenu: n,
      loop: r = !1,
      trapFocus: o,
      onOpenAutoFocus: i,
      onCloseAutoFocus: a,
      disableOutsidePointerEvents: s,
      onEntryFocus: l,
      onEscapeKeyDown: c,
      onPointerDownOutside: u,
      onFocusOutside: d,
      onInteractOutside: h,
      onDismiss: p,
      disableOutsideScroll: m,
      ...v
    } = e, f = zt(ze, n), y = Gn(ze, n), S = to(n), C = Fl(n), T = fm(n), [A, U] = b.useState(null), L = b.useRef(null), H = je(t, L, f.onContentChange), G = b.useRef(0), W = b.useRef(""), K = b.useRef(0), F = b.useRef(null), N = b.useRef("right"), O = b.useRef(0), E = m ? Ll : b.Fragment, M = m ? { as: Ln, allowPinchZoom: !0 } : void 0, $ = (P) => {
      var q, J;
      const me = W.current + P, de = T().filter((V) => !V.disabled), se = document.activeElement, Y = (q = de.find((V) => V.ref.current === se)) == null ? void 0 : q.textValue, He = de.map((V) => V.textValue), Ee = Pm(He, me, Y), ve = (J = de.find((V) => V.textValue === Ee)) == null ? void 0 : J.ref.current;
      (function V(ee) {
        W.current = ee, window.clearTimeout(G.current), ee !== "" && (G.current = window.setTimeout(() => V(""), 1e3));
      })(me), ve && setTimeout(() => ve.focus());
    };
    b.useEffect(() => () => window.clearTimeout(G.current), []), Df();
    const I = b.useCallback((P) => {
      var q, J;
      return N.current === ((q = F.current) == null ? void 0 : q.side) && Lm(P, (J = F.current) == null ? void 0 : J.area);
    }, []);
    return /* @__PURE__ */ k.jsx(
      bm,
      {
        scope: n,
        searchRef: W,
        onItemEnter: b.useCallback(
          (P) => {
            I(P) && P.preventDefault();
          },
          [I]
        ),
        onItemLeave: b.useCallback(
          (P) => {
            var q;
            I(P) || ((q = L.current) == null || q.focus(), U(null));
          },
          [I]
        ),
        onTriggerLeave: b.useCallback(
          (P) => {
            I(P) && P.preventDefault();
          },
          [I]
        ),
        pointerGraceTimerRef: K,
        onPointerGraceIntentChange: b.useCallback((P) => {
          F.current = P;
        }, []),
        children: /* @__PURE__ */ k.jsx(E, { ...M, children: /* @__PURE__ */ k.jsx(
          Js,
          {
            asChild: !0,
            trapped: o,
            onMountAutoFocus: Q(i, (P) => {
              var q;
              P.preventDefault(), (q = L.current) == null || q.focus({ preventScroll: !0 });
            }),
            onUnmountAutoFocus: a,
            children: /* @__PURE__ */ k.jsx(
              Xs,
              {
                asChild: !0,
                disableOutsidePointerEvents: s,
                onEscapeKeyDown: c,
                onPointerDownOutside: u,
                onFocusOutside: d,
                onInteractOutside: h,
                onDismiss: p,
                children: /* @__PURE__ */ k.jsx(
                  wh,
                  {
                    asChild: !0,
                    ...C,
                    dir: y.dir,
                    orientation: "vertical",
                    loop: r,
                    currentTabStopId: A,
                    onCurrentTabStopIdChange: U,
                    onEntryFocus: Q(l, (P) => {
                      y.isUsingKeyboardRef.current || P.preventDefault();
                    }),
                    preventScrollOnEntryFocus: !0,
                    children: /* @__PURE__ */ k.jsx(
                      nh,
                      {
                        role: "menu",
                        "aria-orientation": "vertical",
                        "data-state": rc(f.open),
                        "data-radix-menu-content": "",
                        dir: y.dir,
                        ...S,
                        ...v,
                        ref: H,
                        style: { outline: "none", ...v.style },
                        onKeyDown: Q(v.onKeyDown, (P) => {
                          const q = P.target.closest("[data-radix-menu-content]") === P.currentTarget, J = P.ctrlKey || P.altKey || P.metaKey, me = P.key.length === 1;
                          q && (P.key === "Tab" && P.preventDefault(), !J && me && $(P.key));
                          const de = L.current;
                          if (P.target !== de || !cm.includes(P.key)) return;
                          P.preventDefault();
                          const se = T().filter((Y) => !Y.disabled).map((Y) => Y.ref.current);
                          Il.includes(P.key) && se.reverse(), jm(se);
                        }),
                        onBlur: Q(e.onBlur, (P) => {
                          P.currentTarget.contains(P.target) || (window.clearTimeout(G.current), W.current = "");
                        }),
                        onPointerMove: Q(
                          e.onPointerMove,
                          Mn((P) => {
                            const q = P.target, J = O.current !== P.clientX;
                            if (P.currentTarget.contains(q) && J) {
                              const me = P.clientX > O.current ? "right" : "left";
                              N.current = me, O.current = P.clientX;
                            }
                          })
                        )
                      }
                    )
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
zl.displayName = ze;
var xm = "MenuGroup", Ai = b.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ k.jsx(Oe.div, { role: "group", ...r, ref: t });
  }
);
Ai.displayName = xm;
var Em = "MenuLabel", Ul = b.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ k.jsx(Oe.div, { ...r, ref: t });
  }
);
Ul.displayName = Em;
var Pr = "MenuItem", Ua = "menu.itemSelect", no = b.forwardRef(
  (e, t) => {
    const { disabled: n = !1, onSelect: r, ...o } = e, i = b.useRef(null), a = Gn(Pr, e.__scopeMenu), s = ki(Pr, e.__scopeMenu), l = je(t, i), c = b.useRef(!1), u = () => {
      const d = i.current;
      if (!n && d) {
        const h = new CustomEvent(Ua, { bubbles: !0, cancelable: !0 });
        d.addEventListener(Ua, (p) => r == null ? void 0 : r(p), { once: !0 }), qs(d, h), h.defaultPrevented ? c.current = !1 : a.onClose();
      }
    };
    return /* @__PURE__ */ k.jsx(
      Wl,
      {
        ...o,
        ref: l,
        disabled: n,
        onClick: Q(e.onClick, u),
        onPointerDown: (d) => {
          var h;
          (h = e.onPointerDown) == null || h.call(e, d), c.current = !0;
        },
        onPointerUp: Q(e.onPointerUp, (d) => {
          var h;
          c.current || (h = d.currentTarget) == null || h.click();
        }),
        onKeyDown: Q(e.onKeyDown, (d) => {
          const h = s.searchRef.current !== "";
          n || h && d.key === " " || Qo.includes(d.key) && (d.currentTarget.click(), d.preventDefault());
        })
      }
    );
  }
);
no.displayName = Pr;
var Wl = b.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, disabled: r = !1, textValue: o, ...i } = e, a = ki(Pr, n), s = Fl(n), l = b.useRef(null), c = je(t, l), [u, d] = b.useState(!1), [h, p] = b.useState("");
    return b.useEffect(() => {
      const m = l.current;
      m && p((m.textContent ?? "").trim());
    }, [i.children]), /* @__PURE__ */ k.jsx(
      Fn.ItemSlot,
      {
        scope: n,
        disabled: r,
        textValue: o ?? h,
        children: /* @__PURE__ */ k.jsx(xh, { asChild: !0, ...s, focusable: !r, children: /* @__PURE__ */ k.jsx(
          Oe.div,
          {
            role: "menuitem",
            "data-highlighted": u ? "" : void 0,
            "aria-disabled": r || void 0,
            "data-disabled": r ? "" : void 0,
            ...i,
            ref: c,
            onPointerMove: Q(
              e.onPointerMove,
              Mn((m) => {
                r ? a.onItemLeave(m) : (a.onItemEnter(m), m.defaultPrevented || m.currentTarget.focus({ preventScroll: !0 }));
              })
            ),
            onPointerLeave: Q(
              e.onPointerLeave,
              Mn((m) => a.onItemLeave(m))
            ),
            onFocus: Q(e.onFocus, () => d(!0)),
            onBlur: Q(e.onBlur, () => d(!1))
          }
        ) })
      }
    );
  }
), Sm = "MenuCheckboxItem", Hl = b.forwardRef(
  (e, t) => {
    const { checked: n = !1, onCheckedChange: r, ...o } = e;
    return /* @__PURE__ */ k.jsx(Yl, { scope: e.__scopeMenu, checked: n, children: /* @__PURE__ */ k.jsx(
      no,
      {
        role: "menuitemcheckbox",
        "aria-checked": Ar(n) ? "mixed" : n,
        ...o,
        ref: t,
        "data-state": Ii(n),
        onSelect: Q(
          o.onSelect,
          () => r == null ? void 0 : r(Ar(n) ? !0 : !n),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
Hl.displayName = Sm;
var Kl = "MenuRadioGroup", [_m, Rm] = Bt(
  Kl,
  { value: void 0, onValueChange: () => {
  } }
), ql = b.forwardRef(
  (e, t) => {
    const { value: n, onValueChange: r, ...o } = e, i = Ge(r);
    return /* @__PURE__ */ k.jsx(_m, { scope: e.__scopeMenu, value: n, onValueChange: i, children: /* @__PURE__ */ k.jsx(Ai, { ...o, ref: t }) });
  }
);
ql.displayName = Kl;
var Vl = "MenuRadioItem", Gl = b.forwardRef(
  (e, t) => {
    const { value: n, ...r } = e, o = Rm(Vl, e.__scopeMenu), i = n === o.value;
    return /* @__PURE__ */ k.jsx(Yl, { scope: e.__scopeMenu, checked: i, children: /* @__PURE__ */ k.jsx(
      no,
      {
        role: "menuitemradio",
        "aria-checked": i,
        ...r,
        ref: t,
        "data-state": Ii(i),
        onSelect: Q(
          r.onSelect,
          () => {
            var a;
            return (a = o.onValueChange) == null ? void 0 : a.call(o, n);
          },
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
Gl.displayName = Vl;
var Li = "MenuItemIndicator", [Yl, Om] = Bt(
  Li,
  { checked: !1 }
), Xl = b.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, forceMount: r, ...o } = e, i = Om(Li, n);
    return /* @__PURE__ */ k.jsx(
      qn,
      {
        present: r || Ar(i.checked) || i.checked === !0,
        children: /* @__PURE__ */ k.jsx(
          Oe.span,
          {
            ...o,
            ref: t,
            "data-state": Ii(i.checked)
          }
        )
      }
    );
  }
);
Xl.displayName = Li;
var Nm = "MenuSeparator", Zl = b.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ k.jsx(
      Oe.div,
      {
        role: "separator",
        "aria-orientation": "horizontal",
        ...r,
        ref: t
      }
    );
  }
);
Zl.displayName = Nm;
var Cm = "MenuArrow", Jl = b.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e, o = to(n);
    return /* @__PURE__ */ k.jsx(rh, { ...o, ...r, ref: t });
  }
);
Jl.displayName = Cm;
var Tm = "MenuSub", [yx, Ql] = Bt(Tm), Cn = "MenuSubTrigger", ec = b.forwardRef(
  (e, t) => {
    const n = zt(Cn, e.__scopeMenu), r = Gn(Cn, e.__scopeMenu), o = Ql(Cn, e.__scopeMenu), i = ki(Cn, e.__scopeMenu), a = b.useRef(null), { pointerGraceTimerRef: s, onPointerGraceIntentChange: l } = i, c = { __scopeMenu: e.__scopeMenu }, u = b.useCallback(() => {
      a.current && window.clearTimeout(a.current), a.current = null;
    }, []);
    return b.useEffect(() => u, [u]), b.useEffect(() => {
      const d = s.current;
      return () => {
        window.clearTimeout(d), l(null);
      };
    }, [s, l]), /* @__PURE__ */ k.jsx(Ti, { asChild: !0, ...c, children: /* @__PURE__ */ k.jsx(
      Wl,
      {
        id: o.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": n.open,
        "aria-controls": o.contentId,
        "data-state": rc(n.open),
        ...e,
        ref: Yr(t, o.onTriggerChange),
        onClick: (d) => {
          var h;
          (h = e.onClick) == null || h.call(e, d), !(e.disabled || d.defaultPrevented) && (d.currentTarget.focus(), n.open || n.onOpenChange(!0));
        },
        onPointerMove: Q(
          e.onPointerMove,
          Mn((d) => {
            i.onItemEnter(d), !d.defaultPrevented && !e.disabled && !n.open && !a.current && (i.onPointerGraceIntentChange(null), a.current = window.setTimeout(() => {
              n.onOpenChange(!0), u();
            }, 100));
          })
        ),
        onPointerLeave: Q(
          e.onPointerLeave,
          Mn((d) => {
            var h, p;
            u();
            const m = (h = n.content) == null ? void 0 : h.getBoundingClientRect();
            if (m) {
              const v = (p = n.content) == null ? void 0 : p.dataset.side, f = v === "right", y = f ? -5 : 5, S = m[f ? "left" : "right"], C = m[f ? "right" : "left"];
              i.onPointerGraceIntentChange({
                area: [
                  // Apply a bleed on clientX to ensure that our exit point is
                  // consistently within polygon bounds
                  { x: d.clientX + y, y: d.clientY },
                  { x: S, y: m.top },
                  { x: C, y: m.top },
                  { x: C, y: m.bottom },
                  { x: S, y: m.bottom }
                ],
                side: v
              }), window.clearTimeout(s.current), s.current = window.setTimeout(
                () => i.onPointerGraceIntentChange(null),
                300
              );
            } else {
              if (i.onTriggerLeave(d), d.defaultPrevented) return;
              i.onPointerGraceIntentChange(null);
            }
          })
        ),
        onKeyDown: Q(e.onKeyDown, (d) => {
          var h;
          const p = i.searchRef.current !== "";
          e.disabled || p && d.key === " " || um[r.dir].includes(d.key) && (n.onOpenChange(!0), (h = n.content) == null || h.focus(), d.preventDefault());
        })
      }
    ) });
  }
);
ec.displayName = Cn;
var tc = "MenuSubContent", nc = b.forwardRef(
  (e, t) => {
    const n = $l(ze, e.__scopeMenu), { forceMount: r = n.forceMount, ...o } = e, i = zt(ze, e.__scopeMenu), a = Gn(ze, e.__scopeMenu), s = Ql(tc, e.__scopeMenu), l = b.useRef(null), c = je(t, l);
    return /* @__PURE__ */ k.jsx(Fn.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ k.jsx(qn, { present: r || i.open, children: /* @__PURE__ */ k.jsx(Fn.Slot, { scope: e.__scopeMenu, children: /* @__PURE__ */ k.jsx(
      Pi,
      {
        id: s.contentId,
        "aria-labelledby": s.triggerId,
        ...o,
        ref: c,
        align: "start",
        side: a.dir === "rtl" ? "left" : "right",
        disableOutsidePointerEvents: !1,
        disableOutsideScroll: !1,
        trapFocus: !1,
        onOpenAutoFocus: (u) => {
          var d;
          a.isUsingKeyboardRef.current && ((d = l.current) == null || d.focus()), u.preventDefault();
        },
        onCloseAutoFocus: (u) => u.preventDefault(),
        onFocusOutside: Q(e.onFocusOutside, (u) => {
          u.target !== s.trigger && i.onOpenChange(!1);
        }),
        onEscapeKeyDown: Q(e.onEscapeKeyDown, (u) => {
          a.onClose(), u.preventDefault();
        }),
        onKeyDown: Q(e.onKeyDown, (u) => {
          var d;
          const h = u.currentTarget.contains(u.target), p = dm[a.dir].includes(u.key);
          h && p && (i.onOpenChange(!1), (d = s.trigger) == null || d.focus(), u.preventDefault());
        })
      }
    ) }) }) });
  }
);
nc.displayName = tc;
function rc(e) {
  return e ? "open" : "closed";
}
function Ar(e) {
  return e === "indeterminate";
}
function Ii(e) {
  return Ar(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
function jm(e) {
  const t = document.activeElement;
  for (const n of e)
    if (n === t || (n.focus(), document.activeElement !== t)) return;
}
function km(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
function Pm(e, t, n) {
  const r = t.length > 1 && Array.from(t).every((s) => s === t[0]) ? t[0] : t, o = n ? e.indexOf(n) : -1;
  let i = km(e, Math.max(o, 0));
  r.length === 1 && (i = i.filter((s) => s !== n));
  const a = i.find(
    (s) => s.toLowerCase().startsWith(r.toLowerCase())
  );
  return a !== n ? a : void 0;
}
function Am(e, t) {
  const { x: n, y: r } = e;
  let o = !1;
  for (let i = 0, a = t.length - 1; i < t.length; a = i++) {
    const s = t[i].x, l = t[i].y, c = t[a].x, u = t[a].y;
    l > r != u > r && n < (c - s) * (r - l) / (u - l) + s && (o = !o);
  }
  return o;
}
function Lm(e, t) {
  if (!t) return !1;
  const n = { x: e.clientX, y: e.clientY };
  return Am(n, t);
}
function Mn(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
var Im = Ml, Dm = Ti, Fm = Bl, Mm = zl, $m = Ai, Bm = Ul, zm = no, Um = Hl, Wm = ql, Hm = Gl, Km = Xl, qm = Zl, Vm = Jl, Gm = ec, Ym = nc, Di = "DropdownMenu", [Xm, wx] = Hs(
  Di,
  [Dl]
), Ne = Dl(), [Zm, oc] = Xm(Di), ic = (e) => {
  const {
    __scopeDropdownMenu: t,
    children: n,
    dir: r,
    open: o,
    defaultOpen: i,
    onOpenChange: a,
    modal: s = !0
  } = e, l = Ne(t), c = b.useRef(null), [u = !1, d] = Ks({
    prop: o,
    defaultProp: i,
    onChange: a
  });
  return /* @__PURE__ */ k.jsx(
    Zm,
    {
      scope: t,
      triggerId: qo(),
      triggerRef: c,
      contentId: qo(),
      open: u,
      onOpenChange: d,
      onOpenToggle: b.useCallback(() => d((h) => !h), [d]),
      modal: s,
      children: /* @__PURE__ */ k.jsx(Im, { ...l, open: u, onOpenChange: d, dir: r, modal: s, children: n })
    }
  );
};
ic.displayName = Di;
var ac = "DropdownMenuTrigger", sc = b.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, disabled: r = !1, ...o } = e, i = oc(ac, n), a = Ne(n);
    return /* @__PURE__ */ k.jsx(Dm, { asChild: !0, ...a, children: /* @__PURE__ */ k.jsx(
      Oe.button,
      {
        type: "button",
        id: i.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": i.open,
        "aria-controls": i.open ? i.contentId : void 0,
        "data-state": i.open ? "open" : "closed",
        "data-disabled": r ? "" : void 0,
        disabled: r,
        ...o,
        ref: Yr(t, i.triggerRef),
        onPointerDown: Q(e.onPointerDown, (s) => {
          !r && s.button === 0 && s.ctrlKey === !1 && (i.onOpenToggle(), i.open || s.preventDefault());
        }),
        onKeyDown: Q(e.onKeyDown, (s) => {
          r || (["Enter", " "].includes(s.key) && i.onOpenToggle(), s.key === "ArrowDown" && i.onOpenChange(!0), ["Enter", " ", "ArrowDown"].includes(s.key) && s.preventDefault());
        })
      }
    ) });
  }
);
sc.displayName = ac;
var Jm = "DropdownMenuPortal", lc = (e) => {
  const { __scopeDropdownMenu: t, ...n } = e, r = Ne(t);
  return /* @__PURE__ */ k.jsx(Fm, { ...r, ...n });
};
lc.displayName = Jm;
var cc = "DropdownMenuContent", uc = b.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = oc(cc, n), i = Ne(n), a = b.useRef(!1);
    return /* @__PURE__ */ k.jsx(
      Mm,
      {
        id: o.contentId,
        "aria-labelledby": o.triggerId,
        ...i,
        ...r,
        ref: t,
        onCloseAutoFocus: Q(e.onCloseAutoFocus, (s) => {
          var l;
          a.current || (l = o.triggerRef.current) == null || l.focus(), a.current = !1, s.preventDefault();
        }),
        onInteractOutside: Q(e.onInteractOutside, (s) => {
          const l = s.detail.originalEvent, c = l.button === 0 && l.ctrlKey === !0, u = l.button === 2 || c;
          (!o.modal || u) && (a.current = !0);
        }),
        style: {
          ...e.style,
          "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
          "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
          "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
uc.displayName = cc;
var Qm = "DropdownMenuGroup", dc = b.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = Ne(n);
    return /* @__PURE__ */ k.jsx($m, { ...o, ...r, ref: t });
  }
);
dc.displayName = Qm;
var ev = "DropdownMenuLabel", fc = b.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = Ne(n);
    return /* @__PURE__ */ k.jsx(Bm, { ...o, ...r, ref: t });
  }
);
fc.displayName = ev;
var tv = "DropdownMenuItem", pc = b.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = Ne(n);
    return /* @__PURE__ */ k.jsx(zm, { ...o, ...r, ref: t });
  }
);
pc.displayName = tv;
var nv = "DropdownMenuCheckboxItem", rv = b.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Ne(n);
  return /* @__PURE__ */ k.jsx(Um, { ...o, ...r, ref: t });
});
rv.displayName = nv;
var ov = "DropdownMenuRadioGroup", iv = b.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Ne(n);
  return /* @__PURE__ */ k.jsx(Wm, { ...o, ...r, ref: t });
});
iv.displayName = ov;
var av = "DropdownMenuRadioItem", sv = b.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Ne(n);
  return /* @__PURE__ */ k.jsx(Hm, { ...o, ...r, ref: t });
});
sv.displayName = av;
var lv = "DropdownMenuItemIndicator", cv = b.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Ne(n);
  return /* @__PURE__ */ k.jsx(Km, { ...o, ...r, ref: t });
});
cv.displayName = lv;
var uv = "DropdownMenuSeparator", hc = b.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Ne(n);
  return /* @__PURE__ */ k.jsx(qm, { ...o, ...r, ref: t });
});
hc.displayName = uv;
var dv = "DropdownMenuArrow", fv = b.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = Ne(n);
    return /* @__PURE__ */ k.jsx(Vm, { ...o, ...r, ref: t });
  }
);
fv.displayName = dv;
var pv = "DropdownMenuSubTrigger", hv = b.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Ne(n);
  return /* @__PURE__ */ k.jsx(Gm, { ...o, ...r, ref: t });
});
hv.displayName = pv;
var mv = "DropdownMenuSubContent", vv = b.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Ne(n);
  return /* @__PURE__ */ k.jsx(
    Ym,
    {
      ...o,
      ...r,
      ref: t,
      style: {
        ...e.style,
        "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
        "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
        "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
vv.displayName = mv;
var gv = ic, bv = sc, yv = lc, wv = uc, mc = fc, xv = pc, Ev = hc, vc = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function n() {
      for (var i = "", a = 0; a < arguments.length; a++) {
        var s = arguments[a];
        s && (i = o(i, r(s)));
      }
      return i;
    }
    function r(i) {
      if (typeof i == "string" || typeof i == "number")
        return i;
      if (typeof i != "object")
        return "";
      if (Array.isArray(i))
        return n.apply(null, i);
      if (i.toString !== Object.prototype.toString && !i.toString.toString().includes("[native code]"))
        return i.toString();
      var a = "";
      for (var s in i)
        t.call(i, s) && i[s] && (a = o(a, s));
      return a;
    }
    function o(i, a) {
      return a ? i ? i + " " + a : i + a : i;
    }
    e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
  })();
})(vc);
var Sv = vc.exports;
const sn = /* @__PURE__ */ hf(Sv), gc = xt(null), _v = () => {
  const e = rt(gc);
  if (e == null)
    throw new Error("useDropdownMenuContext must be used within a DropdownMenu.Provider");
  return e;
}, Rv = We(
  ({ children: e, splitButton: t = !1, ...n }, r) => {
    const o = Be(
      () => ({
        splitButton: t
      }),
      [t]
    );
    return /* @__PURE__ */ k.jsx(gc.Provider, { value: o, children: /* @__PURE__ */ k.jsx(gv, { ...n, children: /* @__PURE__ */ k.jsx(
      "div",
      {
        ref: r,
        className: sn(n.className, {
          "btn-group": t
        }),
        children: e
      }
    ) }) });
  }
), Ov = We(
  ({ children: e, showCaret: t = !0, ...n }, r) => {
    const { splitButton: o } = _v();
    return /* @__PURE__ */ k.jsx(
      bv,
      {
        ref: r,
        asChild: !0,
        ...n,
        className: sn(n.className, {
          "dropdown-toggle": t,
          "dropdown-toggle-split": o
        }),
        children: e
      }
    );
  }
), Nv = We(({ children: e, ...t }, n) => /* @__PURE__ */ k.jsx(yv, { children: /* @__PURE__ */ k.jsx(
  wv,
  {
    ref: n,
    align: "start",
    ...t,
    className: sn("dropdown-menu d-block position-static", t.className),
    children: e
  }
) })), Cv = We(
  ({ children: e, ...t }, n) => /* @__PURE__ */ k.jsx(
    xv,
    {
      ref: n,
      asChild: !0,
      ...t,
      className: sn("dropdown-item rounded-0", t.className),
      children: qr(e) ? e : /* @__PURE__ */ k.jsx("div", { children: e })
    }
  )
), Tv = We(
  ({ children: e, ...t }, n) => /* @__PURE__ */ k.jsx(mc, { ref: n, asChild: !0, ...t, children: qr(e) && !Ws.isFragment(e) ? e : /* @__PURE__ */ k.jsx("div", { className: "py-1 px-4 text-muted mb-0 small", children: e }) })
), jv = We(({ children: e, ...t }, n) => /* @__PURE__ */ k.jsx(
  mc,
  {
    ref: n,
    asChild: !0,
    ...t,
    className: sn("dropdown-header", t.className),
    children: qr(e) && !Ws.isFragment(e) ? e : /* @__PURE__ */ k.jsx("div", { children: e })
  }
)), kv = We(({ children: e, ...t }, n) => /* @__PURE__ */ k.jsx(
  Ev,
  {
    ref: n,
    ...t,
    className: sn(t.className, "dropdown-divider"),
    children: e
  }
)), Ve = Object.assign(Rv, {
  Trigger: Ov,
  Content: Nv,
  Item: Cv,
  Group: dc,
  Label: Tv,
  Separator: kv,
  Heading: jv
}), Pv = ({
  event: e,
  id: t = "related-results-dropdown",
  buttonLabel: n = "Results by year",
  menuItemLabel: r = "%year% results",
  addMarginRight: o = !1
  //this is to add a margin if there is a button to the right
}) => {
  const { relatedEvents: i } = e, a = e && i ? i.map(({ year: l, resultsUrl: c }) => ({ year: l, resultsUrl: c })).reverse() : [], s = window.innerWidth < 576;
  return a.length === 0 ? null : /* @__PURE__ */ R.jsxs(Ve, { className: `flex-grow-1 ${o ? "mr-2" : ""}`, children: [
    /* @__PURE__ */ R.jsx(Ve.Trigger, { children: /* @__PURE__ */ R.jsx(
      Wo,
      {
        className: `${s ? "btn-sm" : ""} text-nowrap w-100 text-primary`,
        id: t,
        variant: "secondary",
        children: n
      }
    ) }),
    /* @__PURE__ */ R.jsx(Ve.Content, { children: a.map((l, c) => /* @__PURE__ */ R.jsx(Ve.Item, { children: /* @__PURE__ */ R.jsx("a", { href: l.resultsUrl, children: r.replace("%year%", l.year) }) }, `${c}_${l.year}`)) })
  ] });
};
Pv.propTypes = {
  event: x.shape({
    relatedEvents: x.arrayOf(
      x.shape({
        year: x.number,
        resultsUrl: x.string
      })
    )
  }),
  id: x.string,
  buttonLabel: x.string,
  menuItemLabel: x.string,
  addMarginRight: x.bool
};
var vr = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function bc(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var yc = { exports: {} }, bn = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Wa;
function Av() {
  if (Wa) return bn;
  Wa = 1;
  var e = z, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function a(s, l, c) {
    var u, d = {}, h = null, p = null;
    c !== void 0 && (h = "" + c), l.key !== void 0 && (h = "" + l.key), l.ref !== void 0 && (p = l.ref);
    for (u in l) r.call(l, u) && !i.hasOwnProperty(u) && (d[u] = l[u]);
    if (s && s.defaultProps) for (u in l = s.defaultProps, l) d[u] === void 0 && (d[u] = l[u]);
    return { $$typeof: t, type: s, key: h, ref: p, props: d, _owner: o.current };
  }
  return bn.Fragment = n, bn.jsx = a, bn.jsxs = a, bn;
}
yc.exports = Av();
var D = yc.exports, wc = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function n() {
      for (var i = "", a = 0; a < arguments.length; a++) {
        var s = arguments[a];
        s && (i = o(i, r(s)));
      }
      return i;
    }
    function r(i) {
      if (typeof i == "string" || typeof i == "number")
        return i;
      if (typeof i != "object")
        return "";
      if (Array.isArray(i))
        return n.apply(null, i);
      if (i.toString !== Object.prototype.toString && !i.toString.toString().includes("[native code]"))
        return i.toString();
      var a = "";
      for (var s in i)
        t.call(i, s) && i[s] && (a = o(a, s));
      return a;
    }
    function o(i, a) {
      return a ? i ? i + " " + a : i + a : i;
    }
    e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
  })();
})(wc);
var Lv = wc.exports;
const pe = /* @__PURE__ */ bc(Lv), xc = z.forwardRef(
  ({ children: e, className: t, disabled: n, formGroup: r, ...o }, i) => {
    const a = pe(t, {
      "form-group": r
    });
    return /* @__PURE__ */ D.jsx("fieldset", { ...o, ref: i, className: a, disabled: n, children: e });
  }
);
z.forwardRef(
  ({ children: e, className: t, disabled: n, inline: r, noValidate: o, validated: i, ...a }, s) => {
    const l = pe(t, "form", {
      "form-inline": r,
      "was-validated": i,
      "needs-validation": o
    });
    return /* @__PURE__ */ D.jsx("form", { ...a, className: l, noValidate: o, ref: s, children: /* @__PURE__ */ D.jsx(xc, { disabled: n, children: e }) });
  }
);
const Et = z.forwardRef(
  ({
    children: e,
    className: t,
    invalid: n,
    onBlur: r = () => {
    },
    onChange: o = () => {
    },
    tag: i = "input",
    valid: a,
    ...s
  }, l) => z.createElement(
    i,
    {
      ...s,
      className: pe(t, {
        "is-valid": a && !n,
        "is-invalid": n && !a
      }),
      onBlur: (c) => {
        c.stopPropagation(), r((c == null ? void 0 : c.target).value, c);
      },
      onChange: (c) => {
        c.stopPropagation(), o((c == null ? void 0 : c.target).value, c);
      },
      ref: l
    },
    e
  )
), Ec = ({
  className: e,
  title: t = "Required",
  ...n
}) => {
  const r = pe(e, "required", "text-danger", "ml-1");
  return /* @__PURE__ */ D.jsx("span", { ...n, className: r, title: t, children: "*" });
}, Iv = z.forwardRef(
  ({ children: e, className: t, hidden: n, required: r, ...o }, i) => {
    const a = pe(t, {
      "sr-only": n
    });
    return /* @__PURE__ */ D.jsxs("legend", { ...o, ref: i, className: a, children: [
      e,
      r && /* @__PURE__ */ D.jsx(Ec, {})
    ] });
  }
), Dv = ({
  children: e,
  className: t,
  tag: n = "p",
  tooltip: r = !1,
  type: o = "help",
  ...i
}) => z.createElement(
  n,
  {
    ...i,
    className: pe(t, {
      "small form-text text-muted": o === "help",
      "valid-feedback mb-0": o === "success" && !r,
      "invalid-feedback mb-0": o === "error" && !r,
      "valid-tooltip": o === "success" && r,
      "invalid-tooltip": o === "error" && r
    })
  },
  e
), Fv = ({
  className: e,
  children: t,
  inline: n = !1,
  stacked: r = !1,
  type: o = "radio",
  legend: i,
  ...a
}) => {
  const s = Be(
    () => ({
      type: o,
      stacked: r
    }),
    [o, r]
  );
  return /* @__PURE__ */ D.jsx(Sc.Provider, { value: s, children: /* @__PURE__ */ D.jsxs(xc, { formGroup: !0, children: [
    /* @__PURE__ */ D.jsx(Iv, { children: i }),
    /* @__PURE__ */ D.jsx("div", { className: n ? "advanced-choice__wrapper--inline" : "", ...a, children: t })
  ] }) });
}, Sc = xt(null), Mv = () => {
  const e = rt(Sc);
  if (e == null)
    throw new Error("useChoiceContext must be used within a ChoiceContext.Provider");
  return e;
}, $v = z.forwardRef(
  ({ className: e, description: t, imageUrl: n, label: r, id: o, ...i }, a) => {
    const { stacked: s, type: l = "radio" } = Mv(), c = pe(e, "advanced-choice", s && "advanced-choice--stacked");
    return /* @__PURE__ */ D.jsxs("div", { className: c, children: [
      /* @__PURE__ */ D.jsx(
        Et,
        {
          ...i,
          id: o,
          className: "advanced-choice__input",
          ref: a,
          type: l
        }
      ),
      /* @__PURE__ */ D.jsxs("label", { className: "advanced-choice__label form-check-label", htmlFor: o, children: [
        r,
        /* @__PURE__ */ D.jsx(Dv, { className: "my-0", children: t })
      ] }),
      n && /* @__PURE__ */ D.jsx("img", { src: n, alt: "", className: "advanced-choice__image" })
    ] });
  }
);
Object.assign(Fv, {
  Item: $v
});
z.forwardRef(
  ({ children: e, className: t, id: n, label: r, inline: o = !1, indeterminate: i = !1, ...a }, s) => {
    const l = pe(t, "form-check", o && "form-check-inline"), c = z.useRef({
      innerRef: null,
      outerRef: null
    });
    return z.useEffect(() => {
      c.current.innerRef && (c.current.innerRef.indeterminate = i);
    }, [i]), /* @__PURE__ */ D.jsxs("div", { className: l, children: [
      /* @__PURE__ */ D.jsx(
        Et,
        {
          ...a,
          id: n,
          ref: (u) => {
            c.current = {
              innerRef: u,
              outerRef: s
            };
          },
          type: "checkbox",
          className: "form-check-input"
        }
      ),
      /* @__PURE__ */ D.jsx("label", { className: "form-check-label", htmlFor: n, children: r }),
      e
    ] });
  }
);
var ro = /* @__PURE__ */ ((e) => (e.primary = "primary", e.secondary = "secondary", e.success = "success", e.danger = "danger", e.warning = "warning", e.info = "info", e.light = "light", e.dark = "dark", e.link = "link", e.unstyled = "unstyled", e.text = "text", e))(ro || {}), jn = /* @__PURE__ */ ((e) => (e.xsmall = "xs", e.small = "sm", e.medium = "md", e.large = "lg", e.xlarge = "xl", e))(jn || {}), Tn = /* @__PURE__ */ ((e) => (e.brand = "brand", e.regular = "regular", e.solid = "solid", e))(Tn || {});
const _c = ({
  append: e,
  appendClassName: t,
  children: n,
  className: r,
  feedback: o,
  matching: i,
  prepend: a,
  prependClassName: s,
  size: l = jn.medium,
  ...c
}) => {
  const u = pe(r, "input-group", {
    [`input-group-${l}`]: l,
    "input-group--matching-icon": i
  });
  return /* @__PURE__ */ D.jsxs("div", { ...c, className: u, children: [
    a && /* @__PURE__ */ D.jsx("span", { className: pe(s, "input-group-prepend"), children: a }),
    n,
    e && /* @__PURE__ */ D.jsx("span", { className: pe(t, "input-group-append"), children: e }),
    o
  ] });
}, Bv = z.forwardRef(
  ({ children: e, className: t, hidden: n, htmlFor: r, required: o = !1, ...i }, a) => {
    const s = pe(t, "form-label", {
      "sr-only": n
    });
    return /* @__PURE__ */ D.jsxs("label", { ...i, ref: a, className: s, htmlFor: r, children: [
      e,
      o && /* @__PURE__ */ D.jsx(Ec, {})
    ] });
  }
), Fi = z.forwardRef(
  ({ className: e, plaintext: t, size: n, ...r }, o) => {
    const i = pe(e, {
      "form-control": !t,
      "form-control-plaintext": t,
      [`form-control-${n}`]: n
    });
    return /* @__PURE__ */ D.jsx(Et, { ...r, className: i, ref: o });
  }
);
z.forwardRef(
  ({
    id: e,
    label: t,
    onChange: n = () => {
    },
    required: r = !1,
    value: o
  }, i) => /* @__PURE__ */ D.jsxs(z.Fragment, { children: [
    /* @__PURE__ */ D.jsx(Bv, { htmlFor: `${e}-color`, id: `${e}-label`, required: r, children: t }),
    /* @__PURE__ */ D.jsx(
      _c,
      {
        prepend: /* @__PURE__ */ D.jsx(
          Et,
          {
            id: `${e}-color`,
            type: "color",
            onChange: (a) => {
              n(a);
            },
            onInput: (a) => {
              n(a.target.value);
            },
            className: "form-control",
            style: {
              width: "40px",
              padding: "1px 2px",
              borderTopRightRadius: 0,
              borderBottomRightRadius: 0
            },
            value: o,
            required: r
          }
        ),
        children: /* @__PURE__ */ D.jsx(
          Fi,
          {
            ref: i,
            id: `${e}-text`,
            "aria-labelledby": `${e}-label`,
            value: o,
            maxLength: 7,
            pattern: "#[0-9A-Fa-f]{6}",
            title: "#FFFFFF",
            onChange: (a) => {
              n(a);
            }
          }
        )
      }
    )
  ] })
);
const Lr = {
  prefix: String(Math.round(Math.random() * 1e10)),
  current: 0
}, Rc = /* @__PURE__ */ z.createContext(Lr), zv = /* @__PURE__ */ z.createContext(!1);
let Uv = !!(typeof window < "u" && window.document && window.document.createElement), Po = /* @__PURE__ */ new WeakMap();
function Wv(e = !1) {
  let t = rt(Rc), n = ae(null);
  if (n.current === null && !e) {
    var r, o;
    let i = (o = z.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || o === void 0 || (r = o.ReactCurrentOwner) === null || r === void 0 ? void 0 : r.current;
    if (i) {
      let a = Po.get(i);
      a == null ? Po.set(i, {
        id: t.current,
        state: i.memoizedState
      }) : i.memoizedState !== a.state && (t.current = a.id, Po.delete(i));
    }
    n.current = ++t.current;
  }
  return n.current;
}
function Hv(e) {
  let t = rt(Rc);
  t === Lr && !Uv && console.warn("When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.");
  let n = Wv(!!e), r = `react-aria${t.prefix}`;
  return e || `${r}-${n}`;
}
function Kv(e) {
  let t = z.useId(), [n] = Ue(Yv()), r = n ? "react-aria" : `react-aria${Lr.prefix}`;
  return e || `${r}-${t}`;
}
z.useId;
function qv() {
  return !1;
}
function Vv() {
  return !0;
}
function Gv(e) {
  return () => {
  };
}
function Yv() {
  return typeof z.useSyncExternalStore == "function" ? z.useSyncExternalStore(Gv, qv, Vv) : rt(zv);
}
if (typeof HTMLTemplateElement < "u") {
  const e = Object.getOwnPropertyDescriptor(Node.prototype, "firstChild").get;
  Object.defineProperty(HTMLTemplateElement.prototype, "firstChild", {
    configurable: !0,
    enumerable: !0,
    get: function() {
      return this.dataset.reactAriaHidden ? this.content.firstChild : e.call(this);
    }
  });
}
typeof DocumentFragment < "u" && new DocumentFragment();
typeof document < "u" && z.useLayoutEffect;
const oo = (e) => {
  var t;
  return (t = e == null ? void 0 : e.ownerDocument) !== null && t !== void 0 ? t : document;
}, ei = (e) => e && "window" in e && e.window === e ? e : oo(e).defaultView || window;
function Xv(e) {
  var t;
  return typeof window > "u" || window.navigator == null ? !1 : ((t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.brands.some((n) => e.test(n.brand))) || e.test(window.navigator.userAgent);
}
function Zv(e) {
  var t;
  return typeof window < "u" && window.navigator != null ? e.test(((t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.platform) || window.navigator.platform) : !1;
}
function Oc(e) {
  let t = null;
  return () => (t == null && (t = e()), t);
}
const Jv = Oc(function() {
  return Zv(/^Mac/i);
}), Qv = Oc(function() {
  return Xv(/Android/i);
});
let yn = /* @__PURE__ */ new Map(), Ha = /* @__PURE__ */ new Set();
function Ka() {
  if (typeof window > "u") return;
  function e(r) {
    return "propertyName" in r;
  }
  let t = (r) => {
    if (!e(r) || !r.target) return;
    let o = yn.get(r.target);
    o || (o = /* @__PURE__ */ new Set(), yn.set(r.target, o), r.target.addEventListener("transitioncancel", n, {
      once: !0
    })), o.add(r.propertyName);
  }, n = (r) => {
    if (!e(r) || !r.target) return;
    let o = yn.get(r.target);
    if (o && (o.delete(r.propertyName), o.size === 0 && (r.target.removeEventListener("transitioncancel", n), yn.delete(r.target)), yn.size === 0)) {
      for (let i of Ha) i();
      Ha.clear();
    }
  };
  document.body.addEventListener("transitionrun", t), document.body.addEventListener("transitionend", n);
}
typeof document < "u" && (document.readyState !== "loading" ? Ka() : document.addEventListener("DOMContentLoaded", Ka));
function eg(e) {
  return e.mozInputSource === 0 && e.isTrusted ? !0 : Qv() && e.pointerType ? e.type === "click" && e.buttons === 1 : e.detail === 0 && !e.pointerType;
}
let tg = /* @__PURE__ */ new Set(), kn = /* @__PURE__ */ new Map(), Ft = !1, ti = !1;
function Mi(e, t) {
  for (let n of tg) n(e, t);
}
function ng(e) {
  return !(e.metaKey || !Jv() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function Ir(e) {
  Ft = !0, ng(e) && Mi("keyboard", e);
}
function Me(e) {
  (e.type === "mousedown" || e.type === "pointerdown") && (Ft = !0, Mi("pointer", e));
}
function Nc(e) {
  eg(e) && (Ft = !0);
}
function Cc(e) {
  e.target === window || e.target === document || (!Ft && !ti && Mi("virtual", e), Ft = !1, ti = !1);
}
function Tc() {
  Ft = !1, ti = !0;
}
function qa(e) {
  if (typeof window > "u" || kn.get(ei(e))) return;
  const t = ei(e), n = oo(e);
  let r = t.HTMLElement.prototype.focus;
  t.HTMLElement.prototype.focus = function() {
    Ft = !0, r.apply(this, arguments);
  }, n.addEventListener("keydown", Ir, !0), n.addEventListener("keyup", Ir, !0), n.addEventListener("click", Nc, !0), t.addEventListener("focus", Cc, !0), t.addEventListener("blur", Tc, !1), typeof PointerEvent < "u" ? (n.addEventListener("pointerdown", Me, !0), n.addEventListener("pointermove", Me, !0), n.addEventListener("pointerup", Me, !0)) : (n.addEventListener("mousedown", Me, !0), n.addEventListener("mousemove", Me, !0), n.addEventListener("mouseup", Me, !0)), t.addEventListener("beforeunload", () => {
    jc(e);
  }, {
    once: !0
  }), kn.set(t, {
    focus: r
  });
}
const jc = (e, t) => {
  const n = ei(e), r = oo(e);
  t && r.removeEventListener("DOMContentLoaded", t), kn.has(n) && (n.HTMLElement.prototype.focus = kn.get(n).focus, r.removeEventListener("keydown", Ir, !0), r.removeEventListener("keyup", Ir, !0), r.removeEventListener("click", Nc, !0), n.removeEventListener("focus", Cc, !0), n.removeEventListener("blur", Tc, !1), typeof PointerEvent < "u" ? (r.removeEventListener("pointerdown", Me, !0), r.removeEventListener("pointermove", Me, !0), r.removeEventListener("pointerup", Me, !0)) : (r.removeEventListener("mousedown", Me, !0), r.removeEventListener("mousemove", Me, !0), r.removeEventListener("mouseup", Me, !0)), kn.delete(n));
};
function rg(e) {
  const t = oo(e);
  let n;
  return t.readyState !== "loading" ? qa(e) : (n = () => {
    qa(e);
  }, t.addEventListener("DOMContentLoaded", n)), () => jc(e, n);
}
typeof document < "u" && rg();
const og = /* @__PURE__ */ new Set([
  "Arab",
  "Syrc",
  "Samr",
  "Mand",
  "Thaa",
  "Mend",
  "Nkoo",
  "Adlm",
  "Rohg",
  "Hebr"
]), ig = /* @__PURE__ */ new Set([
  "ae",
  "ar",
  "arc",
  "bcc",
  "bqi",
  "ckb",
  "dv",
  "fa",
  "glk",
  "he",
  "ku",
  "mzn",
  "nqo",
  "pnb",
  "ps",
  "sd",
  "ug",
  "ur",
  "yi"
]);
function ag(e) {
  if (Intl.Locale) {
    let n = new Intl.Locale(e).maximize(), r = typeof n.getTextInfo == "function" ? n.getTextInfo() : n.textInfo;
    if (r) return r.direction === "rtl";
    if (n.script) return og.has(n.script);
  }
  let t = e.split("-")[0];
  return ig.has(t);
}
const sg = Symbol.for("react-aria.i18n.locale");
function lg() {
  let e = typeof window < "u" && window[sg] || typeof navigator < "u" && (navigator.language || navigator.userLanguage) || "en-US";
  try {
    Intl.DateTimeFormat.supportedLocalesOf([
      e
    ]);
  } catch {
    e = "en-US";
  }
  return {
    locale: e,
    direction: ag(e) ? "rtl" : "ltr"
  };
}
lg();
let cg = !1;
try {
  cg = new Intl.NumberFormat("de-DE", {
    signDisplay: "exceptZero"
  }).resolvedOptions().signDisplay === "exceptZero";
} catch {
}
let ug = !1;
try {
  ug = new Intl.NumberFormat("de-DE", {
    style: "unit",
    unit: "degree"
  }).resolvedOptions().style === "unit";
} catch {
}
xt({});
var kc = { exports: {} }, ne = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Va;
function dg() {
  if (Va) return ne;
  Va = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), a = Symbol.for("react.context"), s = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), p = Symbol.for("react.offscreen"), m;
  m = Symbol.for("react.module.reference");
  function v(f) {
    if (typeof f == "object" && f !== null) {
      var y = f.$$typeof;
      switch (y) {
        case e:
          switch (f = f.type, f) {
            case n:
            case o:
            case r:
            case c:
            case u:
              return f;
            default:
              switch (f = f && f.$$typeof, f) {
                case s:
                case a:
                case l:
                case h:
                case d:
                case i:
                  return f;
                default:
                  return y;
              }
          }
        case t:
          return y;
      }
    }
  }
  return ne.ContextConsumer = a, ne.ContextProvider = i, ne.Element = e, ne.ForwardRef = l, ne.Fragment = n, ne.Lazy = h, ne.Memo = d, ne.Portal = t, ne.Profiler = o, ne.StrictMode = r, ne.Suspense = c, ne.SuspenseList = u, ne.isAsyncMode = function() {
    return !1;
  }, ne.isConcurrentMode = function() {
    return !1;
  }, ne.isContextConsumer = function(f) {
    return v(f) === a;
  }, ne.isContextProvider = function(f) {
    return v(f) === i;
  }, ne.isElement = function(f) {
    return typeof f == "object" && f !== null && f.$$typeof === e;
  }, ne.isForwardRef = function(f) {
    return v(f) === l;
  }, ne.isFragment = function(f) {
    return v(f) === n;
  }, ne.isLazy = function(f) {
    return v(f) === h;
  }, ne.isMemo = function(f) {
    return v(f) === d;
  }, ne.isPortal = function(f) {
    return v(f) === t;
  }, ne.isProfiler = function(f) {
    return v(f) === o;
  }, ne.isStrictMode = function(f) {
    return v(f) === r;
  }, ne.isSuspense = function(f) {
    return v(f) === c;
  }, ne.isSuspenseList = function(f) {
    return v(f) === u;
  }, ne.isValidElementType = function(f) {
    return typeof f == "string" || typeof f == "function" || f === n || f === o || f === r || f === c || f === u || f === p || typeof f == "object" && f !== null && (f.$$typeof === h || f.$$typeof === d || f.$$typeof === i || f.$$typeof === a || f.$$typeof === l || f.$$typeof === m || f.getModuleId !== void 0);
  }, ne.typeOf = v, ne;
}
kc.exports = dg();
var fg = kc.exports;
const pg = /* @__PURE__ */ bc(fg), ni = ({
  className: e,
  family: t = Tn.solid,
  fixedWidth: n = !1,
  flip: r,
  icon: o,
  inverse: i = !1,
  pulse: a = !1,
  rotate: s,
  size: l,
  spin: c = !1,
  stack: u,
  title: d,
  variant: h,
  ...p
}) => {
  le(() => {
    console.warn(
      "This component is deprecated. Please use the individual icon imports from @fastnorth/react-cerberus/Icons."
    );
  }, []);
  const m = pe(e, `fa-${o}`, {
    fab: t === Tn.brand,
    far: t === Tn.regular,
    fas: t === Tn.solid,
    "fa-fw": n,
    "fa-spin": c,
    "fa-pulse": a,
    "fa-inverse": i,
    [`fa-${l}`]: l,
    [`fa-rotate-${s}`]: s,
    [`fa-flip-${r}`]: r,
    [`fa-stack-${u}`]: u,
    [`text-${h}`]: h
  });
  return /* @__PURE__ */ D.jsx(
    "span",
    {
      ...p,
      className: m,
      title: d,
      "aria-hidden": d ? void 0 : !0
    }
  );
}, hg = "_container_1g94w_1", mg = "_stack_1g94w_14", vg = "_circle_1g94w_24", gg = "_svg_1g94w_40", bg = "_spin_1g94w_47", wn = {
  container: hg,
  stack: mg,
  circle: vg,
  svg: gg,
  spin: bg
}, yg = ({ size: e = jn.small, variant: t, stack: n = !1, spin: r = !0, title: o, ...i }, a) => {
  le(() => {
    if (!Object.values(jn).includes(e))
      throw new Error(
        `You must provide a valid size from the SIZES enum: ${Object.keys(jn).join(", ")}`
      );
  }, [e]);
  const s = pe(i.className, wn.container, n && wn.stack, {
    [`text-${t}`]: !n && t !== "secondary",
    "text-gray-900": t === "secondary",
    [wn.spin]: r
  }), l = pe(wn.circle, {
    [`bg-${t}`]: n && t !== "secondary",
    "bg-gray-100": n && t === "secondary"
  }), c = { "--size": `var(--icon-size-${e})` };
  return /* @__PURE__ */ D.jsxs(
    "div",
    {
      className: s,
      style: c,
      title: o,
      "aria-hidden": o ? void 0 : !0,
      children: [
        n && /* @__PURE__ */ D.jsx("span", { className: l, "aria-hidden": "true", "data-circle": !0 }),
        /* @__PURE__ */ D.jsx(
          "svg",
          {
            viewBox: "0 0 512 512",
            xmlns: "http://www.w3.org/2000/svg",
            ...i,
            className: wn.svg,
            ref: a,
            children: /* @__PURE__ */ D.jsx(
              "path",
              {
                fill: "currentColor",
                d: "m304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm-368 48c0-26.51-21.49-48-48-48s-48 21.49-48 48 21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zm-294.156-294.156c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"
              }
            )
          }
        )
      ]
    }
  );
}, wg = We(yg), xg = vi(wg), $i = z.forwardRef(
  ({
    tag: e = "button",
    block: t = !1,
    btn: n = !0,
    busy: r = !1,
    children: o = null,
    className: i = null,
    disabled: a = !1,
    iconLeft: s = null,
    iconRight: l = null,
    outline: c = !1,
    size: u = null,
    text: d = null,
    type: h = e === "button" ? "button" : null,
    variant: p = ro.primary,
    href: m,
    ...v
  }, f) => {
    const y = pe(i, {
      btn: n,
      [`btn-outline-${p}`]: p && c,
      [`btn-${p}`]: n && p && !c,
      [`btn-${u}`]: u,
      "btn-block": t,
      disabled: a
    });
    return /* @__PURE__ */ D.jsx(D.Fragment, { children: z.createElement(
      e,
      {
        ...v,
        disabled: e === "button" && (a || r),
        href: e === "a" ? m : void 0,
        ref: f,
        type: h,
        className: y
      },
      r && /* @__PURE__ */ D.jsx(xg, { spin: !0, className: "mr-2" }),
      typeof s == "string" ? /* @__PURE__ */ D.jsx(ni, { icon: s, className: "mr-2", "data-testid": "button-icon-left" }) : s,
      d,
      typeof l == "string" ? /* @__PURE__ */ D.jsx(ni, { icon: l, className: "ml-2", "data-testid": "button-icon-right" }) : l,
      o
    ) });
  }
);
function Eg(e) {
  return (t) => {
    e.forEach((n) => {
      typeof n == "function" ? n(t) : n != null && (n.current = t);
    });
  };
}
const Sg = z.forwardRef((e, t) => {
  const {
    id: n,
    ariaDescribedBy: r,
    onChange: o = () => {
    },
    className: i,
    children: a,
    ...s
  } = e, [l, c] = z.useState([]), u = (m) => {
    const v = Array.from(m.target.files);
    c(v), o(v);
  }, d = () => {
    (h == null ? void 0 : h.current) != null && h.current.click();
  }, h = z.useRef(null);
  let p;
  return a == null ? p = /* @__PURE__ */ D.jsx(ri, { onActivateFileInput: d }) : (pg.isFragment(a) ? p = a.props.children : p = a, p.type === ri && (p = z.cloneElement(p, {
    onActivateFileInput: d
  }))), /* @__PURE__ */ D.jsxs(vt, { children: [
    s.multiple || l.length === 0 ? /* @__PURE__ */ D.jsx(_g, { className: i, onActivateFileInput: d, children: p }) : /* @__PURE__ */ D.jsx("div", { className: "mt-3", children: l.length === 1 && /* @__PURE__ */ D.jsxs(vt, { children: [
      /* @__PURE__ */ D.jsxs("div", { className: "d-flex align-items-center", children: [
        /* @__PURE__ */ D.jsx("strong", { className: "mr-2", children: "File:" }),
        /* @__PURE__ */ D.jsx(
          "span",
          {
            style: {
              wordBreak: "break-all"
            },
            children: l[0].name
          }
        )
      ] }),
      /* @__PURE__ */ D.jsx(
        $i,
        {
          variant: "link",
          className: "mt-1 ml-3 pl-4 text-nowrap",
          onClick: () => {
            o([]), d();
          },
          children: "Choose a different file"
        }
      )
    ] }) }),
    /* @__PURE__ */ D.jsx(
      "input",
      {
        ...s,
        className: "d-none",
        id: n,
        ref: Eg([h, t]),
        "aria-describedby": r,
        type: "file",
        onChange: u,
        "data-testid": "file"
      }
    )
  ] });
});
Object.assign(Sg, { Chooser: ri });
function _g({ className: e, onActivateFileInput: t, children: n }) {
  return /* @__PURE__ */ D.jsxs(
    "div",
    {
      className: pe(
        e,
        "form__file-upload",
        "position-relative",
        "text-center",
        "mt-3"
      ),
      children: [
        n,
        /* @__PURE__ */ D.jsx(
          $i,
          {
            className: "form__file-upload-input",
            onClick: () => {
              t();
            }
          }
        )
      ]
    }
  );
}
function ri({
  title: e = "Drop file here",
  conjunction: t = "or",
  callToActionText: n = "Choose from files",
  onActivateFileInput: r
}) {
  return /* @__PURE__ */ D.jsxs(vt, { children: [
    /* @__PURE__ */ D.jsx("span", { className: "h5 d-block mb-2", children: e }),
    /* @__PURE__ */ D.jsx("span", { className: "d-block mb-3", children: t }),
    /* @__PURE__ */ D.jsx(
      $i,
      {
        variant: ro.primary,
        onClick: () => {
          typeof r == "function" && r();
        },
        children: n
      }
    )
  ] });
}
z.forwardRef(
  ({ className: e, id: t, size: n, ...r }, o) => {
    const i = pe(e, "form-control", {
      [`form-control-${n}`]: n
    });
    return /* @__PURE__ */ D.jsx(Et, { ...r, className: i, id: t, ref: o, tag: "textarea" });
  }
);
function Jt(e, t, n) {
  let r = n.initialDeps ?? [], o;
  return () => {
    var i, a, s, l;
    let c;
    n.key && (i = n.debug) != null && i.call(n) && (c = Date.now());
    const u = e();
    if (!(u.length !== r.length || u.some((h, p) => r[p] !== h)))
      return o;
    r = u;
    let d;
    if (n.key && (a = n.debug) != null && a.call(n) && (d = Date.now()), o = t(...u), n.key && (s = n.debug) != null && s.call(n)) {
      const h = Math.round((Date.now() - c) * 100) / 100, p = Math.round((Date.now() - d) * 100) / 100, m = p / 16, v = (f, y) => {
        for (f = String(f); f.length < y; )
          f = " " + f;
        return f;
      };
      console.info(
        `%c⏱ ${v(p, 5)} /${v(h, 5)} ms`,
        `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(
          0,
          Math.min(120 - 120 * m, 120)
        )}deg 100% 31%);`,
        n == null ? void 0 : n.key
      );
    }
    return (l = n == null ? void 0 : n.onChange) == null || l.call(n, o), o;
  };
}
function Ao(e, t) {
  if (e === void 0)
    throw new Error("Unexpected undefined");
  return e;
}
const Rg = (e, t) => Math.abs(e - t) < 1, Og = (e, t, n) => {
  let r;
  return function(...o) {
    e.clearTimeout(r), r = e.setTimeout(() => t.apply(this, o), n);
  };
}, Ng = (e) => e, Cg = (e) => {
  const t = Math.max(e.startIndex - e.overscan, 0), n = Math.min(e.endIndex + e.overscan, e.count - 1), r = [];
  for (let o = t; o <= n; o++)
    r.push(o);
  return r;
}, Tg = (e, t) => {
  const n = e.scrollElement;
  if (!n)
    return;
  const r = e.targetWindow;
  if (!r)
    return;
  const o = (a) => {
    const { width: s, height: l } = a;
    t({ width: Math.round(s), height: Math.round(l) });
  };
  if (o(n.getBoundingClientRect()), !r.ResizeObserver)
    return () => {
    };
  const i = new r.ResizeObserver((a) => {
    const s = a[0];
    if (s != null && s.borderBoxSize) {
      const l = s.borderBoxSize[0];
      if (l) {
        o({ width: l.inlineSize, height: l.blockSize });
        return;
      }
    }
    o(n.getBoundingClientRect());
  });
  return i.observe(n, { box: "border-box" }), () => {
    i.unobserve(n);
  };
}, Ga = {
  passive: !0
}, jg = typeof window > "u" ? !0 : "onscrollend" in window, kg = (e, t) => {
  const n = e.scrollElement;
  if (!n)
    return;
  const r = e.targetWindow;
  if (!r)
    return;
  let o = 0;
  const i = jg ? () => {
  } : Og(
    r,
    () => {
      t(o, !1);
    },
    e.options.isScrollingResetDelay
  ), a = (c) => () => {
    const { horizontal: u, isRtl: d } = e.options;
    o = u ? n.scrollLeft * (d && -1 || 1) : n.scrollTop, i(), t(o, c);
  }, s = a(!0), l = a(!1);
  return l(), n.addEventListener("scroll", s, Ga), n.addEventListener("scrollend", l, Ga), () => {
    n.removeEventListener("scroll", s), n.removeEventListener("scrollend", l);
  };
}, Pg = (e, t, n) => {
  if (t != null && t.borderBoxSize) {
    const r = t.borderBoxSize[0];
    if (r)
      return Math.round(
        r[n.options.horizontal ? "inlineSize" : "blockSize"]
      );
  }
  return Math.round(
    e.getBoundingClientRect()[n.options.horizontal ? "width" : "height"]
  );
}, Ag = (e, {
  adjustments: t = 0,
  behavior: n
}, r) => {
  var o, i;
  const a = e + t;
  (i = (o = r.scrollElement) == null ? void 0 : o.scrollTo) == null || i.call(o, {
    [r.options.horizontal ? "left" : "top"]: a,
    behavior: n
  });
};
class Lg {
  constructor(t) {
    this.unsubs = [], this.scrollElement = null, this.targetWindow = null, this.isScrolling = !1, this.scrollToIndexTimeoutId = null, this.measurementsCache = [], this.itemSizeCache = /* @__PURE__ */ new Map(), this.pendingMeasuredCacheIndexes = [], this.scrollRect = null, this.scrollOffset = null, this.scrollDirection = null, this.scrollAdjustments = 0, this.elementsCache = /* @__PURE__ */ new Map(), this.observer = /* @__PURE__ */ (() => {
      let n = null;
      const r = () => n || (!this.targetWindow || !this.targetWindow.ResizeObserver ? null : n = new this.targetWindow.ResizeObserver((o) => {
        o.forEach((i) => {
          this._measureElement(i.target, i);
        });
      }));
      return {
        disconnect: () => {
          var o;
          (o = r()) == null || o.disconnect(), n = null;
        },
        observe: (o) => {
          var i;
          return (i = r()) == null ? void 0 : i.observe(o, { box: "border-box" });
        },
        unobserve: (o) => {
          var i;
          return (i = r()) == null ? void 0 : i.unobserve(o);
        }
      };
    })(), this.range = null, this.setOptions = (n) => {
      Object.entries(n).forEach(([r, o]) => {
        typeof o > "u" && delete n[r];
      }), this.options = {
        debug: !1,
        initialOffset: 0,
        overscan: 1,
        paddingStart: 0,
        paddingEnd: 0,
        scrollPaddingStart: 0,
        scrollPaddingEnd: 0,
        horizontal: !1,
        getItemKey: Ng,
        rangeExtractor: Cg,
        onChange: () => {
        },
        measureElement: Pg,
        initialRect: { width: 0, height: 0 },
        scrollMargin: 0,
        gap: 0,
        indexAttribute: "data-index",
        initialMeasurementsCache: [],
        lanes: 1,
        isScrollingResetDelay: 150,
        enabled: !0,
        isRtl: !1,
        ...n
      };
    }, this.notify = (n) => {
      var r, o;
      (o = (r = this.options).onChange) == null || o.call(r, this, n);
    }, this.maybeNotify = Jt(
      () => (this.calculateRange(), [
        this.isScrolling,
        this.range ? this.range.startIndex : null,
        this.range ? this.range.endIndex : null
      ]),
      (n) => {
        this.notify(n);
      },
      {
        key: !1,
        debug: () => this.options.debug,
        initialDeps: [
          this.isScrolling,
          this.range ? this.range.startIndex : null,
          this.range ? this.range.endIndex : null
        ]
      }
    ), this.cleanup = () => {
      this.unsubs.filter(Boolean).forEach((n) => n()), this.unsubs = [], this.observer.disconnect(), this.scrollElement = null, this.targetWindow = null;
    }, this._didMount = () => () => {
      this.cleanup();
    }, this._willUpdate = () => {
      var n;
      const r = this.options.enabled ? this.options.getScrollElement() : null;
      if (this.scrollElement !== r) {
        if (this.cleanup(), !r) {
          this.maybeNotify();
          return;
        }
        this.scrollElement = r, this.scrollElement && "ownerDocument" in this.scrollElement ? this.targetWindow = this.scrollElement.ownerDocument.defaultView : this.targetWindow = ((n = this.scrollElement) == null ? void 0 : n.window) ?? null, this.elementsCache.forEach((o) => {
          this.observer.observe(o);
        }), this._scrollToOffset(this.getScrollOffset(), {
          adjustments: void 0,
          behavior: void 0
        }), this.unsubs.push(
          this.options.observeElementRect(this, (o) => {
            this.scrollRect = o, this.maybeNotify();
          })
        ), this.unsubs.push(
          this.options.observeElementOffset(this, (o, i) => {
            this.scrollAdjustments = 0, this.scrollDirection = i ? this.getScrollOffset() < o ? "forward" : "backward" : null, this.scrollOffset = o, this.isScrolling = i, this.maybeNotify();
          })
        );
      }
    }, this.getSize = () => this.options.enabled ? (this.scrollRect = this.scrollRect ?? this.options.initialRect, this.scrollRect[this.options.horizontal ? "width" : "height"]) : (this.scrollRect = null, 0), this.getScrollOffset = () => this.options.enabled ? (this.scrollOffset = this.scrollOffset ?? (typeof this.options.initialOffset == "function" ? this.options.initialOffset() : this.options.initialOffset), this.scrollOffset) : (this.scrollOffset = null, 0), this.getFurthestMeasurement = (n, r) => {
      const o = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map();
      for (let a = r - 1; a >= 0; a--) {
        const s = n[a];
        if (o.has(s.lane))
          continue;
        const l = i.get(
          s.lane
        );
        if (l == null || s.end > l.end ? i.set(s.lane, s) : s.end < l.end && o.set(s.lane, !0), o.size === this.options.lanes)
          break;
      }
      return i.size === this.options.lanes ? Array.from(i.values()).sort((a, s) => a.end === s.end ? a.index - s.index : a.end - s.end)[0] : void 0;
    }, this.getMeasurementOptions = Jt(
      () => [
        this.options.count,
        this.options.paddingStart,
        this.options.scrollMargin,
        this.options.getItemKey,
        this.options.enabled
      ],
      (n, r, o, i, a) => (this.pendingMeasuredCacheIndexes = [], {
        count: n,
        paddingStart: r,
        scrollMargin: o,
        getItemKey: i,
        enabled: a
      }),
      {
        key: !1
      }
    ), this.getMeasurements = Jt(
      () => [this.getMeasurementOptions(), this.itemSizeCache],
      ({ count: n, paddingStart: r, scrollMargin: o, getItemKey: i, enabled: a }, s) => {
        if (!a)
          return this.measurementsCache = [], this.itemSizeCache.clear(), [];
        this.measurementsCache.length === 0 && (this.measurementsCache = this.options.initialMeasurementsCache, this.measurementsCache.forEach((u) => {
          this.itemSizeCache.set(u.key, u.size);
        }));
        const l = this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
        this.pendingMeasuredCacheIndexes = [];
        const c = this.measurementsCache.slice(0, l);
        for (let u = l; u < n; u++) {
          const d = i(u), h = this.options.lanes === 1 ? c[u - 1] : this.getFurthestMeasurement(c, u), p = h ? h.end + this.options.gap : r + o, m = s.get(d), v = typeof m == "number" ? m : this.options.estimateSize(u), f = p + v, y = h ? h.lane : u % this.options.lanes;
          c[u] = {
            index: u,
            start: p,
            size: v,
            end: f,
            key: d,
            lane: y
          };
        }
        return this.measurementsCache = c, c;
      },
      {
        key: !1,
        debug: () => this.options.debug
      }
    ), this.calculateRange = Jt(
      () => [this.getMeasurements(), this.getSize(), this.getScrollOffset()],
      (n, r, o) => this.range = n.length > 0 && r > 0 ? Ig({
        measurements: n,
        outerSize: r,
        scrollOffset: o
      }) : null,
      {
        key: !1,
        debug: () => this.options.debug
      }
    ), this.getIndexes = Jt(
      () => [
        this.options.rangeExtractor,
        this.calculateRange(),
        this.options.overscan,
        this.options.count
      ],
      (n, r, o, i) => r === null ? [] : n({
        startIndex: r.startIndex,
        endIndex: r.endIndex,
        overscan: o,
        count: i
      }),
      {
        key: !1,
        debug: () => this.options.debug
      }
    ), this.indexFromElement = (n) => {
      const r = this.options.indexAttribute, o = n.getAttribute(r);
      return o ? parseInt(o, 10) : (console.warn(
        `Missing attribute name '${r}={index}' on measured element.`
      ), -1);
    }, this._measureElement = (n, r) => {
      const o = this.indexFromElement(n), i = this.measurementsCache[o];
      if (!i)
        return;
      const a = i.key, s = this.elementsCache.get(a);
      s !== n && (s && this.observer.unobserve(s), this.observer.observe(n), this.elementsCache.set(a, n)), n.isConnected && this.resizeItem(o, this.options.measureElement(n, r, this));
    }, this.resizeItem = (n, r) => {
      const o = this.measurementsCache[n];
      if (!o)
        return;
      const i = this.itemSizeCache.get(o.key) ?? o.size, a = r - i;
      a !== 0 && ((this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(o, a, this) : o.start < this.getScrollOffset() + this.scrollAdjustments) && this._scrollToOffset(this.getScrollOffset(), {
        adjustments: this.scrollAdjustments += a,
        behavior: void 0
      }), this.pendingMeasuredCacheIndexes.push(o.index), this.itemSizeCache = new Map(this.itemSizeCache.set(o.key, r)), this.notify(!1));
    }, this.measureElement = (n) => {
      if (!n) {
        this.elementsCache.forEach((r, o) => {
          r.isConnected || (this.observer.unobserve(r), this.elementsCache.delete(o));
        });
        return;
      }
      this._measureElement(n, void 0);
    }, this.getVirtualItems = Jt(
      () => [this.getIndexes(), this.getMeasurements()],
      (n, r) => {
        const o = [];
        for (let i = 0, a = n.length; i < a; i++) {
          const s = n[i], l = r[s];
          o.push(l);
        }
        return o;
      },
      {
        key: !1,
        debug: () => this.options.debug
      }
    ), this.getVirtualItemForOffset = (n) => {
      const r = this.getMeasurements();
      if (r.length !== 0)
        return Ao(
          r[Pc(
            0,
            r.length - 1,
            (o) => Ao(r[o]).start,
            n
          )]
        );
    }, this.getOffsetForAlignment = (n, r) => {
      const o = this.getSize(), i = this.getScrollOffset();
      r === "auto" && (n <= i ? r = "start" : n >= i + o ? r = "end" : r = "start"), r === "start" ? n = n : r === "end" ? n = n - o : r === "center" && (n = n - o / 2);
      const a = this.options.horizontal ? "scrollWidth" : "scrollHeight", s = (this.scrollElement ? "document" in this.scrollElement ? this.scrollElement.document.documentElement[a] : this.scrollElement[a] : 0) - o;
      return Math.max(Math.min(s, n), 0);
    }, this.getOffsetForIndex = (n, r = "auto") => {
      n = Math.max(0, Math.min(n, this.options.count - 1));
      const o = this.measurementsCache[n];
      if (!o)
        return;
      const i = this.getSize(), a = this.getScrollOffset();
      if (r === "auto")
        if (o.end >= a + i - this.options.scrollPaddingEnd)
          r = "end";
        else if (o.start <= a + this.options.scrollPaddingStart)
          r = "start";
        else
          return [a, r];
      const s = r === "end" ? o.end + this.options.scrollPaddingEnd : o.start - this.options.scrollPaddingStart;
      return [this.getOffsetForAlignment(s, r), r];
    }, this.isDynamicMode = () => this.elementsCache.size > 0, this.cancelScrollToIndex = () => {
      this.scrollToIndexTimeoutId !== null && this.targetWindow && (this.targetWindow.clearTimeout(this.scrollToIndexTimeoutId), this.scrollToIndexTimeoutId = null);
    }, this.scrollToOffset = (n, { align: r = "start", behavior: o } = {}) => {
      this.cancelScrollToIndex(), o === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getOffsetForAlignment(n, r), {
        adjustments: void 0,
        behavior: o
      });
    }, this.scrollToIndex = (n, { align: r = "auto", behavior: o } = {}) => {
      n = Math.max(0, Math.min(n, this.options.count - 1)), this.cancelScrollToIndex(), o === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      );
      const i = this.getOffsetForIndex(n, r);
      if (!i) return;
      const [a, s] = i;
      this._scrollToOffset(a, { adjustments: void 0, behavior: o }), o !== "smooth" && this.isDynamicMode() && this.targetWindow && (this.scrollToIndexTimeoutId = this.targetWindow.setTimeout(() => {
        if (this.scrollToIndexTimeoutId = null, this.elementsCache.has(
          this.options.getItemKey(n)
        )) {
          const [l] = Ao(
            this.getOffsetForIndex(n, s)
          );
          Rg(l, this.getScrollOffset()) || this.scrollToIndex(n, { align: s, behavior: o });
        } else
          this.scrollToIndex(n, { align: s, behavior: o });
      }));
    }, this.scrollBy = (n, { behavior: r } = {}) => {
      this.cancelScrollToIndex(), r === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getScrollOffset() + n, {
        adjustments: void 0,
        behavior: r
      });
    }, this.getTotalSize = () => {
      var n;
      const r = this.getMeasurements();
      let o;
      return r.length === 0 ? o = this.options.paddingStart : o = this.options.lanes === 1 ? ((n = r[r.length - 1]) == null ? void 0 : n.end) ?? 0 : Math.max(
        ...r.slice(-this.options.lanes).map((i) => i.end)
      ), Math.max(
        o - this.options.scrollMargin + this.options.paddingEnd,
        0
      );
    }, this._scrollToOffset = (n, {
      adjustments: r,
      behavior: o
    }) => {
      this.options.scrollToFn(n, { behavior: o, adjustments: r }, this);
    }, this.measure = () => {
      this.itemSizeCache = /* @__PURE__ */ new Map(), this.notify(!1);
    }, this.setOptions(t);
  }
}
const Pc = (e, t, n, r) => {
  for (; e <= t; ) {
    const o = (e + t) / 2 | 0, i = n(o);
    if (i < r)
      e = o + 1;
    else if (i > r)
      t = o - 1;
    else
      return o;
  }
  return e > 0 ? e - 1 : 0;
};
function Ig({
  measurements: e,
  outerSize: t,
  scrollOffset: n
}) {
  const r = e.length - 1, o = Pc(0, r, (a) => e[a].start, n);
  let i = o;
  for (; i < r && e[i].end < n + t; )
    i++;
  return { startIndex: o, endIndex: i };
}
const Dg = typeof document < "u" ? b.useLayoutEffect : b.useEffect;
function Fg(e) {
  const t = b.useReducer(() => ({}), {})[1], n = {
    ...e,
    onChange: (o, i) => {
      var a;
      i ? Dd(t) : t(), (a = e.onChange) == null || a.call(e, o, i);
    }
  }, [r] = b.useState(
    () => new Lg(n)
  );
  return r.setOptions(n), b.useEffect(() => r._didMount(), []), Dg(() => r._willUpdate()), r;
}
function Mg(e) {
  return Fg({
    observeElementRect: Tg,
    observeElementOffset: kg,
    scrollToFn: Ag,
    ...e
  });
}
var $g = Object.defineProperty, Bg = (e, t, n) => t in e ? $g(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Lo = (e, t, n) => (Bg(e, typeof t != "symbol" ? t + "" : t, n), n);
let zg = class {
  constructor() {
    Lo(this, "current", this.detect()), Lo(this, "handoffState", "pending"), Lo(this, "currentId", 0);
  }
  set(e) {
    this.current !== e && (this.handoffState = "pending", this.currentId = 0, this.current = e);
  }
  reset() {
    this.set(this.detect());
  }
  nextId() {
    return ++this.currentId;
  }
  get isServer() {
    return this.current === "server";
  }
  get isClient() {
    return this.current === "client";
  }
  detect() {
    return typeof window > "u" || typeof document > "u" ? "server" : "client";
  }
  handoff() {
    this.handoffState === "pending" && (this.handoffState = "complete");
  }
  get isHandoffComplete() {
    return this.handoffState === "complete";
  }
}, At = new zg(), Re = (e, t) => {
  At.isServer ? le(e, t) : Rs(e, t);
};
function Yn(e) {
  let t = ae(e);
  return Re(() => {
    t.current = e;
  }, [e]), t;
}
function Bi(e, t) {
  let [n, r] = Ue(e), o = Yn(e);
  return Re(() => r(o.current), [o, r, ...t]), n;
}
let re = function(e) {
  let t = Yn(e);
  return z.useCallback((...n) => t.current(...n), [t]);
};
function Ug(e, t, n) {
  let [r, o] = Ue(n), i = e !== void 0, a = ae(i), s = ae(!1), l = ae(!1);
  return i && !a.current && !s.current ? (s.current = !0, a.current = i, console.error("A component is changing from uncontrolled to controlled. This may be caused by the value changing from undefined to a defined value, which should not happen.")) : !i && a.current && !l.current && (l.current = !0, a.current = i, console.error("A component is changing from controlled to uncontrolled. This may be caused by the value changing from a defined value to undefined, which should not happen.")), [i ? e : r, re((c) => (i || o(c), t == null ? void 0 : t(c)))];
}
function Wg(e) {
  typeof queueMicrotask == "function" ? queueMicrotask(e) : Promise.resolve().then(e).catch((t) => setTimeout(() => {
    throw t;
  }));
}
function Dr() {
  let e = [], t = { addEventListener(n, r, o, i) {
    return n.addEventListener(r, o, i), t.add(() => n.removeEventListener(r, o, i));
  }, requestAnimationFrame(...n) {
    let r = requestAnimationFrame(...n);
    return t.add(() => cancelAnimationFrame(r));
  }, nextFrame(...n) {
    return t.requestAnimationFrame(() => t.requestAnimationFrame(...n));
  }, setTimeout(...n) {
    let r = setTimeout(...n);
    return t.add(() => clearTimeout(r));
  }, microTask(...n) {
    let r = { current: !0 };
    return Wg(() => {
      r.current && n[0]();
    }), t.add(() => {
      r.current = !1;
    });
  }, style(n, r, o) {
    let i = n.style.getPropertyValue(r);
    return Object.assign(n.style, { [r]: o }), this.add(() => {
      Object.assign(n.style, { [r]: i });
    });
  }, group(n) {
    let r = Dr();
    return n(r), this.add(() => r.dispose());
  }, add(n) {
    return e.push(n), () => {
      let r = e.indexOf(n);
      if (r >= 0) for (let o of e.splice(r, 1)) o();
    };
  }, dispose() {
    for (let n of e.splice(0)) n();
  } };
  return t;
}
function zi() {
  let [e] = Ue(Dr);
  return le(() => () => e.dispose(), [e]), e;
}
function Hg() {
  let e = typeof document > "u";
  return "useSyncExternalStore" in b ? ((t) => t.useSyncExternalStore)(b)(() => () => {
  }, () => !1, () => !e) : !1;
}
function Kg() {
  let e = Hg(), [t, n] = b.useState(At.isHandoffComplete);
  return t && At.isHandoffComplete === !1 && n(!1), b.useEffect(() => {
    t !== !0 && n(!0);
  }, [t]), b.useEffect(() => At.handoff(), []), e ? !1 : t;
}
var Ya;
let Xn = (Ya = z.useId) != null ? Ya : function() {
  let e = Kg(), [t, n] = z.useState(e ? () => At.nextId() : null);
  return Re(() => {
    t === null && n(At.nextId());
  }, [t]), t != null ? "" + t : void 0;
};
function st(e, t, ...n) {
  if (e in t) {
    let o = t[e];
    return typeof o == "function" ? o(...n) : o;
  }
  let r = new Error(`Tried to handle "${e}" but there is no handler defined. Only defined handlers are: ${Object.keys(t).map((o) => `"${o}"`).join(", ")}.`);
  throw Error.captureStackTrace && Error.captureStackTrace(r, st), r;
}
function Ui(e) {
  return At.isServer ? null : e instanceof Node ? e.ownerDocument : e != null && e.hasOwnProperty("current") && e.current instanceof Node ? e.current.ownerDocument : document;
}
let Xa = ["[contentEditable=true]", "[tabindex]", "a[href]", "area[href]", "button:not([disabled])", "iframe", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].map((e) => `${e}:not([tabindex='-1'])`).join(",");
var qg = ((e) => (e[e.First = 1] = "First", e[e.Previous = 2] = "Previous", e[e.Next = 4] = "Next", e[e.Last = 8] = "Last", e[e.WrapAround = 16] = "WrapAround", e[e.NoScroll = 32] = "NoScroll", e))(qg || {}), Vg = ((e) => (e[e.Error = 0] = "Error", e[e.Overflow = 1] = "Overflow", e[e.Success = 2] = "Success", e[e.Underflow = 3] = "Underflow", e))(Vg || {}), Gg = ((e) => (e[e.Previous = -1] = "Previous", e[e.Next = 1] = "Next", e))(Gg || {}), Ac = ((e) => (e[e.Strict = 0] = "Strict", e[e.Loose = 1] = "Loose", e))(Ac || {});
function Yg(e, t = 0) {
  var n;
  return e === ((n = Ui(e)) == null ? void 0 : n.body) ? !1 : st(t, { 0() {
    return e.matches(Xa);
  }, 1() {
    let r = e;
    for (; r !== null; ) {
      if (r.matches(Xa)) return !0;
      r = r.parentElement;
    }
    return !1;
  } });
}
var Xg = ((e) => (e[e.Keyboard = 0] = "Keyboard", e[e.Mouse = 1] = "Mouse", e))(Xg || {});
typeof window < "u" && typeof document < "u" && (document.addEventListener("keydown", (e) => {
  e.metaKey || e.altKey || e.ctrlKey || (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0), document.addEventListener("click", (e) => {
  e.detail === 1 ? delete document.documentElement.dataset.headlessuiFocusVisible : e.detail === 0 && (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0));
function Zg(e, t = (n) => n) {
  return e.slice().sort((n, r) => {
    let o = t(n), i = t(r);
    if (o === null || i === null) return 0;
    let a = o.compareDocumentPosition(i);
    return a & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : a & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
  });
}
function Jg() {
  return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
function Qg() {
  return /Android/gi.test(window.navigator.userAgent);
}
function Lc() {
  return Jg() || Qg();
}
function gr(e, t, n) {
  let r = Yn(t);
  le(() => {
    function o(i) {
      r.current(i);
    }
    return document.addEventListener(e, o, n), () => document.removeEventListener(e, o, n);
  }, [e, n]);
}
function eb(e, t, n) {
  let r = Yn(t);
  le(() => {
    function o(i) {
      r.current(i);
    }
    return window.addEventListener(e, o, n), () => window.removeEventListener(e, o, n);
  }, [e, n]);
}
function tb(e, t, n = !0) {
  let r = ae(!1);
  le(() => {
    requestAnimationFrame(() => {
      r.current = n;
    });
  }, [n]);
  function o(a, s) {
    if (!r.current || a.defaultPrevented) return;
    let l = s(a);
    if (l === null || !l.getRootNode().contains(l) || !l.isConnected) return;
    let c = function u(d) {
      return typeof d == "function" ? u(d()) : Array.isArray(d) || d instanceof Set ? d : [d];
    }(e);
    for (let u of c) {
      if (u === null) continue;
      let d = u instanceof HTMLElement ? u : u.current;
      if (d != null && d.contains(l) || a.composed && a.composedPath().includes(d)) return;
    }
    return !Yg(l, Ac.Loose) && l.tabIndex !== -1 && a.preventDefault(), t(a, l);
  }
  let i = ae(null);
  gr("pointerdown", (a) => {
    var s, l;
    r.current && (i.current = ((l = (s = a.composedPath) == null ? void 0 : s.call(a)) == null ? void 0 : l[0]) || a.target);
  }, !0), gr("mousedown", (a) => {
    var s, l;
    r.current && (i.current = ((l = (s = a.composedPath) == null ? void 0 : s.call(a)) == null ? void 0 : l[0]) || a.target);
  }, !0), gr("click", (a) => {
    Lc() || i.current && (o(a, () => i.current), i.current = null);
  }, !0), gr("touchend", (a) => o(a, () => a.target instanceof HTMLElement ? a.target : null), !0), eb("blur", (a) => o(a, () => window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), !0);
}
function nb(...e) {
  return Be(() => Ui(...e), [...e]);
}
function Za(e) {
  var t;
  if (e.type) return e.type;
  let n = (t = e.as) != null ? t : "button";
  if (typeof n == "string" && n.toLowerCase() === "button") return "button";
}
function rb(e, t) {
  let [n, r] = Ue(() => Za(e));
  return Re(() => {
    r(Za(e));
  }, [e.type, e.as]), Re(() => {
    n || t.current && t.current instanceof HTMLButtonElement && !t.current.hasAttribute("type") && r("button");
  }, [n, t]), n;
}
let ob = Symbol();
function Zn(...e) {
  let t = ae(e);
  le(() => {
    t.current = e;
  }, [e]);
  let n = re((r) => {
    for (let o of t.current) o != null && (typeof o == "function" ? o(r) : o.current = r);
  });
  return e.every((r) => r == null || (r == null ? void 0 : r[ob])) ? void 0 : n;
}
function Ja(e) {
  return [e.screenX, e.screenY];
}
function ib() {
  let e = ae([-1, -1]);
  return { wasMoved(t) {
    let n = Ja(t);
    return e.current[0] === n[0] && e.current[1] === n[1] ? !1 : (e.current = n, !0);
  }, update(t) {
    e.current = Ja(t);
  } };
}
function ab({ container: e, accept: t, walk: n, enabled: r = !0 }) {
  let o = ae(t), i = ae(n);
  le(() => {
    o.current = t, i.current = n;
  }, [t, n]), Re(() => {
    if (!e || !r) return;
    let a = Ui(e);
    if (!a) return;
    let s = o.current, l = i.current, c = Object.assign((d) => s(d), { acceptNode: s }), u = a.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, c, !1);
    for (; u.nextNode(); ) l(u.currentNode);
  }, [e, r, o, i]);
}
function Qa(e, t) {
  let n = ae([]), r = re(e);
  le(() => {
    let o = [...n.current];
    for (let [i, a] of t.entries()) if (n.current[i] !== a) {
      let s = r(t, o);
      return n.current = t, s;
    }
  }, [r, ...t]);
}
function es(...e) {
  return Array.from(new Set(e.flatMap((t) => typeof t == "string" ? t.split(" ") : []))).filter(Boolean).join(" ");
}
var oi = ((e) => (e[e.None = 0] = "None", e[e.RenderStrategy = 1] = "RenderStrategy", e[e.Static = 2] = "Static", e))(oi || {}), sb = ((e) => (e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e))(sb || {});
function Ut({ ourProps: e, theirProps: t, slot: n, defaultTag: r, features: o, visible: i = !0, name: a, mergeRefs: s }) {
  s = s ?? lb;
  let l = Ic(t, e);
  if (i) return br(l, n, r, a, s);
  let c = o ?? 0;
  if (c & 2) {
    let { static: u = !1, ...d } = l;
    if (u) return br(d, n, r, a, s);
  }
  if (c & 1) {
    let { unmount: u = !0, ...d } = l;
    return st(u ? 0 : 1, { 0() {
      return null;
    }, 1() {
      return br({ ...d, hidden: !0, style: { display: "none" } }, n, r, a, s);
    } });
  }
  return br(l, n, r, a, s);
}
function br(e, t = {}, n, r, o) {
  let { as: i = n, children: a, refName: s = "ref", ...l } = Io(e, ["unmount", "static"]), c = e.ref !== void 0 ? { [s]: e.ref } : {}, u = typeof a == "function" ? a(t) : a;
  "className" in l && l.className && typeof l.className == "function" && (l.className = l.className(t));
  let d = {};
  if (t) {
    let h = !1, p = [];
    for (let [m, v] of Object.entries(t)) typeof v == "boolean" && (h = !0), v === !0 && p.push(m);
    h && (d["data-headlessui-state"] = p.join(" "));
  }
  if (i === vt && Object.keys(ii(l)).length > 0) {
    if (!qr(u) || Array.isArray(u) && u.length > 1) throw new Error(['Passing props on "Fragment"!', "", `The current component <${r} /> is rendering a "Fragment".`, "However we need to passthrough the following props:", Object.keys(l).map((v) => `  - ${v}`).join(`
`), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".', "Render a single element as the child so that we can forward the props onto that element."].map((v) => `  - ${v}`).join(`
`)].join(`
`));
    let h = u.props, p = typeof (h == null ? void 0 : h.className) == "function" ? (...v) => es(h == null ? void 0 : h.className(...v), l.className) : es(h == null ? void 0 : h.className, l.className), m = p ? { className: p } : {};
    return Ad(u, Object.assign({}, Ic(u.props, ii(Io(l, ["ref"]))), d, c, { ref: o(u.ref, c.ref) }, m));
  }
  return Ld(i, Object.assign({}, Io(l, ["ref"]), i !== vt && c, i !== vt && d), u);
}
function lb(...e) {
  return e.every((t) => t == null) ? void 0 : (t) => {
    for (let n of e) n != null && (typeof n == "function" ? n(t) : n.current = t);
  };
}
function Ic(...e) {
  if (e.length === 0) return {};
  if (e.length === 1) return e[0];
  let t = {}, n = {};
  for (let r of e) for (let o in r) o.startsWith("on") && typeof r[o] == "function" ? (n[o] != null || (n[o] = []), n[o].push(r[o])) : t[o] = r[o];
  if (t.disabled || t["aria-disabled"]) return Object.assign(t, Object.fromEntries(Object.keys(n).map((r) => [r, void 0])));
  for (let r in n) Object.assign(t, { [r](o, ...i) {
    let a = n[r];
    for (let s of a) {
      if ((o instanceof Event || (o == null ? void 0 : o.nativeEvent) instanceof Event) && o.defaultPrevented) return;
      s(o, ...i);
    }
  } });
  return t;
}
function Wt(e) {
  var t;
  return Object.assign(We(e), { displayName: (t = e.displayName) != null ? t : e.name });
}
function ii(e) {
  let t = Object.assign({}, e);
  for (let n in t) t[n] === void 0 && delete t[n];
  return t;
}
function Io(e, t = []) {
  let n = Object.assign({}, e);
  for (let r of t) r in n && delete n[r];
  return n;
}
let cb = "div";
var Dc = ((e) => (e[e.None = 1] = "None", e[e.Focusable = 2] = "Focusable", e[e.Hidden = 4] = "Hidden", e))(Dc || {});
function ub(e, t) {
  var n;
  let { features: r = 1, ...o } = e, i = { ref: t, "aria-hidden": (r & 2) === 2 ? !0 : (n = o["aria-hidden"]) != null ? n : void 0, hidden: (r & 4) === 4 ? !0 : void 0, style: { position: "fixed", top: 1, left: 1, width: 1, height: 0, padding: 0, margin: -1, overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0", ...(r & 4) === 4 && (r & 2) !== 2 && { display: "none" } } };
  return Ut({ ourProps: i, theirProps: o, slot: {}, defaultTag: cb, name: "Hidden" });
}
let db = Wt(ub), Wi = xt(null);
Wi.displayName = "OpenClosedContext";
var $n = ((e) => (e[e.Open = 1] = "Open", e[e.Closed = 2] = "Closed", e[e.Closing = 4] = "Closing", e[e.Opening = 8] = "Opening", e))($n || {});
function fb() {
  return rt(Wi);
}
function pb({ value: e, children: t }) {
  return z.createElement(Wi.Provider, { value: e }, t);
}
function hb(e) {
  function t() {
    document.readyState !== "loading" && (e(), document.removeEventListener("DOMContentLoaded", t));
  }
  typeof window < "u" && typeof document < "u" && (document.addEventListener("DOMContentLoaded", t), t());
}
let Tt = [];
hb(() => {
  function e(t) {
    t.target instanceof HTMLElement && t.target !== document.body && Tt[0] !== t.target && (Tt.unshift(t.target), Tt = Tt.filter((n) => n != null && n.isConnected), Tt.splice(10));
  }
  window.addEventListener("click", e, { capture: !0 }), window.addEventListener("mousedown", e, { capture: !0 }), window.addEventListener("focus", e, { capture: !0 }), document.body.addEventListener("click", e, { capture: !0 }), document.body.addEventListener("mousedown", e, { capture: !0 }), document.body.addEventListener("focus", e, { capture: !0 });
});
function mb(e) {
  let t = e.parentElement, n = null;
  for (; t && !(t instanceof HTMLFieldSetElement); ) t instanceof HTMLLegendElement && (n = t), t = t.parentElement;
  let r = (t == null ? void 0 : t.getAttribute("disabled")) === "";
  return r && vb(n) ? !1 : r;
}
function vb(e) {
  if (!e) return !1;
  let t = e.previousElementSibling;
  for (; t !== null; ) {
    if (t instanceof HTMLLegendElement) return !1;
    t = t.previousElementSibling;
  }
  return !0;
}
function gb(e) {
  throw new Error("Unexpected object: " + e);
}
var be = ((e) => (e[e.First = 0] = "First", e[e.Previous = 1] = "Previous", e[e.Next = 2] = "Next", e[e.Last = 3] = "Last", e[e.Specific = 4] = "Specific", e[e.Nothing = 5] = "Nothing", e))(be || {});
function ts(e, t) {
  let n = t.resolveItems();
  if (n.length <= 0) return null;
  let r = t.resolveActiveIndex(), o = r ?? -1;
  switch (e.focus) {
    case 0: {
      for (let i = 0; i < n.length; ++i) if (!t.resolveDisabled(n[i], i, n)) return i;
      return r;
    }
    case 1: {
      for (let i = o - 1; i >= 0; --i) if (!t.resolveDisabled(n[i], i, n)) return i;
      return r;
    }
    case 2: {
      for (let i = o + 1; i < n.length; ++i) if (!t.resolveDisabled(n[i], i, n)) return i;
      return r;
    }
    case 3: {
      for (let i = n.length - 1; i >= 0; --i) if (!t.resolveDisabled(n[i], i, n)) return i;
      return r;
    }
    case 4: {
      for (let i = 0; i < n.length; ++i) if (t.resolveId(n[i], i, n) === e.id) return i;
      return r;
    }
    case 5:
      return null;
    default:
      gb(e);
  }
}
function Fc(e = {}, t = null, n = []) {
  for (let [r, o] of Object.entries(e)) $c(n, Mc(t, r), o);
  return n;
}
function Mc(e, t) {
  return e ? e + "[" + t + "]" : t;
}
function $c(e, t, n) {
  if (Array.isArray(n)) for (let [r, o] of n.entries()) $c(e, Mc(t, r.toString()), o);
  else n instanceof Date ? e.push([t, n.toISOString()]) : typeof n == "boolean" ? e.push([t, n ? "1" : "0"]) : typeof n == "string" ? e.push([t, n]) : typeof n == "number" ? e.push([t, `${n}`]) : n == null ? e.push([t, ""]) : Fc(n, t, e);
}
var Pe = ((e) => (e.Space = " ", e.Enter = "Enter", e.Escape = "Escape", e.Backspace = "Backspace", e.Delete = "Delete", e.ArrowLeft = "ArrowLeft", e.ArrowUp = "ArrowUp", e.ArrowRight = "ArrowRight", e.ArrowDown = "ArrowDown", e.Home = "Home", e.End = "End", e.PageUp = "PageUp", e.PageDown = "PageDown", e.Tab = "Tab", e))(Pe || {}), bb = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(bb || {}), yb = ((e) => (e[e.Single = 0] = "Single", e[e.Multi = 1] = "Multi", e))(yb || {}), wb = ((e) => (e[e.Pointer = 0] = "Pointer", e[e.Focus = 1] = "Focus", e[e.Other = 2] = "Other", e))(wb || {}), xb = ((e) => (e[e.OpenCombobox = 0] = "OpenCombobox", e[e.CloseCombobox = 1] = "CloseCombobox", e[e.GoToOption = 2] = "GoToOption", e[e.RegisterOption = 3] = "RegisterOption", e[e.UnregisterOption = 4] = "UnregisterOption", e[e.RegisterLabel = 5] = "RegisterLabel", e[e.SetActivationTrigger = 6] = "SetActivationTrigger", e[e.UpdateVirtualOptions = 7] = "UpdateVirtualOptions", e))(xb || {});
function Do(e, t = (n) => n) {
  let n = e.activeOptionIndex !== null ? e.options[e.activeOptionIndex] : null, r = t(e.options.slice()), o = r.length > 0 && r[0].dataRef.current.order !== null ? r.sort((a, s) => a.dataRef.current.order - s.dataRef.current.order) : Zg(r, (a) => a.dataRef.current.domRef.current), i = n ? o.indexOf(n) : null;
  return i === -1 && (i = null), { options: o, activeOptionIndex: i };
}
let Eb = { 1(e) {
  var t;
  return (t = e.dataRef.current) != null && t.disabled || e.comboboxState === 1 ? e : { ...e, activeOptionIndex: null, comboboxState: 1 };
}, 0(e) {
  var t, n;
  if ((t = e.dataRef.current) != null && t.disabled || e.comboboxState === 0) return e;
  if ((n = e.dataRef.current) != null && n.value) {
    let r = e.dataRef.current.calculateIndex(e.dataRef.current.value);
    if (r !== -1) return { ...e, activeOptionIndex: r, comboboxState: 0 };
  }
  return { ...e, comboboxState: 0 };
}, 2(e, t) {
  var n, r, o, i, a;
  if ((n = e.dataRef.current) != null && n.disabled || (r = e.dataRef.current) != null && r.optionsRef.current && !((o = e.dataRef.current) != null && o.optionsPropsRef.current.static) && e.comboboxState === 1) return e;
  if (e.virtual) {
    let u = t.focus === be.Specific ? t.idx : ts(t, { resolveItems: () => e.virtual.options, resolveActiveIndex: () => {
      var h, p;
      return (p = (h = e.activeOptionIndex) != null ? h : e.virtual.options.findIndex((m) => !e.virtual.disabled(m))) != null ? p : null;
    }, resolveDisabled: e.virtual.disabled, resolveId() {
      throw new Error("Function not implemented.");
    } }), d = (i = t.trigger) != null ? i : 2;
    return e.activeOptionIndex === u && e.activationTrigger === d ? e : { ...e, activeOptionIndex: u, activationTrigger: d };
  }
  let s = Do(e);
  if (s.activeOptionIndex === null) {
    let u = s.options.findIndex((d) => !d.dataRef.current.disabled);
    u !== -1 && (s.activeOptionIndex = u);
  }
  let l = t.focus === be.Specific ? t.idx : ts(t, { resolveItems: () => s.options, resolveActiveIndex: () => s.activeOptionIndex, resolveId: (u) => u.id, resolveDisabled: (u) => u.dataRef.current.disabled }), c = (a = t.trigger) != null ? a : 2;
  return e.activeOptionIndex === l && e.activationTrigger === c ? e : { ...e, ...s, activeOptionIndex: l, activationTrigger: c };
}, 3: (e, t) => {
  var n, r, o;
  if ((n = e.dataRef.current) != null && n.virtual) return { ...e, options: [...e.options, t.payload] };
  let i = t.payload, a = Do(e, (l) => (l.push(i), l));
  e.activeOptionIndex === null && (r = e.dataRef.current) != null && r.isSelected(t.payload.dataRef.current.value) && (a.activeOptionIndex = a.options.indexOf(i));
  let s = { ...e, ...a, activationTrigger: 2 };
  return (o = e.dataRef.current) != null && o.__demoMode && e.dataRef.current.value === void 0 && (s.activeOptionIndex = 0), s;
}, 4: (e, t) => {
  var n;
  if ((n = e.dataRef.current) != null && n.virtual) return { ...e, options: e.options.filter((o) => o.id !== t.id) };
  let r = Do(e, (o) => {
    let i = o.findIndex((a) => a.id === t.id);
    return i !== -1 && o.splice(i, 1), o;
  });
  return { ...e, ...r, activationTrigger: 2 };
}, 5: (e, t) => e.labelId === t.id ? e : { ...e, labelId: t.id }, 6: (e, t) => e.activationTrigger === t.trigger ? e : { ...e, activationTrigger: t.trigger }, 7: (e, t) => {
  var n;
  if (((n = e.virtual) == null ? void 0 : n.options) === t.options) return e;
  let r = e.activeOptionIndex;
  if (e.activeOptionIndex !== null) {
    let o = t.options.indexOf(e.virtual.options[e.activeOptionIndex]);
    o !== -1 ? r = o : r = null;
  }
  return { ...e, activeOptionIndex: r, virtual: Object.assign({}, e.virtual, { options: t.options }) };
} }, Hi = xt(null);
Hi.displayName = "ComboboxActionsContext";
function Jn(e) {
  let t = rt(Hi);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Combobox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, Jn), n;
  }
  return t;
}
let Bc = xt(null);
function Sb(e) {
  var t;
  let n = Ht("VirtualProvider"), [r, o] = Be(() => {
    let l = n.optionsRef.current;
    if (!l) return [0, 0];
    let c = window.getComputedStyle(l);
    return [parseFloat(c.paddingBlockStart || c.paddingTop), parseFloat(c.paddingBlockEnd || c.paddingBottom)];
  }, [n.optionsRef.current]), i = Mg({ scrollPaddingStart: r, scrollPaddingEnd: o, count: n.virtual.options.length, estimateSize() {
    return 40;
  }, getScrollElement() {
    var l;
    return (l = n.optionsRef.current) != null ? l : null;
  }, overscan: 12 }), [a, s] = Ue(0);
  return Re(() => {
    s((l) => l + 1);
  }, [(t = n.virtual) == null ? void 0 : t.options]), z.createElement(Bc.Provider, { value: i }, z.createElement("div", { style: { position: "relative", width: "100%", height: `${i.getTotalSize()}px` }, ref: (l) => {
    if (l) {
      if (typeof process < "u" && process.env.JEST_WORKER_ID !== void 0 || n.activationTrigger === 0) return;
      n.activeOptionIndex !== null && n.virtual.options.length > n.activeOptionIndex && i.scrollToIndex(n.activeOptionIndex);
    }
  } }, i.getVirtualItems().map((l) => {
    var c;
    return z.createElement(vt, { key: l.key }, z.cloneElement((c = e.children) == null ? void 0 : c.call(e, { option: n.virtual.options[l.index], open: n.comboboxState === 0 }), { key: `${a}-${l.key}`, "data-index": l.index, "aria-setsize": n.virtual.options.length, "aria-posinset": l.index + 1, style: { position: "absolute", top: 0, left: 0, transform: `translateY(${l.start}px)`, overflowAnchor: "none" } }));
  })));
}
let Ki = xt(null);
Ki.displayName = "ComboboxDataContext";
function Ht(e) {
  let t = rt(Ki);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Combobox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, Ht), n;
  }
  return t;
}
function _b(e, t) {
  return st(t.type, Eb, e, t);
}
let Rb = vt;
function Ob(e, t) {
  let { value: n, defaultValue: r, onChange: o, form: i, name: a, by: s = null, disabled: l = !1, __demoMode: c = !1, nullable: u = !1, multiple: d = !1, immediate: h = !1, virtual: p = null, ...m } = e, v = !1, f = null, [y = d ? [] : void 0, S] = Ug(n, o, r), [C, T] = gi(_b, { dataRef: Pd(), comboboxState: c ? 0 : 1, options: [], virtual: null, activeOptionIndex: null, activationTrigger: 2, labelId: null }), A = ae(!1), U = ae({ static: !1, hold: !1 }), L = ae(null), H = ae(null), G = ae(null), W = ae(null), K = re(typeof s == "string" ? (V, ee) => {
    let ye = s;
    return (V == null ? void 0 : V[ye]) === (ee == null ? void 0 : ee[ye]);
  } : s ?? ((V, ee) => V === ee)), F = re((V) => C.options.findIndex((ee) => K(ee.dataRef.current.value, V))), N = bi((V) => st(E.mode, { 1: () => y.some((ee) => K(ee, V)), 0: () => K(y, V) }), [y]), O = re((V) => C.activeOptionIndex === F(V)), E = Be(() => ({ ...C, immediate: v, optionsPropsRef: U, labelRef: L, inputRef: H, buttonRef: G, optionsRef: W, value: y, defaultValue: r, disabled: l, mode: d ? 1 : 0, virtual: C.virtual, get activeOptionIndex() {
    if (A.current && C.activeOptionIndex === null && C.options.length > 0) {
      let V = C.options.findIndex((ee) => !ee.dataRef.current.disabled);
      if (V !== -1) return V;
    }
    return C.activeOptionIndex;
  }, calculateIndex: F, compare: K, isSelected: N, isActive: O, nullable: u, __demoMode: c }), [y, r, l, d, u, c, C, f]);
  Re(() => {
  }, [f, void 0]), Re(() => {
    C.dataRef.current = E;
  }, [E]), tb([E.buttonRef, E.inputRef, E.optionsRef], () => Y.closeCombobox(), E.comboboxState === 0);
  let M = Be(() => {
    var V, ee, ye;
    return { open: E.comboboxState === 0, disabled: l, activeIndex: E.activeOptionIndex, activeOption: E.activeOptionIndex === null ? null : E.virtual ? E.virtual.options[(V = E.activeOptionIndex) != null ? V : 0] : (ye = (ee = E.options[E.activeOptionIndex]) == null ? void 0 : ee.dataRef.current.value) != null ? ye : null, value: y };
  }, [E, l, y]), $ = re(() => {
    if (E.activeOptionIndex !== null) {
      if (E.virtual) de(E.virtual.options[E.activeOptionIndex]);
      else {
        let { dataRef: V } = E.options[E.activeOptionIndex];
        de(V.current.value);
      }
      Y.goToOption(be.Specific, E.activeOptionIndex);
    }
  }), I = re(() => {
    T({ type: 0 }), A.current = !0;
  }), P = re(() => {
    T({ type: 1 }), A.current = !1;
  }), q = re((V, ee, ye) => (A.current = !1, V === be.Specific ? T({ type: 2, focus: be.Specific, idx: ee, trigger: ye }) : T({ type: 2, focus: V, trigger: ye }))), J = re((V, ee) => (T({ type: 3, payload: { id: V, dataRef: ee } }), () => {
    E.isActive(ee.current.value) && (A.current = !0), T({ type: 4, id: V });
  })), me = re((V) => (T({ type: 5, id: V }), () => T({ type: 5, id: null }))), de = re((V) => st(E.mode, { 0() {
    return S == null ? void 0 : S(V);
  }, 1() {
    let ee = E.value.slice(), ye = ee.findIndex((Je) => K(Je, V));
    return ye === -1 ? ee.push(V) : ee.splice(ye, 1), S == null ? void 0 : S(ee);
  } })), se = re((V) => {
    T({ type: 6, trigger: V });
  }), Y = Be(() => ({ onChange: de, registerOption: J, registerLabel: me, goToOption: q, closeCombobox: P, openCombobox: I, setActivationTrigger: se, selectActiveOption: $ }), []), He = t === null ? {} : { ref: t }, Ee = ae(null), ve = zi();
  return le(() => {
    Ee.current && r !== void 0 && ve.addEventListener(Ee.current, "reset", () => {
      S == null || S(r);
    });
  }, [Ee, S]), z.createElement(Hi.Provider, { value: Y }, z.createElement(Ki.Provider, { value: E }, z.createElement(pb, { value: st(E.comboboxState, { 0: $n.Open, 1: $n.Closed }) }, a != null && y != null && Fc({ [a]: y }).map(([V, ee], ye) => z.createElement(db, { features: Dc.Hidden, ref: ye === 0 ? (Je) => {
    var Ke;
    Ee.current = (Ke = Je == null ? void 0 : Je.closest("form")) != null ? Ke : null;
  } : void 0, ...ii({ key: V, as: "input", type: "hidden", hidden: !0, readOnly: !0, form: i, disabled: l, name: V, value: ee }) })), Ut({ ourProps: He, theirProps: m, slot: M, defaultTag: Rb, name: "Combobox" }))));
}
let Nb = "input";
function Cb(e, t) {
  var n, r, o, i, a;
  let s = Xn(), { id: l = `headlessui-combobox-input-${s}`, onChange: c, displayValue: u, type: d = "text", ...h } = e, p = Ht("Combobox.Input"), m = Jn("Combobox.Input"), v = Zn(p.inputRef, t), f = nb(p.inputRef), y = ae(!1), S = zi(), C = re(() => {
    m.onChange(null), p.optionsRef.current && (p.optionsRef.current.scrollTop = 0), m.goToOption(be.Nothing);
  }), T = function() {
    var E;
    return typeof u == "function" && p.value !== void 0 ? (E = u(p.value)) != null ? E : "" : typeof p.value == "string" ? p.value : "";
  }();
  Qa(([E, M], [$, I]) => {
    if (y.current) return;
    let P = p.inputRef.current;
    P && ((I === 0 && M === 1 || E !== $) && (P.value = E), requestAnimationFrame(() => {
      if (y.current || !P || (f == null ? void 0 : f.activeElement) !== P) return;
      let { selectionStart: q, selectionEnd: J } = P;
      Math.abs((J ?? 0) - (q ?? 0)) === 0 && q === 0 && P.setSelectionRange(P.value.length, P.value.length);
    }));
  }, [T, p.comboboxState, f]), Qa(([E], [M]) => {
    if (E === 0 && M === 1) {
      if (y.current) return;
      let $ = p.inputRef.current;
      if (!$) return;
      let I = $.value, { selectionStart: P, selectionEnd: q, selectionDirection: J } = $;
      $.value = "", $.value = I, J !== null ? $.setSelectionRange(P, q, J) : $.setSelectionRange(P, q);
    }
  }, [p.comboboxState]);
  let A = ae(!1), U = re(() => {
    A.current = !0;
  }), L = re(() => {
    S.nextFrame(() => {
      A.current = !1;
    });
  }), H = re((E) => {
    switch (y.current = !0, E.key) {
      case Pe.Enter:
        if (y.current = !1, p.comboboxState !== 0 || A.current) return;
        if (E.preventDefault(), E.stopPropagation(), p.activeOptionIndex === null) {
          m.closeCombobox();
          return;
        }
        m.selectActiveOption(), p.mode === 0 && m.closeCombobox();
        break;
      case Pe.ArrowDown:
        return y.current = !1, E.preventDefault(), E.stopPropagation(), st(p.comboboxState, { 0: () => m.goToOption(be.Next), 1: () => m.openCombobox() });
      case Pe.ArrowUp:
        return y.current = !1, E.preventDefault(), E.stopPropagation(), st(p.comboboxState, { 0: () => m.goToOption(be.Previous), 1: () => {
          m.openCombobox(), S.nextFrame(() => {
            p.value || m.goToOption(be.Last);
          });
        } });
      case Pe.Home:
        if (E.shiftKey) break;
        return y.current = !1, E.preventDefault(), E.stopPropagation(), m.goToOption(be.First);
      case Pe.PageUp:
        return y.current = !1, E.preventDefault(), E.stopPropagation(), m.goToOption(be.First);
      case Pe.End:
        if (E.shiftKey) break;
        return y.current = !1, E.preventDefault(), E.stopPropagation(), m.goToOption(be.Last);
      case Pe.PageDown:
        return y.current = !1, E.preventDefault(), E.stopPropagation(), m.goToOption(be.Last);
      case Pe.Escape:
        return y.current = !1, p.comboboxState !== 0 ? void 0 : (E.preventDefault(), p.optionsRef.current && !p.optionsPropsRef.current.static && E.stopPropagation(), p.nullable && p.mode === 0 && p.value === null && C(), m.closeCombobox());
      case Pe.Tab:
        if (y.current = !1, p.comboboxState !== 0) return;
        p.mode === 0 && p.activationTrigger !== 1 && m.selectActiveOption(), m.closeCombobox();
        break;
    }
  }), G = re((E) => {
    c == null || c(E), p.nullable && p.mode === 0 && E.target.value === "" && C(), m.openCombobox();
  }), W = re((E) => {
    var M, $, I;
    let P = (M = E.relatedTarget) != null ? M : Tt.find((q) => q !== E.currentTarget);
    if (y.current = !1, !(($ = p.optionsRef.current) != null && $.contains(P)) && !((I = p.buttonRef.current) != null && I.contains(P)) && p.comboboxState === 0) return E.preventDefault(), p.mode === 0 && (p.nullable && p.value === null ? C() : p.activationTrigger !== 1 && m.selectActiveOption()), m.closeCombobox();
  }), K = re((E) => {
    var M, $, I;
    let P = (M = E.relatedTarget) != null ? M : Tt.find((q) => q !== E.currentTarget);
    ($ = p.buttonRef.current) != null && $.contains(P) || (I = p.optionsRef.current) != null && I.contains(P) || p.disabled || p.immediate && p.comboboxState !== 0 && (m.openCombobox(), S.nextFrame(() => {
      m.setActivationTrigger(1);
    }));
  }), F = Bi(() => {
    if (p.labelId) return [p.labelId].join(" ");
  }, [p.labelId]), N = Be(() => ({ open: p.comboboxState === 0, disabled: p.disabled }), [p]), O = { ref: v, id: l, role: "combobox", type: d, "aria-controls": (n = p.optionsRef.current) == null ? void 0 : n.id, "aria-expanded": p.comboboxState === 0, "aria-activedescendant": p.activeOptionIndex === null ? void 0 : p.virtual ? (r = p.options.find((E) => {
    var M;
    return !((M = p.virtual) != null && M.disabled(E.dataRef.current.value)) && p.compare(E.dataRef.current.value, p.virtual.options[p.activeOptionIndex]);
  })) == null ? void 0 : r.id : (o = p.options[p.activeOptionIndex]) == null ? void 0 : o.id, "aria-labelledby": F, "aria-autocomplete": "list", defaultValue: (a = (i = e.defaultValue) != null ? i : p.defaultValue !== void 0 ? u == null ? void 0 : u(p.defaultValue) : null) != null ? a : p.defaultValue, disabled: p.disabled, onCompositionStart: U, onCompositionEnd: L, onKeyDown: H, onChange: G, onFocus: K, onBlur: W };
  return Ut({ ourProps: O, theirProps: h, slot: N, defaultTag: Nb, name: "Combobox.Input" });
}
let Tb = "button";
function jb(e, t) {
  var n;
  let r = Ht("Combobox.Button"), o = Jn("Combobox.Button"), i = Zn(r.buttonRef, t), a = Xn(), { id: s = `headlessui-combobox-button-${a}`, ...l } = e, c = zi(), u = re((v) => {
    switch (v.key) {
      case Pe.ArrowDown:
        return v.preventDefault(), v.stopPropagation(), r.comboboxState === 1 && o.openCombobox(), c.nextFrame(() => {
          var f;
          return (f = r.inputRef.current) == null ? void 0 : f.focus({ preventScroll: !0 });
        });
      case Pe.ArrowUp:
        return v.preventDefault(), v.stopPropagation(), r.comboboxState === 1 && (o.openCombobox(), c.nextFrame(() => {
          r.value || o.goToOption(be.Last);
        })), c.nextFrame(() => {
          var f;
          return (f = r.inputRef.current) == null ? void 0 : f.focus({ preventScroll: !0 });
        });
      case Pe.Escape:
        return r.comboboxState !== 0 ? void 0 : (v.preventDefault(), r.optionsRef.current && !r.optionsPropsRef.current.static && v.stopPropagation(), o.closeCombobox(), c.nextFrame(() => {
          var f;
          return (f = r.inputRef.current) == null ? void 0 : f.focus({ preventScroll: !0 });
        }));
      default:
        return;
    }
  }), d = re((v) => {
    if (mb(v.currentTarget)) return v.preventDefault();
    r.comboboxState === 0 ? o.closeCombobox() : (v.preventDefault(), o.openCombobox()), c.nextFrame(() => {
      var f;
      return (f = r.inputRef.current) == null ? void 0 : f.focus({ preventScroll: !0 });
    });
  }), h = Bi(() => {
    if (r.labelId) return [r.labelId, s].join(" ");
  }, [r.labelId, s]), p = Be(() => ({ open: r.comboboxState === 0, disabled: r.disabled, value: r.value }), [r]), m = { ref: i, id: s, type: rb(e, r.buttonRef), tabIndex: -1, "aria-haspopup": "listbox", "aria-controls": (n = r.optionsRef.current) == null ? void 0 : n.id, "aria-expanded": r.comboboxState === 0, "aria-labelledby": h, disabled: r.disabled, onClick: d, onKeyDown: u };
  return Ut({ ourProps: m, theirProps: l, slot: p, defaultTag: Tb, name: "Combobox.Button" });
}
let kb = "label";
function Pb(e, t) {
  let n = Xn(), { id: r = `headlessui-combobox-label-${n}`, ...o } = e, i = Ht("Combobox.Label"), a = Jn("Combobox.Label"), s = Zn(i.labelRef, t);
  Re(() => a.registerLabel(r), [r]);
  let l = re(() => {
    var u;
    return (u = i.inputRef.current) == null ? void 0 : u.focus({ preventScroll: !0 });
  }), c = Be(() => ({ open: i.comboboxState === 0, disabled: i.disabled }), [i]);
  return Ut({ ourProps: { ref: s, id: r, onClick: l }, theirProps: o, slot: c, defaultTag: kb, name: "Combobox.Label" });
}
let Ab = "ul", Lb = oi.RenderStrategy | oi.Static;
function Ib(e, t) {
  let n = Xn(), { id: r = `headlessui-combobox-options-${n}`, hold: o = !1, ...i } = e, a = Ht("Combobox.Options"), s = Zn(a.optionsRef, t), l = fb(), c = l !== null ? (l & $n.Open) === $n.Open : a.comboboxState === 0;
  Re(() => {
    var p;
    a.optionsPropsRef.current.static = (p = e.static) != null ? p : !1;
  }, [a.optionsPropsRef, e.static]), Re(() => {
    a.optionsPropsRef.current.hold = o;
  }, [a.optionsPropsRef, o]), ab({ container: a.optionsRef.current, enabled: a.comboboxState === 0, accept(p) {
    return p.getAttribute("role") === "option" ? NodeFilter.FILTER_REJECT : p.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
  }, walk(p) {
    p.setAttribute("role", "none");
  } });
  let u = Bi(() => {
    var p, m;
    return (m = a.labelId) != null ? m : (p = a.buttonRef.current) == null ? void 0 : p.id;
  }, [a.labelId, a.buttonRef.current]), d = Be(() => ({ open: a.comboboxState === 0, option: void 0 }), [a]), h = { "aria-labelledby": u, role: "listbox", "aria-multiselectable": a.mode === 1 ? !0 : void 0, id: r, ref: s };
  return a.virtual && a.comboboxState === 0 && Object.assign(i, { children: z.createElement(Sb, null, i.children) }), Ut({ ourProps: h, theirProps: i, slot: d, defaultTag: Ab, features: Lb, visible: c, name: "Combobox.Options" });
}
let Db = "li";
function Fb(e, t) {
  var n;
  let r = Xn(), { id: o = `headlessui-combobox-option-${r}`, disabled: i = !1, value: a, order: s = null, ...l } = e, c = Ht("Combobox.Option"), u = Jn("Combobox.Option"), d = c.virtual ? c.activeOptionIndex === c.calculateIndex(a) : c.activeOptionIndex === null ? !1 : ((n = c.options[c.activeOptionIndex]) == null ? void 0 : n.id) === o, h = c.isSelected(a), p = ae(null), m = Yn({ disabled: i, value: a, domRef: p, order: s }), v = rt(Bc), f = Zn(t, p, v ? v.measureElement : null), y = re(() => u.onChange(a));
  Re(() => u.registerOption(o, m), [m, o]);
  let S = ae(!(c.virtual || c.__demoMode));
  Re(() => {
    if (!c.virtual || !c.__demoMode) return;
    let W = Dr();
    return W.requestAnimationFrame(() => {
      S.current = !0;
    }), W.dispose;
  }, [c.virtual, c.__demoMode]), Re(() => {
    if (!S.current || c.comboboxState !== 0 || !d || c.activationTrigger === 0) return;
    let W = Dr();
    return W.requestAnimationFrame(() => {
      var K, F;
      (F = (K = p.current) == null ? void 0 : K.scrollIntoView) == null || F.call(K, { block: "nearest" });
    }), W.dispose;
  }, [p, d, c.comboboxState, c.activationTrigger, c.activeOptionIndex]);
  let C = re((W) => {
    var K;
    if (i || (K = c.virtual) != null && K.disabled(a)) return W.preventDefault();
    y(), Lc() || requestAnimationFrame(() => {
      var F;
      return (F = c.inputRef.current) == null ? void 0 : F.focus({ preventScroll: !0 });
    }), c.mode === 0 && requestAnimationFrame(() => u.closeCombobox());
  }), T = re(() => {
    var W;
    if (i || (W = c.virtual) != null && W.disabled(a)) return u.goToOption(be.Nothing);
    let K = c.calculateIndex(a);
    u.goToOption(be.Specific, K);
  }), A = ib(), U = re((W) => A.update(W)), L = re((W) => {
    var K;
    if (!A.wasMoved(W) || i || (K = c.virtual) != null && K.disabled(a) || d) return;
    let F = c.calculateIndex(a);
    u.goToOption(be.Specific, F, 0);
  }), H = re((W) => {
    var K;
    A.wasMoved(W) && (i || (K = c.virtual) != null && K.disabled(a) || d && (c.optionsPropsRef.current.hold || u.goToOption(be.Nothing)));
  }), G = Be(() => ({ active: d, selected: h, disabled: i }), [d, h, i]);
  return Ut({ ourProps: { id: o, ref: f, role: "option", tabIndex: i === !0 ? void 0 : -1, "aria-disabled": i === !0 ? !0 : void 0, "aria-selected": h, disabled: void 0, onClick: C, onFocus: T, onPointerEnter: U, onMouseEnter: U, onPointerMove: L, onMouseMove: L, onPointerLeave: H, onMouseLeave: H }, theirProps: l, slot: G, defaultTag: Db, name: "Combobox.Option" });
}
let Mb = Wt(Ob), $b = Wt(jb), Bb = Wt(Cb), zb = Wt(Pb), Ub = Wt(Ib), Wb = Wt(Fb);
Object.assign(Mb, { Input: Bb, Button: $b, Label: zb, Options: Ub, Option: Wb });
var Fr = { exports: {} };
Fr.exports;
(function(e, t) {
  var n = 200, r = "__lodash_hash_undefined__", o = 1, i = 2, a = 9007199254740991, s = "[object Arguments]", l = "[object Array]", c = "[object AsyncFunction]", u = "[object Boolean]", d = "[object Date]", h = "[object Error]", p = "[object Function]", m = "[object GeneratorFunction]", v = "[object Map]", f = "[object Number]", y = "[object Null]", S = "[object Object]", C = "[object Promise]", T = "[object Proxy]", A = "[object RegExp]", U = "[object Set]", L = "[object String]", H = "[object Symbol]", G = "[object Undefined]", W = "[object WeakMap]", K = "[object ArrayBuffer]", F = "[object DataView]", N = "[object Float32Array]", O = "[object Float64Array]", E = "[object Int8Array]", M = "[object Int16Array]", $ = "[object Int32Array]", I = "[object Uint8Array]", P = "[object Uint8ClampedArray]", q = "[object Uint16Array]", J = "[object Uint32Array]", me = /[\\^$.*+?()[\]{}|]/g, de = /^\[object .+?Constructor\]$/, se = /^(?:0|[1-9]\d*)$/, Y = {};
  Y[N] = Y[O] = Y[E] = Y[M] = Y[$] = Y[I] = Y[P] = Y[q] = Y[J] = !0, Y[s] = Y[l] = Y[K] = Y[u] = Y[F] = Y[d] = Y[h] = Y[p] = Y[v] = Y[f] = Y[S] = Y[A] = Y[U] = Y[L] = Y[W] = !1;
  var He = typeof vr == "object" && vr && vr.Object === Object && vr, Ee = typeof self == "object" && self && self.Object === Object && self, ve = He || Ee || Function("return this")(), V = t && !t.nodeType && t, ee = V && !0 && e && !e.nodeType && e, ye = ee && ee.exports === V, Je = ye && He.process, Ke = function() {
    try {
      return Je && Je.binding && Je.binding("util");
    } catch {
    }
  }(), tr = Ke && Ke.isTypedArray;
  function uo(g, w) {
    for (var j = -1, B = g == null ? 0 : g.length, ie = 0, Z = []; ++j < B; ) {
      var fe = g[j];
      w(fe, j, g) && (Z[ie++] = fe);
    }
    return Z;
  }
  function fo(g, w) {
    for (var j = -1, B = w.length, ie = g.length; ++j < B; )
      g[ie + j] = w[j];
    return g;
  }
  function po(g, w) {
    for (var j = -1, B = g == null ? 0 : g.length; ++j < B; )
      if (w(g[j], j, g))
        return !0;
    return !1;
  }
  function ho(g, w) {
    for (var j = -1, B = Array(g); ++j < g; )
      B[j] = w(j);
    return B;
  }
  function Vt(g) {
    return function(w) {
      return g(w);
    };
  }
  function Nu(g, w) {
    return g.has(w);
  }
  function Cu(g, w) {
    return g == null ? void 0 : g[w];
  }
  function Tu(g) {
    var w = -1, j = Array(g.size);
    return g.forEach(function(B, ie) {
      j[++w] = [ie, B];
    }), j;
  }
  function ju(g, w) {
    return function(j) {
      return g(w(j));
    };
  }
  function ku(g) {
    var w = -1, j = Array(g.size);
    return g.forEach(function(B) {
      j[++w] = B;
    }), j;
  }
  var Pu = Array.prototype, Au = Function.prototype, nr = Object.prototype, mo = ve["__core-js_shared__"], Qi = Au.toString, Qe = nr.hasOwnProperty, ea = function() {
    var g = /[^.]+$/.exec(mo && mo.keys && mo.keys.IE_PROTO || "");
    return g ? "Symbol(src)_1." + g : "";
  }(), ta = nr.toString, Lu = RegExp(
    "^" + Qi.call(Qe).replace(me, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), na = ye ? ve.Buffer : void 0, rr = ve.Symbol, ra = ve.Uint8Array, oa = nr.propertyIsEnumerable, Iu = Pu.splice, St = rr ? rr.toStringTag : void 0, ia = Object.getOwnPropertySymbols, Du = na ? na.isBuffer : void 0, Fu = ju(Object.keys, Object), vo = Gt(ve, "DataView"), un = Gt(ve, "Map"), go = Gt(ve, "Promise"), bo = Gt(ve, "Set"), yo = Gt(ve, "WeakMap"), dn = Gt(Object, "create"), Mu = Ot(vo), $u = Ot(un), Bu = Ot(go), zu = Ot(bo), Uu = Ot(yo), aa = rr ? rr.prototype : void 0, wo = aa ? aa.valueOf : void 0;
  function _t(g) {
    var w = -1, j = g == null ? 0 : g.length;
    for (this.clear(); ++w < j; ) {
      var B = g[w];
      this.set(B[0], B[1]);
    }
  }
  function Wu() {
    this.__data__ = dn ? dn(null) : {}, this.size = 0;
  }
  function Hu(g) {
    var w = this.has(g) && delete this.__data__[g];
    return this.size -= w ? 1 : 0, w;
  }
  function Ku(g) {
    var w = this.__data__;
    if (dn) {
      var j = w[g];
      return j === r ? void 0 : j;
    }
    return Qe.call(w, g) ? w[g] : void 0;
  }
  function qu(g) {
    var w = this.__data__;
    return dn ? w[g] !== void 0 : Qe.call(w, g);
  }
  function Vu(g, w) {
    var j = this.__data__;
    return this.size += this.has(g) ? 0 : 1, j[g] = dn && w === void 0 ? r : w, this;
  }
  _t.prototype.clear = Wu, _t.prototype.delete = Hu, _t.prototype.get = Ku, _t.prototype.has = qu, _t.prototype.set = Vu;
  function it(g) {
    var w = -1, j = g == null ? 0 : g.length;
    for (this.clear(); ++w < j; ) {
      var B = g[w];
      this.set(B[0], B[1]);
    }
  }
  function Gu() {
    this.__data__ = [], this.size = 0;
  }
  function Yu(g) {
    var w = this.__data__, j = ir(w, g);
    if (j < 0)
      return !1;
    var B = w.length - 1;
    return j == B ? w.pop() : Iu.call(w, j, 1), --this.size, !0;
  }
  function Xu(g) {
    var w = this.__data__, j = ir(w, g);
    return j < 0 ? void 0 : w[j][1];
  }
  function Zu(g) {
    return ir(this.__data__, g) > -1;
  }
  function Ju(g, w) {
    var j = this.__data__, B = ir(j, g);
    return B < 0 ? (++this.size, j.push([g, w])) : j[B][1] = w, this;
  }
  it.prototype.clear = Gu, it.prototype.delete = Yu, it.prototype.get = Xu, it.prototype.has = Zu, it.prototype.set = Ju;
  function Rt(g) {
    var w = -1, j = g == null ? 0 : g.length;
    for (this.clear(); ++w < j; ) {
      var B = g[w];
      this.set(B[0], B[1]);
    }
  }
  function Qu() {
    this.size = 0, this.__data__ = {
      hash: new _t(),
      map: new (un || it)(),
      string: new _t()
    };
  }
  function ed(g) {
    var w = ar(this, g).delete(g);
    return this.size -= w ? 1 : 0, w;
  }
  function td(g) {
    return ar(this, g).get(g);
  }
  function nd(g) {
    return ar(this, g).has(g);
  }
  function rd(g, w) {
    var j = ar(this, g), B = j.size;
    return j.set(g, w), this.size += j.size == B ? 0 : 1, this;
  }
  Rt.prototype.clear = Qu, Rt.prototype.delete = ed, Rt.prototype.get = td, Rt.prototype.has = nd, Rt.prototype.set = rd;
  function or(g) {
    var w = -1, j = g == null ? 0 : g.length;
    for (this.__data__ = new Rt(); ++w < j; )
      this.add(g[w]);
  }
  function od(g) {
    return this.__data__.set(g, r), this;
  }
  function id(g) {
    return this.__data__.has(g);
  }
  or.prototype.add = or.prototype.push = od, or.prototype.has = id;
  function ut(g) {
    var w = this.__data__ = new it(g);
    this.size = w.size;
  }
  function ad() {
    this.__data__ = new it(), this.size = 0;
  }
  function sd(g) {
    var w = this.__data__, j = w.delete(g);
    return this.size = w.size, j;
  }
  function ld(g) {
    return this.__data__.get(g);
  }
  function cd(g) {
    return this.__data__.has(g);
  }
  function ud(g, w) {
    var j = this.__data__;
    if (j instanceof it) {
      var B = j.__data__;
      if (!un || B.length < n - 1)
        return B.push([g, w]), this.size = ++j.size, this;
      j = this.__data__ = new Rt(B);
    }
    return j.set(g, w), this.size = j.size, this;
  }
  ut.prototype.clear = ad, ut.prototype.delete = sd, ut.prototype.get = ld, ut.prototype.has = cd, ut.prototype.set = ud;
  function dd(g, w) {
    var j = sr(g), B = !j && Od(g), ie = !j && !B && xo(g), Z = !j && !B && !ie && ma(g), fe = j || B || ie || Z, we = fe ? ho(g.length, String) : [], xe = we.length;
    for (var ce in g)
      Qe.call(g, ce) && !(fe && // Safari 9 has enumerable `arguments.length` in strict mode.
      (ce == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      ie && (ce == "offset" || ce == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      Z && (ce == "buffer" || ce == "byteLength" || ce == "byteOffset") || // Skip index properties.
      xd(ce, xe))) && we.push(ce);
    return we;
  }
  function ir(g, w) {
    for (var j = g.length; j--; )
      if (da(g[j][0], w))
        return j;
    return -1;
  }
  function fd(g, w, j) {
    var B = w(g);
    return sr(g) ? B : fo(B, j(g));
  }
  function fn(g) {
    return g == null ? g === void 0 ? G : y : St && St in Object(g) ? yd(g) : Rd(g);
  }
  function sa(g) {
    return pn(g) && fn(g) == s;
  }
  function la(g, w, j, B, ie) {
    return g === w ? !0 : g == null || w == null || !pn(g) && !pn(w) ? g !== g && w !== w : pd(g, w, j, B, la, ie);
  }
  function pd(g, w, j, B, ie, Z) {
    var fe = sr(g), we = sr(w), xe = fe ? l : dt(g), ce = we ? l : dt(w);
    xe = xe == s ? S : xe, ce = ce == s ? S : ce;
    var ke = xe == S, qe = ce == S, Se = xe == ce;
    if (Se && xo(g)) {
      if (!xo(w))
        return !1;
      fe = !0, ke = !1;
    }
    if (Se && !ke)
      return Z || (Z = new ut()), fe || ma(g) ? ca(g, w, j, B, ie, Z) : gd(g, w, xe, j, B, ie, Z);
    if (!(j & o)) {
      var De = ke && Qe.call(g, "__wrapped__"), Fe = qe && Qe.call(w, "__wrapped__");
      if (De || Fe) {
        var ft = De ? g.value() : g, at = Fe ? w.value() : w;
        return Z || (Z = new ut()), ie(ft, at, j, B, Z);
      }
    }
    return Se ? (Z || (Z = new ut()), bd(g, w, j, B, ie, Z)) : !1;
  }
  function hd(g) {
    if (!ha(g) || Sd(g))
      return !1;
    var w = fa(g) ? Lu : de;
    return w.test(Ot(g));
  }
  function md(g) {
    return pn(g) && pa(g.length) && !!Y[fn(g)];
  }
  function vd(g) {
    if (!_d(g))
      return Fu(g);
    var w = [];
    for (var j in Object(g))
      Qe.call(g, j) && j != "constructor" && w.push(j);
    return w;
  }
  function ca(g, w, j, B, ie, Z) {
    var fe = j & o, we = g.length, xe = w.length;
    if (we != xe && !(fe && xe > we))
      return !1;
    var ce = Z.get(g);
    if (ce && Z.get(w))
      return ce == w;
    var ke = -1, qe = !0, Se = j & i ? new or() : void 0;
    for (Z.set(g, w), Z.set(w, g); ++ke < we; ) {
      var De = g[ke], Fe = w[ke];
      if (B)
        var ft = fe ? B(Fe, De, ke, w, g, Z) : B(De, Fe, ke, g, w, Z);
      if (ft !== void 0) {
        if (ft)
          continue;
        qe = !1;
        break;
      }
      if (Se) {
        if (!po(w, function(at, Nt) {
          if (!Nu(Se, Nt) && (De === at || ie(De, at, j, B, Z)))
            return Se.push(Nt);
        })) {
          qe = !1;
          break;
        }
      } else if (!(De === Fe || ie(De, Fe, j, B, Z))) {
        qe = !1;
        break;
      }
    }
    return Z.delete(g), Z.delete(w), qe;
  }
  function gd(g, w, j, B, ie, Z, fe) {
    switch (j) {
      case F:
        if (g.byteLength != w.byteLength || g.byteOffset != w.byteOffset)
          return !1;
        g = g.buffer, w = w.buffer;
      case K:
        return !(g.byteLength != w.byteLength || !Z(new ra(g), new ra(w)));
      case u:
      case d:
      case f:
        return da(+g, +w);
      case h:
        return g.name == w.name && g.message == w.message;
      case A:
      case L:
        return g == w + "";
      case v:
        var we = Tu;
      case U:
        var xe = B & o;
        if (we || (we = ku), g.size != w.size && !xe)
          return !1;
        var ce = fe.get(g);
        if (ce)
          return ce == w;
        B |= i, fe.set(g, w);
        var ke = ca(we(g), we(w), B, ie, Z, fe);
        return fe.delete(g), ke;
      case H:
        if (wo)
          return wo.call(g) == wo.call(w);
    }
    return !1;
  }
  function bd(g, w, j, B, ie, Z) {
    var fe = j & o, we = ua(g), xe = we.length, ce = ua(w), ke = ce.length;
    if (xe != ke && !fe)
      return !1;
    for (var qe = xe; qe--; ) {
      var Se = we[qe];
      if (!(fe ? Se in w : Qe.call(w, Se)))
        return !1;
    }
    var De = Z.get(g);
    if (De && Z.get(w))
      return De == w;
    var Fe = !0;
    Z.set(g, w), Z.set(w, g);
    for (var ft = fe; ++qe < xe; ) {
      Se = we[qe];
      var at = g[Se], Nt = w[Se];
      if (B)
        var va = fe ? B(Nt, at, Se, w, g, Z) : B(at, Nt, Se, g, w, Z);
      if (!(va === void 0 ? at === Nt || ie(at, Nt, j, B, Z) : va)) {
        Fe = !1;
        break;
      }
      ft || (ft = Se == "constructor");
    }
    if (Fe && !ft) {
      var lr = g.constructor, cr = w.constructor;
      lr != cr && "constructor" in g && "constructor" in w && !(typeof lr == "function" && lr instanceof lr && typeof cr == "function" && cr instanceof cr) && (Fe = !1);
    }
    return Z.delete(g), Z.delete(w), Fe;
  }
  function ua(g) {
    return fd(g, Td, wd);
  }
  function ar(g, w) {
    var j = g.__data__;
    return Ed(w) ? j[typeof w == "string" ? "string" : "hash"] : j.map;
  }
  function Gt(g, w) {
    var j = Cu(g, w);
    return hd(j) ? j : void 0;
  }
  function yd(g) {
    var w = Qe.call(g, St), j = g[St];
    try {
      g[St] = void 0;
      var B = !0;
    } catch {
    }
    var ie = ta.call(g);
    return B && (w ? g[St] = j : delete g[St]), ie;
  }
  var wd = ia ? function(g) {
    return g == null ? [] : (g = Object(g), uo(ia(g), function(w) {
      return oa.call(g, w);
    }));
  } : jd, dt = fn;
  (vo && dt(new vo(new ArrayBuffer(1))) != F || un && dt(new un()) != v || go && dt(go.resolve()) != C || bo && dt(new bo()) != U || yo && dt(new yo()) != W) && (dt = function(g) {
    var w = fn(g), j = w == S ? g.constructor : void 0, B = j ? Ot(j) : "";
    if (B)
      switch (B) {
        case Mu:
          return F;
        case $u:
          return v;
        case Bu:
          return C;
        case zu:
          return U;
        case Uu:
          return W;
      }
    return w;
  });
  function xd(g, w) {
    return w = w ?? a, !!w && (typeof g == "number" || se.test(g)) && g > -1 && g % 1 == 0 && g < w;
  }
  function Ed(g) {
    var w = typeof g;
    return w == "string" || w == "number" || w == "symbol" || w == "boolean" ? g !== "__proto__" : g === null;
  }
  function Sd(g) {
    return !!ea && ea in g;
  }
  function _d(g) {
    var w = g && g.constructor, j = typeof w == "function" && w.prototype || nr;
    return g === j;
  }
  function Rd(g) {
    return ta.call(g);
  }
  function Ot(g) {
    if (g != null) {
      try {
        return Qi.call(g);
      } catch {
      }
      try {
        return g + "";
      } catch {
      }
    }
    return "";
  }
  function da(g, w) {
    return g === w || g !== g && w !== w;
  }
  var Od = sa(/* @__PURE__ */ function() {
    return arguments;
  }()) ? sa : function(g) {
    return pn(g) && Qe.call(g, "callee") && !oa.call(g, "callee");
  }, sr = Array.isArray;
  function Nd(g) {
    return g != null && pa(g.length) && !fa(g);
  }
  var xo = Du || kd;
  function Cd(g, w) {
    return la(g, w);
  }
  function fa(g) {
    if (!ha(g))
      return !1;
    var w = fn(g);
    return w == p || w == m || w == c || w == T;
  }
  function pa(g) {
    return typeof g == "number" && g > -1 && g % 1 == 0 && g <= a;
  }
  function ha(g) {
    var w = typeof g;
    return g != null && (w == "object" || w == "function");
  }
  function pn(g) {
    return g != null && typeof g == "object";
  }
  var ma = tr ? Vt(tr) : md;
  function Td(g) {
    return Nd(g) ? dd(g) : vd(g);
  }
  function jd() {
    return [];
  }
  function kd() {
    return !1;
  }
  e.exports = Cd;
})(Fr, Fr.exports);
Fr.exports;
z.forwardRef((e, t) => /* @__PURE__ */ D.jsx(Fi, { ...e, ref: t, pattern: "[0-9]*", inputMode: "numeric", spellCheck: "false" }));
z.forwardRef(
  ({ children: e, className: t, id: n, label: r, inline: o = !1, ...i }, a) => {
    const s = pe(t, "form-check", o && "form-check-inline");
    return /* @__PURE__ */ D.jsxs("div", { className: s, children: [
      /* @__PURE__ */ D.jsx(Et, { ...i, id: n, className: "form-check-input", ref: a, type: "radio" }),
      /* @__PURE__ */ D.jsx("label", { className: "form-check-label", htmlFor: n, children: r }),
      e
    ] });
  }
);
z.forwardRef(
  ({
    allowPlaceholderSelectionWhenRequired: e = !1,
    className: t,
    id: n,
    options: r,
    placeholder: o = "Select…",
    required: i = !1,
    size: a,
    value: s,
    onChange: l,
    ...c
  }, u) => /* @__PURE__ */ D.jsxs(
    Et,
    {
      ...c,
      className: pe(t, "custom-select", {
        [`custom-select-${a}`]: a
      }),
      id: n,
      ref: u,
      required: i,
      tag: "select",
      value: s,
      onChange: typeof l == "function" ? (d) => {
        l(d);
      } : void 0,
      children: [
        o && /* @__PURE__ */ D.jsx("option", { value: "", disabled: i && !e, children: o }),
        r.map((d) => /* @__PURE__ */ D.jsx("option", { value: d.value, disabled: d.disabled, children: d.label }, d.value))
      ]
    }
  )
);
z.forwardRef(
  ({ className: e, icon: t, variant: n = ro.primary, ...r }, o) => {
    const i = pe(e, "switch", `switch--${n}`);
    return /* @__PURE__ */ D.jsxs("label", { className: i, children: [
      /* @__PURE__ */ D.jsx(Et, { ...r, className: "switch__input", ref: o, type: "checkbox" }),
      /* @__PURE__ */ D.jsx("span", { className: "switch__label", children: t && /* @__PURE__ */ D.jsx(ni, { icon: t, className: `switch__icon text-${n}` }) })
    ] });
  }
);
var ai = { exports: {} }, si = { exports: {} }, Bn = 1e3, zn = Bn * 60, Un = zn * 60, Wn = Un * 24, Hb = Wn * 365.25, Kb = function(e, t) {
  t = t || {};
  var n = typeof e;
  if (n === "string" && e.length > 0)
    return qb(e);
  if (n === "number" && isNaN(e) === !1)
    return t.long ? Gb(e) : Vb(e);
  throw new Error(
    "val is not a non-empty string or a valid number. val=" + JSON.stringify(e)
  );
};
function qb(e) {
  if (e = String(e), !(e.length > 100)) {
    var t = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
      e
    );
    if (t) {
      var n = parseFloat(t[1]), r = (t[2] || "ms").toLowerCase();
      switch (r) {
        case "years":
        case "year":
        case "yrs":
        case "yr":
        case "y":
          return n * Hb;
        case "days":
        case "day":
        case "d":
          return n * Wn;
        case "hours":
        case "hour":
        case "hrs":
        case "hr":
        case "h":
          return n * Un;
        case "minutes":
        case "minute":
        case "mins":
        case "min":
        case "m":
          return n * zn;
        case "seconds":
        case "second":
        case "secs":
        case "sec":
        case "s":
          return n * Bn;
        case "milliseconds":
        case "millisecond":
        case "msecs":
        case "msec":
        case "ms":
          return n;
        default:
          return;
      }
    }
  }
}
function Vb(e) {
  return e >= Wn ? Math.round(e / Wn) + "d" : e >= Un ? Math.round(e / Un) + "h" : e >= zn ? Math.round(e / zn) + "m" : e >= Bn ? Math.round(e / Bn) + "s" : e + "ms";
}
function Gb(e) {
  return yr(e, Wn, "day") || yr(e, Un, "hour") || yr(e, zn, "minute") || yr(e, Bn, "second") || e + " ms";
}
function yr(e, t, n) {
  if (!(e < t))
    return e < t * 1.5 ? Math.floor(e / t) + " " + n : Math.ceil(e / t) + " " + n + "s";
}
(function(e, t) {
  t = e.exports = o.debug = o.default = o, t.coerce = l, t.disable = a, t.enable = i, t.enabled = s, t.humanize = Kb, t.names = [], t.skips = [], t.formatters = {};
  var n;
  function r(c) {
    var u = 0, d;
    for (d in c)
      u = (u << 5) - u + c.charCodeAt(d), u |= 0;
    return t.colors[Math.abs(u) % t.colors.length];
  }
  function o(c) {
    function u() {
      if (u.enabled) {
        var d = u, h = +/* @__PURE__ */ new Date(), p = h - (n || h);
        d.diff = p, d.prev = n, d.curr = h, n = h;
        for (var m = new Array(arguments.length), v = 0; v < m.length; v++)
          m[v] = arguments[v];
        m[0] = t.coerce(m[0]), typeof m[0] != "string" && m.unshift("%O");
        var f = 0;
        m[0] = m[0].replace(/%([a-zA-Z%])/g, function(S, C) {
          if (S === "%%") return S;
          f++;
          var T = t.formatters[C];
          if (typeof T == "function") {
            var A = m[f];
            S = T.call(d, A), m.splice(f, 1), f--;
          }
          return S;
        }), t.formatArgs.call(d, m);
        var y = u.log || t.log || console.log.bind(console);
        y.apply(d, m);
      }
    }
    return u.namespace = c, u.enabled = t.enabled(c), u.useColors = t.useColors(), u.color = r(c), typeof t.init == "function" && t.init(u), u;
  }
  function i(c) {
    t.save(c), t.names = [], t.skips = [];
    for (var u = (typeof c == "string" ? c : "").split(/[\s,]+/), d = u.length, h = 0; h < d; h++)
      u[h] && (c = u[h].replace(/\*/g, ".*?"), c[0] === "-" ? t.skips.push(new RegExp("^" + c.substr(1) + "$")) : t.names.push(new RegExp("^" + c + "$")));
  }
  function a() {
    t.enable("");
  }
  function s(c) {
    var u, d;
    for (u = 0, d = t.skips.length; u < d; u++)
      if (t.skips[u].test(c))
        return !1;
    for (u = 0, d = t.names.length; u < d; u++)
      if (t.names[u].test(c))
        return !0;
    return !1;
  }
  function l(c) {
    return c instanceof Error ? c.stack || c.message : c;
  }
})(si, si.exports);
var Yb = si.exports;
(function(e, t) {
  t = e.exports = Yb, t.log = o, t.formatArgs = r, t.save = i, t.load = a, t.useColors = n, t.storage = typeof chrome < "u" && typeof chrome.storage < "u" ? chrome.storage.local : s(), t.colors = [
    "lightseagreen",
    "forestgreen",
    "goldenrod",
    "dodgerblue",
    "darkorchid",
    "crimson"
  ];
  function n() {
    return typeof window < "u" && window.process && window.process.type === "renderer" ? !0 : typeof document < "u" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // is firebug? http://stackoverflow.com/a/398120/376773
    typeof window < "u" && window.console && (window.console.firebug || window.console.exception && window.console.table) || // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // double check webkit in userAgent just in case we are in a worker
    typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
  }
  t.formatters.j = function(l) {
    try {
      return JSON.stringify(l);
    } catch (c) {
      return "[UnexpectedJSONParseError]: " + c.message;
    }
  };
  function r(l) {
    var c = this.useColors;
    if (l[0] = (c ? "%c" : "") + this.namespace + (c ? " %c" : " ") + l[0] + (c ? "%c " : " ") + "+" + t.humanize(this.diff), !!c) {
      var u = "color: " + this.color;
      l.splice(1, 0, u, "color: inherit");
      var d = 0, h = 0;
      l[0].replace(/%[a-zA-Z%]/g, function(p) {
        p !== "%%" && (d++, p === "%c" && (h = d));
      }), l.splice(h, 0, u);
    }
  }
  function o() {
    return typeof console == "object" && console.log && Function.prototype.apply.call(console.log, console, arguments);
  }
  function i(l) {
    try {
      l == null ? t.storage.removeItem("debug") : t.storage.debug = l;
    } catch {
    }
  }
  function a() {
    var l;
    try {
      l = t.storage.debug;
    } catch {
    }
    return !l && typeof process < "u" && "env" in process && (l = process.env.DEBUG), l;
  }
  t.enable(a());
  function s() {
    try {
      return window.localStorage;
    } catch {
    }
  }
})(ai, ai.exports);
var Xb = ai.exports, ns = Xb("jsonp"), Zb = ey, Jb = 0;
function Qb() {
}
function ey(e, t, n) {
  typeof t == "function" && (n = t, t = {}), t || (t = {});
  var r = t.prefix || "__jp", o = t.name || r + Jb++, i = t.param || "callback", a = t.timeout != null ? t.timeout : 6e4, s = encodeURIComponent, l = document.getElementsByTagName("script")[0] || document.head, c, u;
  a && (u = setTimeout(function() {
    d(), n && n(new Error("Timeout"));
  }, a));
  function d() {
    c.parentNode && c.parentNode.removeChild(c), window[o] = Qb, u && clearTimeout(u);
  }
  function h() {
    window[o] && d();
  }
  return window[o] = function(p) {
    ns("jsonp got", p), d(), n && n(null, p);
  }, e += (~e.indexOf("?") ? "&" : "?") + i + "=" + s(o), e = e.replace("?&", "?"), ns('jsonp req "%s"', e), c = document.createElement("script"), c.src = e, l.parentNode.insertBefore(c, l), h;
}
const Kt = /* @__PURE__ */ yi(Zb);
var ty = Object.defineProperty, ny = Object.defineProperties, ry = Object.getOwnPropertyDescriptors, Mr = Object.getOwnPropertySymbols, zc = Object.prototype.hasOwnProperty, Uc = Object.prototype.propertyIsEnumerable, rs = (e, t, n) => t in e ? ty(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, $e = (e, t) => {
  for (var n in t || (t = {}))
    zc.call(t, n) && rs(e, n, t[n]);
  if (Mr)
    for (var n of Mr(t))
      Uc.call(t, n) && rs(e, n, t[n]);
  return e;
}, qi = (e, t) => ny(e, ry(t)), Vi = (e, t) => {
  var n = {};
  for (var r in e)
    zc.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && Mr)
    for (var r of Mr(e))
      t.indexOf(r) < 0 && Uc.call(e, r) && (n[r] = e[r]);
  return n;
};
function oe(e) {
  const t = Object.entries(e).filter(([, n]) => n != null).map(([n, r]) => `${encodeURIComponent(n)}=${encodeURIComponent(String(r))}`);
  return t.length > 0 ? `?${t.join("&")}` : "";
}
const oy = (e) => !!e && (typeof e == "object" || typeof e == "function") && typeof e.then == "function", iy = (e, t) => ({
  left: window.outerWidth / 2 + (window.screenX || window.screenLeft || 0) - e / 2,
  top: window.outerHeight / 2 + (window.screenY || window.screenTop || 0) - t / 2
}), ay = (e, t) => ({
  top: (window.screen.height - t) / 2,
  left: (window.screen.width - e) / 2
});
function sy(e, t, n) {
  var r = t, { height: o, width: i } = r, a = Vi(r, ["height", "width"]);
  const s = $e({
    height: o,
    width: i,
    location: "no",
    toolbar: "no",
    status: "no",
    directories: "no",
    menubar: "no",
    scrollbars: "yes",
    resizable: "no",
    centerscreen: "yes",
    chrome: "yes"
  }, a), l = window.open(
    e,
    "",
    Object.keys(s).map((c) => `${c}=${s[c]}`).join(", ")
  );
  if (n) {
    const c = window.setInterval(() => {
      try {
        (l === null || l.closed) && (window.clearInterval(c), n(l));
      } catch (u) {
        console.error(u);
      }
    }, 1e3);
  }
  return l;
}
function ly(e) {
  var t = e, {
    beforeOnClick: n,
    children: r,
    className: o,
    disabled: i,
    disabledStyle: a = { opacity: 0.6 },
    forwardedRef: s,
    htmlTitle: l,
    networkLink: c,
    networkName: u,
    onClick: d,
    onShareWindowClose: h,
    openShareDialogOnClick: p = !0,
    opts: m,
    resetButtonStyle: v = !0,
    style: f,
    url: y,
    windowHeight: S = 400,
    windowPosition: C = "windowCenter",
    windowWidth: T = 550
  } = t, A = Vi(t, [
    "beforeOnClick",
    "children",
    "className",
    "disabled",
    "disabledStyle",
    "forwardedRef",
    "htmlTitle",
    "networkLink",
    "networkName",
    "onClick",
    "onShareWindowClose",
    "openShareDialogOnClick",
    "opts",
    "resetButtonStyle",
    "style",
    "url",
    "windowHeight",
    "windowPosition",
    "windowWidth"
  ]);
  const U = async (G) => {
    const W = c(y, m);
    if (!i) {
      if (G.preventDefault(), n) {
        const K = n();
        oy(K) && await K;
      }
      if (p) {
        const K = $e({
          height: S,
          width: T
        }, C === "windowCenter" ? iy(T, S) : ay(T, S));
        sy(W, K, h);
      }
      d && d(G, W);
    }
  }, L = _e(
    "react-share__ShareButton",
    {
      "react-share__ShareButton--disabled": !!i,
      disabled: !!i
    },
    o
  ), H = $e($e(v ? {
    backgroundColor: "transparent",
    border: "none",
    padding: 0,
    font: "inherit",
    color: "inherit",
    cursor: "pointer"
  } : {}, f), i && a);
  return /* @__PURE__ */ R.jsx(
    "button",
    qi($e({}, A), {
      className: L,
      onClick: U,
      ref: s,
      style: H,
      title: l,
      children: r
    })
  );
}
function he(e, t, n, r) {
  function o(i, a) {
    const s = n(i), l = $e({}, i);
    return Object.keys(s).forEach((u) => {
      delete l[u];
    }), /* @__PURE__ */ R.jsx(
      ly,
      qi($e($e({}, r), l), {
        forwardedRef: a,
        networkName: e,
        networkLink: t,
        opts: n(i)
      })
    );
  }
  return o.displayName = `ShareButton-${e}`, We(o);
}
function cy(e, { subject: t, body: n, separator: r }) {
  return "mailto:" + oe({ subject: t, body: n ? n + r + e : e });
}
he(
  "email",
  cy,
  (e) => ({
    subject: e.subject,
    body: e.body,
    separator: e.separator || " "
  }),
  {
    openShareDialogOnClick: !1,
    onClick: (e, t) => {
      window.location.href = t;
    }
  }
);
function uy(e, { appId: t, redirectUri: n, to: r }) {
  return "https://www.facebook.com/dialog/send" + oe({
    link: e,
    redirect_uri: n || e,
    app_id: t,
    to: r
  });
}
he(
  "facebookmessenger",
  uy,
  (e) => ({
    appId: e.appId,
    redirectUri: e.redirectUri,
    to: e.to
  }),
  {
    windowWidth: 1e3,
    windowHeight: 820
  }
);
class dy extends Error {
  constructor(t) {
    super(t), this.name = "AssertionError";
  }
}
function ue(e, t) {
  if (!e)
    throw new dy(t);
}
function fy(e, { hashtag: t }) {
  return ue(e, "facebook.url"), "https://www.facebook.com/sharer/sharer.php" + oe({ u: e, hashtag: t });
}
const py = he(
  "facebook",
  fy,
  (e) => ({ hashtag: e.hashtag }),
  {
    windowWidth: 550,
    windowHeight: 400
  }
), hy = py;
function my() {
  const e = ae(!1);
  return le(() => (e.current = !0, () => {
    e.current = !1;
  }), []), bi(() => e.current, []);
}
function vy(e) {
  var t = e, {
    children: n = (h) => h,
    className: r,
    getCount: o,
    url: i
  } = t, a = Vi(t, [
    "children",
    "className",
    "getCount",
    "url"
  ]);
  const s = my(), [l, c] = Ue(void 0), [u, d] = Ue(!1);
  return le(() => {
    d(!0), o(i, (h) => {
      s() && (c(h), d(!1));
    });
  }, [i]), /* @__PURE__ */ R.jsx("span", qi($e({ className: _e("react-share__ShareCount", r) }, a), { children: !u && l !== void 0 && n(l) }));
}
function qt(e) {
  const t = (n) => /* @__PURE__ */ R.jsx(vy, $e({ getCount: e }, n));
  return t.displayName = `ShareCount(${e.name})`, t;
}
function gy(e, t) {
  const n = `https://graph.facebook.com/?id=${e}&fields=og_object{engagement}`;
  Kt(n, (r, o) => {
    t(
      !r && o && o.og_object && o.og_object.engagement ? o.og_object.engagement.count : void 0
    );
  });
}
qt(gy);
function by(e, { title: t }) {
  return ue(e, "hatena.url"), `http://b.hatena.ne.jp/add?mode=confirm&url=${e}&title=${t}`;
}
he(
  "hatena",
  by,
  (e) => ({
    title: e.title
  }),
  {
    windowWidth: 660,
    windowHeight: 460,
    windowPosition: "windowCenter"
  }
);
function yy(e, t) {
  Kt(
    "https://bookmark.hatenaapis.com/count/entry" + oe({
      url: e
    }),
    (r, o) => {
      t(o ?? void 0);
    }
  );
}
qt(yy);
function wy(e, { title: t, description: n }) {
  return ue(e, "instapaper.url"), "http://www.instapaper.com/hello2" + oe({
    url: e,
    title: t,
    description: n
  });
}
he(
  "instapaper",
  wy,
  (e) => ({
    title: e.title,
    description: e.description
  }),
  {
    windowWidth: 500,
    windowHeight: 500,
    windowPosition: "windowCenter"
  }
);
function xy(e, { title: t }) {
  return ue(e, "line.url"), "https://social-plugins.line.me/lineit/share" + oe({
    url: e,
    text: t
  });
}
he(
  "line",
  xy,
  (e) => ({
    title: e.title
  }),
  {
    windowWidth: 500,
    windowHeight: 500
  }
);
function Ey(e, { title: t, summary: n, source: r }) {
  return ue(e, "linkedin.url"), "https://linkedin.com/shareArticle" + oe({ url: e, mini: "true", title: t, summary: n, source: r });
}
he(
  "linkedin",
  Ey,
  ({ title: e, summary: t, source: n }) => ({ title: e, summary: t, source: n }),
  {
    windowWidth: 750,
    windowHeight: 600
  }
);
function Sy(e, { title: t, description: n }) {
  return ue(e, "livejournal.url"), "https://www.livejournal.com/update.bml" + oe({
    subject: t,
    event: n
  });
}
he(
  "livejournal",
  Sy,
  (e) => ({
    title: e.title,
    description: e.description
  }),
  {
    windowWidth: 660,
    windowHeight: 460
  }
);
function _y(e, { title: t, description: n, imageUrl: r }) {
  return ue(e, "mailru.url"), "https://connect.mail.ru/share" + oe({
    url: e,
    title: t,
    description: n,
    image_url: r
  });
}
he(
  "mailru",
  _y,
  (e) => ({
    title: e.title,
    description: e.description,
    imageUrl: e.imageUrl
  }),
  {
    windowWidth: 660,
    windowHeight: 460
  }
);
function Ry(e, { title: t, description: n, image: r }) {
  return ue(e, "ok.url"), "https://connect.ok.ru/offer" + oe({
    url: e,
    title: t,
    description: n,
    imageUrl: r
  });
}
he(
  "ok",
  Ry,
  (e) => ({
    title: e.title,
    description: e.description,
    image: e.image
  }),
  {
    windowWidth: 588,
    windowHeight: 480,
    windowPosition: "screenCenter"
  }
);
function Oy(e, t) {
  window.OK || (window.OK = {
    Share: {
      count: function(i, a) {
        var s, l;
        (l = (s = window.OK.callbacks)[i]) == null || l.call(s, a);
      }
    },
    callbacks: []
  });
  const n = "https://connect.ok.ru/dk", r = window.OK.callbacks.length;
  return window.ODKL = {
    updateCount(o, i) {
      var a, s;
      const l = o === "" ? 0 : parseInt(o.replace("react-share-", ""), 10);
      (s = (a = window.OK.callbacks)[l]) == null || s.call(a, i === "" ? void 0 : parseInt(i, 10));
    }
  }, window.OK.callbacks.push(t), Kt(
    n + oe({
      "st.cmd": "extLike",
      uid: `react-share-${r}`,
      ref: e
    })
  );
}
qt(Oy);
function Ny(e, { media: t, description: n, pinId: r }) {
  return r ? `https://pinterest.com/pin/${r}/repin/x/` : (ue(e, "pinterest.url"), ue(t, "pinterest.media"), "https://pinterest.com/pin/create/button/" + oe({
    url: e,
    media: t,
    description: n
  }));
}
he(
  "pinterest",
  Ny,
  (e) => ({
    media: e.media,
    description: e.description,
    pinId: e.pinId
  }),
  {
    windowWidth: 1e3,
    windowHeight: 730
  }
);
function Cy(e, t) {
  Kt(
    "https://api.pinterest.com/v1/urls/count.json" + oe({
      url: e
    }),
    (r, o) => {
      t(o ? o.count : void 0);
    }
  );
}
qt(Cy);
function Ty(e, { title: t }) {
  return ue(e, "pocket.url"), "https://getpocket.com/save" + oe({
    url: e,
    title: t
  });
}
he(
  "pocket",
  Ty,
  (e) => ({
    title: e.title
  }),
  {
    windowWidth: 500,
    windowHeight: 500
  }
);
function jy(e, { title: t }) {
  return ue(e, "reddit.url"), "https://www.reddit.com/submit" + oe({
    url: e,
    title: t
  });
}
he(
  "reddit",
  jy,
  (e) => ({
    title: e.title
  }),
  {
    windowWidth: 660,
    windowHeight: 460,
    windowPosition: "windowCenter"
  }
);
function ky(e, { title: t }) {
  return ue(e, "gab.url"), "https://gab.com/compose" + oe({
    url: e,
    text: t
  });
}
he(
  "gab",
  ky,
  (e) => ({
    title: e.title
  }),
  {
    windowWidth: 660,
    windowHeight: 640,
    windowPosition: "windowCenter"
  }
);
function Py(e, t) {
  const n = `https://www.reddit.com/api/info.json?limit=1&url=${e}`;
  Kt(n, { param: "jsonp" }, (r, o) => {
    t(
      !r && o && o.data && o.data.children.length > 0 && o.data.children[0].data.score ? o.data.children[0].data.score : void 0
    );
  });
}
qt(Py);
function Ay(e, { title: t }) {
  return ue(e, "telegram.url"), "https://telegram.me/share/url" + oe({
    url: e,
    text: t
  });
}
he(
  "telegram",
  Ay,
  (e) => ({
    title: e.title
  }),
  {
    windowWidth: 550,
    windowHeight: 400
  }
);
function Ly(e, {
  title: t,
  caption: n,
  tags: r,
  posttype: o
}) {
  return ue(e, "tumblr.url"), "https://www.tumblr.com/widgets/share/tool" + oe({
    canonicalUrl: e,
    title: t,
    caption: n,
    tags: r,
    posttype: o
  });
}
he(
  "tumblr",
  Ly,
  (e) => ({
    title: e.title,
    tags: (e.tags || []).join(","),
    caption: e.caption,
    posttype: e.posttype || "link"
  }),
  {
    windowWidth: 660,
    windowHeight: 460
  }
);
function Iy(e, t) {
  return Kt(
    "https://api.tumblr.com/v2/share/stats" + oe({
      url: e
    }),
    (r, o) => {
      t(!r && o && o.response ? o.response.note_count : void 0);
    }
  );
}
qt(Iy);
function Dy(e, {
  title: t,
  via: n,
  hashtags: r = [],
  related: o = []
}) {
  return ue(e, "twitter.url"), ue(Array.isArray(r), "twitter.hashtags is not an array"), ue(Array.isArray(o), "twitter.related is not an array"), "https://twitter.com/intent/tweet" + oe({
    url: e,
    text: t,
    via: n,
    hashtags: r.length > 0 ? r.join(",") : void 0,
    related: o.length > 0 ? o.join(",") : void 0
  });
}
const Fy = he(
  "twitter",
  Dy,
  (e) => ({
    hashtags: e.hashtags,
    title: e.title,
    via: e.via,
    related: e.related
  }),
  {
    windowWidth: 550,
    windowHeight: 400
  }
), My = Fy;
function $y(e, { title: t, separator: n }) {
  return ue(e, "viber.url"), "viber://forward" + oe({
    text: t ? t + n + e : e
  });
}
he(
  "viber",
  $y,
  (e) => ({
    title: e.title,
    separator: e.separator || " "
  }),
  {
    windowWidth: 660,
    windowHeight: 460
  }
);
function By(e, { title: t, image: n, noParse: r, noVkLinks: o }) {
  return ue(e, "vk.url"), "https://vk.com/share.php" + oe({
    url: e,
    title: t,
    image: n,
    noparse: r ? 1 : 0,
    no_vk_links: o ? 1 : 0
  });
}
he(
  "vk",
  By,
  (e) => ({
    title: e.title,
    image: e.image,
    noParse: e.noParse,
    noVkLinks: e.noVkLinks
  }),
  {
    windowWidth: 660,
    windowHeight: 460
  }
);
function zy(e, t) {
  window.VK || (window.VK = {}), window.VK.Share = {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    count: (o, i) => {
      var a, s;
      return (s = (a = window.VK.callbacks) == null ? void 0 : a[o]) == null ? void 0 : s.call(a, i);
    }
  }, window.VK.callbacks = [];
  const n = "https://vk.com/share.php", r = window.VK.callbacks.length;
  return window.VK.callbacks.push(t), Kt(
    n + oe({
      act: "count",
      index: r,
      url: e
    })
  );
}
qt(zy);
function Uy(e, { title: t, image: n }) {
  return ue(e, "weibo.url"), "http://service.weibo.com/share/share.php" + oe({
    url: e,
    title: t,
    pic: n
  });
}
he(
  "weibo",
  Uy,
  (e) => ({
    title: e.title,
    image: e.image
  }),
  {
    windowWidth: 660,
    windowHeight: 550,
    windowPosition: "screenCenter"
  }
);
function Wy() {
  return /(android|iphone|ipad|mobile)/i.test(navigator.userAgent);
}
function Hy(e, { title: t, separator: n }) {
  return ue(e, "whatsapp.url"), "https://" + (Wy() ? "api" : "web") + ".whatsapp.com/send" + oe({
    text: t ? t + n + e : e
  });
}
he(
  "whatsapp",
  Hy,
  (e) => ({
    title: e.title,
    separator: e.separator || " "
  }),
  {
    windowWidth: 550,
    windowHeight: 400
  }
);
function Ky(e, { quote: t, hashtag: n }) {
  return ue(e, "workplace.url"), "https://work.facebook.com/sharer.php" + oe({
    u: e,
    quote: t,
    hashtag: n
  });
}
he(
  "workplace",
  Ky,
  (e) => ({
    quote: e.quote,
    hashtag: e.hashtag
  }),
  {
    windowWidth: 550,
    windowHeight: 400
  }
);
const qy = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%20512%20512'%3e%3cpath%20fill='%23fff'%20d='M389.2%2048h70.6L305.6%20224.2%20487%20464H345L233.7%20318.6%20106.5%20464H35.8L200.7%20275.5%2026.8%2048H172.4L272.9%20180.9%20389.2%2048zM364.4%20421.8h39.1L151.1%2088h-42L364.4%20421.8z'/%3e%3c/svg%3e", Wc = ({
  shareLabel: e = "Share",
  facebookUrl: t = null,
  facebookOptions: n = {},
  twitterUrl: r = null,
  twitterOptions: o = {},
  smallSize: i = !1
}) => {
  const [a, s] = Ue("copy"), l = window.innerWidth < 576, c = window.location.href, u = () => {
    navigator.clipboard.writeText(c).then(() => {
      s("check");
    });
  };
  le(() => {
    a === "check" && setTimeout(() => {
      s("copy");
    }, 500);
  }, [a, s]);
  let d, h;
  return !t && !r ? null : (t && (d = /* @__PURE__ */ R.jsxs(hy, { resetButtonStyle: !1, url: t, ...n, children: [
    /* @__PURE__ */ R.jsxs("span", { className: "fa-stack mr-2", children: [
      /* @__PURE__ */ R.jsx(mt, { icon: "circle", className: "fa-stack-2x social_share__fb" }),
      /* @__PURE__ */ R.jsx(
        mt,
        {
          icon: "facebook-f",
          className: "fab fa-stack-1x fa-inverse",
          "data-testid": "facebook-icon"
        }
      )
    ] }),
    "Facebook"
  ] })), r && (h = /* @__PURE__ */ R.jsxs(My, { resetButtonStyle: !1, url: r, ...o, children: [
    /* @__PURE__ */ R.jsxs("span", { className: "fa-stack mr-2", children: [
      /* @__PURE__ */ R.jsx(mt, { icon: "circle", className: "fa-stack-2x social_share__twitter" }),
      /* @__PURE__ */ R.jsx("span", { className: "fa-stack-1x", "data-testid": "twitter-icon", children: /* @__PURE__ */ R.jsx("img", { src: qy, className: "twitter-icon", alt: "" }) })
    ] }),
    "X"
  ] })), /* @__PURE__ */ R.jsxs(Ve, { className: `${i === !0 ? "ml-auto" : "flex-grow-1"}`, children: [
    /* @__PURE__ */ R.jsx(Ve.Trigger, { children: /* @__PURE__ */ R.jsxs(
      Wo,
      {
        className: `${l ? "btn-sm " : ""}text-nowrap text-primary${i === !0 ? "" : " w-100"}`,
        id: "social-share-dropdown",
        variant: "secondary",
        "aria-label": e,
        children: [
          /* @__PURE__ */ R.jsx(mt, { icon: "share-alt", className: "pr-2" }),
          /* @__PURE__ */ R.jsx("span", { children: e })
        ]
      }
    ) }),
    /* @__PURE__ */ R.jsxs(Ve.Content, { children: [
      /* @__PURE__ */ R.jsx(Ve.Label, { children: "Share" }),
      /* @__PURE__ */ R.jsx(Ve.Item, { children: d }, "facebook"),
      /* @__PURE__ */ R.jsx(Ve.Item, { children: h }, "twitter"),
      /* @__PURE__ */ R.jsx(Ve.Separator, {}),
      /* @__PURE__ */ R.jsx(
        _c,
        {
          className: "px-2",
          append: /* @__PURE__ */ R.jsx(
            Wo,
            {
              "aria-label": "Copy results details URL",
              onClick: u,
              disabled: a === "check",
              children: /* @__PURE__ */ R.jsx(mt, { icon: a })
            }
          ),
          children: /* @__PURE__ */ R.jsx(Fi, { id: "share-results-link", readOnly: !0, value: c })
        }
      )
    ] })
  ] }));
};
Wc.propTypes = {
  className: x.string,
  facebookUrl: x.string,
  facebookOptions: x.shape({
    quote: x.string,
    hashtag: x.string
  }),
  shareLabel: x.string,
  twitterUrl: x.string,
  twitterOptions: x.shape({
    title: x.string,
    via: x.string,
    hashtags: x.arrayOf(x.string),
    related: x.arrayOf(x.string)
  }),
  smallSize: x.bool
};
const Vy = ({
  baseUrl: e,
  phone: t = null,
  privacyUrl: n = "/terms-and-conditions#Notice",
  privacyLabel: r = "Privacy Policy",
  termsUrl: o = "/terms-and-conditions",
  termsLabel: i = "Terms & Conditions",
  copyrightLabel: a = "Copyright",
  className: s = ""
}) => /* @__PURE__ */ R.jsx("div", { className: _e("page-footer px-3", s), "data-testid": "footer-component", children: /* @__PURE__ */ R.jsxs(
  "footer",
  {
    className: _e(
      "resultsContainer",
      "page-footer__container",
      "justify-content-between"
    ),
    children: [
      /* @__PURE__ */ R.jsx("div", { className: "page-footer__copyrights", children: `${a} © ${(/* @__PURE__ */ new Date()).getFullYear()}` }),
      /* @__PURE__ */ R.jsxs("ul", { className: "page-footer__links", children: [
        t != null && /* @__PURE__ */ R.jsx("a", { href: `tel:${t}`, className: "page-footer_link btn btn-link", children: t }),
        /* @__PURE__ */ R.jsx("a", { href: `${e}${n}`, className: "page-footer_link btn btn-link", children: r }),
        /* @__PURE__ */ R.jsx("a", { href: `${e}${o}`, className: "page-footer_link btn btn-link", children: i })
      ] })
    ]
  }
) });
Vy.propTypes = {
  baseUrl: x.string.isRequired,
  privacyUrl: x.string,
  privacyLabel: x.string,
  termsUrl: x.string,
  termsLabel: x.string,
  copyrightLabel: x.string,
  className: x.string
};
const Hc = xt(), Kc = "set", Gy = (e, t) => {
  switch (t.type) {
    case Kc:
      return { event: t.payload };
    default:
      throw new Error(`Unhandled action type: ${t.type}`);
  }
}, Yy = ({ children: e }) => {
  const [t, n] = gi(Gy, { event: null }), r = bi((i) => n({ type: Kc, payload: i }), []), o = { state: t, setEvent: r };
  return /* @__PURE__ */ R.jsx(Hc.Provider, { value: o, children: e });
};
Yy.propTypes = {
  children: x.node.isRequired
};
const qc = () => {
  const {
    state: { event: e },
    setEvent: t
  } = rt(Hc);
  if (e === void 0)
    throw new Error("useEvent must be used within a EventProvider");
  return { event: e, setEvent: t };
}, Vc = ({ locale: e, localeUrl: t, className: n, children: r, ...o }) => {
  console.warn(
    "The ContextHeader container is being deprecated in a future version. Check the README for new implementation."
  );
  const { event: i } = qc(), a = i && i.locale && typeof i.locale == "object" ? i.locale.availableLocales.map((s) => {
    const l = s.code.replace(/_/g, "-");
    return {
      ...s,
      code: l,
      url: t && t(l)
    };
  }) : [];
  return /* @__PURE__ */ R.jsx(
    Fs,
    {
      event: i,
      className: n,
      locale: e,
      locales: a,
      ...o,
      children: r
    }
  );
};
Vc.propTypes = {
  /** Currently selected locale */
  locale: x.string,
  /** Function that will receive locale and return url for locale switcher */
  localeUrl: x.func,
  children: x.node,
  className: x.string
};
Vc.defaultProps = {
  children: null
};
function Gc(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: Xy } = Object.prototype, { getPrototypeOf: Gi } = Object, io = /* @__PURE__ */ ((e) => (t) => {
  const n = Xy.call(t);
  return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Ze = (e) => (e = e.toLowerCase(), (t) => io(t) === e), ao = (e) => (t) => typeof t === e, { isArray: ln } = Array, Hn = ao("undefined");
function Zy(e) {
  return e !== null && !Hn(e) && e.constructor !== null && !Hn(e.constructor) && Ie(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const Yc = Ze("ArrayBuffer");
function Jy(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && Yc(e.buffer), t;
}
const Qy = ao("string"), Ie = ao("function"), Xc = ao("number"), so = (e) => e !== null && typeof e == "object", ew = (e) => e === !0 || e === !1, Rr = (e) => {
  if (io(e) !== "object")
    return !1;
  const t = Gi(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, tw = Ze("Date"), nw = Ze("File"), rw = Ze("Blob"), ow = Ze("FileList"), iw = (e) => so(e) && Ie(e.pipe), aw = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || Ie(e.append) && ((t = io(e)) === "formdata" || // detect form-data instance
  t === "object" && Ie(e.toString) && e.toString() === "[object FormData]"));
}, sw = Ze("URLSearchParams"), [lw, cw, uw, dw] = ["ReadableStream", "Request", "Response", "Headers"].map(Ze), fw = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Qn(e, t, { allOwnKeys: n = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let r, o;
  if (typeof e != "object" && (e = [e]), ln(e))
    for (r = 0, o = e.length; r < o; r++)
      t.call(null, e[r], r, e);
  else {
    const i = n ? Object.getOwnPropertyNames(e) : Object.keys(e), a = i.length;
    let s;
    for (r = 0; r < a; r++)
      s = i[r], t.call(null, e[s], s, e);
  }
}
function Zc(e, t) {
  t = t.toLowerCase();
  const n = Object.keys(e);
  let r = n.length, o;
  for (; r-- > 0; )
    if (o = n[r], t === o.toLowerCase())
      return o;
  return null;
}
const kt = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, Jc = (e) => !Hn(e) && e !== kt;
function li() {
  const { caseless: e } = Jc(this) && this || {}, t = {}, n = (r, o) => {
    const i = e && Zc(t, o) || o;
    Rr(t[i]) && Rr(r) ? t[i] = li(t[i], r) : Rr(r) ? t[i] = li({}, r) : ln(r) ? t[i] = r.slice() : t[i] = r;
  };
  for (let r = 0, o = arguments.length; r < o; r++)
    arguments[r] && Qn(arguments[r], n);
  return t;
}
const pw = (e, t, n, { allOwnKeys: r } = {}) => (Qn(t, (o, i) => {
  n && Ie(o) ? e[i] = Gc(o, n) : e[i] = o;
}, { allOwnKeys: r }), e), hw = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), mw = (e, t, n, r) => {
  e.prototype = Object.create(t.prototype, r), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), n && Object.assign(e.prototype, n);
}, vw = (e, t, n, r) => {
  let o, i, a;
  const s = {};
  if (t = t || {}, e == null) return t;
  do {
    for (o = Object.getOwnPropertyNames(e), i = o.length; i-- > 0; )
      a = o[i], (!r || r(a, e, t)) && !s[a] && (t[a] = e[a], s[a] = !0);
    e = n !== !1 && Gi(e);
  } while (e && (!n || n(e, t)) && e !== Object.prototype);
  return t;
}, gw = (e, t, n) => {
  e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
  const r = e.indexOf(t, n);
  return r !== -1 && r === n;
}, bw = (e) => {
  if (!e) return null;
  if (ln(e)) return e;
  let t = e.length;
  if (!Xc(t)) return null;
  const n = new Array(t);
  for (; t-- > 0; )
    n[t] = e[t];
  return n;
}, yw = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && Gi(Uint8Array)), ww = (e, t) => {
  const r = (e && e[Symbol.iterator]).call(e);
  let o;
  for (; (o = r.next()) && !o.done; ) {
    const i = o.value;
    t.call(e, i[0], i[1]);
  }
}, xw = (e, t) => {
  let n;
  const r = [];
  for (; (n = e.exec(t)) !== null; )
    r.push(n);
  return r;
}, Ew = Ze("HTMLFormElement"), Sw = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(n, r, o) {
    return r.toUpperCase() + o;
  }
), os = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), _w = Ze("RegExp"), Qc = (e, t) => {
  const n = Object.getOwnPropertyDescriptors(e), r = {};
  Qn(n, (o, i) => {
    let a;
    (a = t(o, i, e)) !== !1 && (r[i] = a || o);
  }), Object.defineProperties(e, r);
}, Rw = (e) => {
  Qc(e, (t, n) => {
    if (Ie(e) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
      return !1;
    const r = e[n];
    if (Ie(r)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, Ow = (e, t) => {
  const n = {}, r = (o) => {
    o.forEach((i) => {
      n[i] = !0;
    });
  };
  return ln(e) ? r(e) : r(String(e).split(t)), n;
}, Nw = () => {
}, Cw = (e, t) => e != null && Number.isFinite(e = +e) ? e : t, Fo = "abcdefghijklmnopqrstuvwxyz", is = "0123456789", eu = {
  DIGIT: is,
  ALPHA: Fo,
  ALPHA_DIGIT: Fo + Fo.toUpperCase() + is
}, Tw = (e = 16, t = eu.ALPHA_DIGIT) => {
  let n = "";
  const { length: r } = t;
  for (; e--; )
    n += t[Math.random() * r | 0];
  return n;
};
function jw(e) {
  return !!(e && Ie(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const kw = (e) => {
  const t = new Array(10), n = (r, o) => {
    if (so(r)) {
      if (t.indexOf(r) >= 0)
        return;
      if (!("toJSON" in r)) {
        t[o] = r;
        const i = ln(r) ? [] : {};
        return Qn(r, (a, s) => {
          const l = n(a, o + 1);
          !Hn(l) && (i[s] = l);
        }), t[o] = void 0, i;
      }
    }
    return r;
  };
  return n(e, 0);
}, Pw = Ze("AsyncFunction"), Aw = (e) => e && (so(e) || Ie(e)) && Ie(e.then) && Ie(e.catch), tu = ((e, t) => e ? setImmediate : t ? ((n, r) => (kt.addEventListener("message", ({ source: o, data: i }) => {
  o === kt && i === n && r.length && r.shift()();
}, !1), (o) => {
  r.push(o), kt.postMessage(n, "*");
}))(`axios@${Math.random()}`, []) : (n) => setTimeout(n))(
  typeof setImmediate == "function",
  Ie(kt.postMessage)
), Lw = typeof queueMicrotask < "u" ? queueMicrotask.bind(kt) : typeof process < "u" && process.nextTick || tu, _ = {
  isArray: ln,
  isArrayBuffer: Yc,
  isBuffer: Zy,
  isFormData: aw,
  isArrayBufferView: Jy,
  isString: Qy,
  isNumber: Xc,
  isBoolean: ew,
  isObject: so,
  isPlainObject: Rr,
  isReadableStream: lw,
  isRequest: cw,
  isResponse: uw,
  isHeaders: dw,
  isUndefined: Hn,
  isDate: tw,
  isFile: nw,
  isBlob: rw,
  isRegExp: _w,
  isFunction: Ie,
  isStream: iw,
  isURLSearchParams: sw,
  isTypedArray: yw,
  isFileList: ow,
  forEach: Qn,
  merge: li,
  extend: pw,
  trim: fw,
  stripBOM: hw,
  inherits: mw,
  toFlatObject: vw,
  kindOf: io,
  kindOfTest: Ze,
  endsWith: gw,
  toArray: bw,
  forEachEntry: ww,
  matchAll: xw,
  isHTMLForm: Ew,
  hasOwnProperty: os,
  hasOwnProp: os,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: Qc,
  freezeMethods: Rw,
  toObjectSet: Ow,
  toCamelCase: Sw,
  noop: Nw,
  toFiniteNumber: Cw,
  findKey: Zc,
  global: kt,
  isContextDefined: Jc,
  ALPHABET: eu,
  generateString: Tw,
  isSpecCompliantForm: jw,
  toJSONObject: kw,
  isAsyncFn: Pw,
  isThenable: Aw,
  setImmediate: tu,
  asap: Lw
};
function X(e, t, n, r, o) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), n && (this.config = n), r && (this.request = r), o && (this.response = o, this.status = o.status ? o.status : null);
}
_.inherits(X, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: _.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const nu = X.prototype, ru = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  ru[e] = { value: e };
});
Object.defineProperties(X, ru);
Object.defineProperty(nu, "isAxiosError", { value: !0 });
X.from = (e, t, n, r, o, i) => {
  const a = Object.create(nu);
  return _.toFlatObject(e, a, function(l) {
    return l !== Error.prototype;
  }, (s) => s !== "isAxiosError"), X.call(a, e.message, t, n, r, o), a.cause = e, a.name = e.name, i && Object.assign(a, i), a;
};
const Iw = null;
function ci(e) {
  return _.isPlainObject(e) || _.isArray(e);
}
function ou(e) {
  return _.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function as(e, t, n) {
  return e ? e.concat(t).map(function(o, i) {
    return o = ou(o), !n && i ? "[" + o + "]" : o;
  }).join(n ? "." : "") : t;
}
function Dw(e) {
  return _.isArray(e) && !e.some(ci);
}
const Fw = _.toFlatObject(_, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function lo(e, t, n) {
  if (!_.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), n = _.toFlatObject(n, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(v, f) {
    return !_.isUndefined(f[v]);
  });
  const r = n.metaTokens, o = n.visitor || u, i = n.dots, a = n.indexes, l = (n.Blob || typeof Blob < "u" && Blob) && _.isSpecCompliantForm(t);
  if (!_.isFunction(o))
    throw new TypeError("visitor must be a function");
  function c(m) {
    if (m === null) return "";
    if (_.isDate(m))
      return m.toISOString();
    if (!l && _.isBlob(m))
      throw new X("Blob is not supported. Use a Buffer instead.");
    return _.isArrayBuffer(m) || _.isTypedArray(m) ? l && typeof Blob == "function" ? new Blob([m]) : Buffer.from(m) : m;
  }
  function u(m, v, f) {
    let y = m;
    if (m && !f && typeof m == "object") {
      if (_.endsWith(v, "{}"))
        v = r ? v : v.slice(0, -2), m = JSON.stringify(m);
      else if (_.isArray(m) && Dw(m) || (_.isFileList(m) || _.endsWith(v, "[]")) && (y = _.toArray(m)))
        return v = ou(v), y.forEach(function(C, T) {
          !(_.isUndefined(C) || C === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            a === !0 ? as([v], T, i) : a === null ? v : v + "[]",
            c(C)
          );
        }), !1;
    }
    return ci(m) ? !0 : (t.append(as(f, v, i), c(m)), !1);
  }
  const d = [], h = Object.assign(Fw, {
    defaultVisitor: u,
    convertValue: c,
    isVisitable: ci
  });
  function p(m, v) {
    if (!_.isUndefined(m)) {
      if (d.indexOf(m) !== -1)
        throw Error("Circular reference detected in " + v.join("."));
      d.push(m), _.forEach(m, function(y, S) {
        (!(_.isUndefined(y) || y === null) && o.call(
          t,
          y,
          _.isString(S) ? S.trim() : S,
          v,
          h
        )) === !0 && p(y, v ? v.concat(S) : [S]);
      }), d.pop();
    }
  }
  if (!_.isObject(e))
    throw new TypeError("data must be an object");
  return p(e), t;
}
function ss(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(r) {
    return t[r];
  });
}
function Yi(e, t) {
  this._pairs = [], e && lo(e, this, t);
}
const iu = Yi.prototype;
iu.append = function(t, n) {
  this._pairs.push([t, n]);
};
iu.toString = function(t) {
  const n = t ? function(r) {
    return t.call(this, r, ss);
  } : ss;
  return this._pairs.map(function(o) {
    return n(o[0]) + "=" + n(o[1]);
  }, "").join("&");
};
function Mw(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function au(e, t, n) {
  if (!t)
    return e;
  const r = n && n.encode || Mw, o = n && n.serialize;
  let i;
  if (o ? i = o(t, n) : i = _.isURLSearchParams(t) ? t.toString() : new Yi(t, n).toString(r), i) {
    const a = e.indexOf("#");
    a !== -1 && (e = e.slice(0, a)), e += (e.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return e;
}
class ls {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, n, r) {
    return this.handlers.push({
      fulfilled: t,
      rejected: n,
      synchronous: r ? r.synchronous : !1,
      runWhen: r ? r.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    _.forEach(this.handlers, function(r) {
      r !== null && t(r);
    });
  }
}
const su = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, $w = typeof URLSearchParams < "u" ? URLSearchParams : Yi, Bw = typeof FormData < "u" ? FormData : null, zw = typeof Blob < "u" ? Blob : null, Uw = {
  isBrowser: !0,
  classes: {
    URLSearchParams: $w,
    FormData: Bw,
    Blob: zw
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, Xi = typeof window < "u" && typeof document < "u", ui = typeof navigator == "object" && navigator || void 0, Ww = Xi && (!ui || ["ReactNative", "NativeScript", "NS"].indexOf(ui.product) < 0), Hw = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", Kw = Xi && window.location.href || "http://localhost", qw = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: Xi,
  hasStandardBrowserEnv: Ww,
  hasStandardBrowserWebWorkerEnv: Hw,
  navigator: ui,
  origin: Kw
}, Symbol.toStringTag, { value: "Module" })), Ce = {
  ...qw,
  ...Uw
};
function Vw(e, t) {
  return lo(e, new Ce.classes.URLSearchParams(), Object.assign({
    visitor: function(n, r, o, i) {
      return Ce.isNode && _.isBuffer(n) ? (this.append(r, n.toString("base64")), !1) : i.defaultVisitor.apply(this, arguments);
    }
  }, t));
}
function Gw(e) {
  return _.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function Yw(e) {
  const t = {}, n = Object.keys(e);
  let r;
  const o = n.length;
  let i;
  for (r = 0; r < o; r++)
    i = n[r], t[i] = e[i];
  return t;
}
function lu(e) {
  function t(n, r, o, i) {
    let a = n[i++];
    if (a === "__proto__") return !0;
    const s = Number.isFinite(+a), l = i >= n.length;
    return a = !a && _.isArray(o) ? o.length : a, l ? (_.hasOwnProp(o, a) ? o[a] = [o[a], r] : o[a] = r, !s) : ((!o[a] || !_.isObject(o[a])) && (o[a] = []), t(n, r, o[a], i) && _.isArray(o[a]) && (o[a] = Yw(o[a])), !s);
  }
  if (_.isFormData(e) && _.isFunction(e.entries)) {
    const n = {};
    return _.forEachEntry(e, (r, o) => {
      t(Gw(r), o, n, 0);
    }), n;
  }
  return null;
}
function Xw(e, t, n) {
  if (_.isString(e))
    try {
      return (t || JSON.parse)(e), _.trim(e);
    } catch (r) {
      if (r.name !== "SyntaxError")
        throw r;
    }
  return (0, JSON.stringify)(e);
}
const er = {
  transitional: su,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(t, n) {
    const r = n.getContentType() || "", o = r.indexOf("application/json") > -1, i = _.isObject(t);
    if (i && _.isHTMLForm(t) && (t = new FormData(t)), _.isFormData(t))
      return o ? JSON.stringify(lu(t)) : t;
    if (_.isArrayBuffer(t) || _.isBuffer(t) || _.isStream(t) || _.isFile(t) || _.isBlob(t) || _.isReadableStream(t))
      return t;
    if (_.isArrayBufferView(t))
      return t.buffer;
    if (_.isURLSearchParams(t))
      return n.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let s;
    if (i) {
      if (r.indexOf("application/x-www-form-urlencoded") > -1)
        return Vw(t, this.formSerializer).toString();
      if ((s = _.isFileList(t)) || r.indexOf("multipart/form-data") > -1) {
        const l = this.env && this.env.FormData;
        return lo(
          s ? { "files[]": t } : t,
          l && new l(),
          this.formSerializer
        );
      }
    }
    return i || o ? (n.setContentType("application/json", !1), Xw(t)) : t;
  }],
  transformResponse: [function(t) {
    const n = this.transitional || er.transitional, r = n && n.forcedJSONParsing, o = this.responseType === "json";
    if (_.isResponse(t) || _.isReadableStream(t))
      return t;
    if (t && _.isString(t) && (r && !this.responseType || o)) {
      const a = !(n && n.silentJSONParsing) && o;
      try {
        return JSON.parse(t);
      } catch (s) {
        if (a)
          throw s.name === "SyntaxError" ? X.from(s, X.ERR_BAD_RESPONSE, this, null, this.response) : s;
      }
    }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: Ce.classes.FormData,
    Blob: Ce.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
_.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  er.headers[e] = {};
});
const Zw = _.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), Jw = (e) => {
  const t = {};
  let n, r, o;
  return e && e.split(`
`).forEach(function(a) {
    o = a.indexOf(":"), n = a.substring(0, o).trim().toLowerCase(), r = a.substring(o + 1).trim(), !(!n || t[n] && Zw[n]) && (n === "set-cookie" ? t[n] ? t[n].push(r) : t[n] = [r] : t[n] = t[n] ? t[n] + ", " + r : r);
  }), t;
}, cs = Symbol("internals");
function xn(e) {
  return e && String(e).trim().toLowerCase();
}
function Or(e) {
  return e === !1 || e == null ? e : _.isArray(e) ? e.map(Or) : String(e);
}
function Qw(e) {
  const t = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let r;
  for (; r = n.exec(e); )
    t[r[1]] = r[2];
  return t;
}
const e0 = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function Mo(e, t, n, r, o) {
  if (_.isFunction(r))
    return r.call(this, t, n);
  if (o && (t = n), !!_.isString(t)) {
    if (_.isString(r))
      return t.indexOf(r) !== -1;
    if (_.isRegExp(r))
      return r.test(t);
  }
}
function t0(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, n, r) => n.toUpperCase() + r);
}
function n0(e, t) {
  const n = _.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((r) => {
    Object.defineProperty(e, r + n, {
      value: function(o, i, a) {
        return this[r].call(this, t, o, i, a);
      },
      configurable: !0
    });
  });
}
class Te {
  constructor(t) {
    t && this.set(t);
  }
  set(t, n, r) {
    const o = this;
    function i(s, l, c) {
      const u = xn(l);
      if (!u)
        throw new Error("header name must be a non-empty string");
      const d = _.findKey(o, u);
      (!d || o[d] === void 0 || c === !0 || c === void 0 && o[d] !== !1) && (o[d || l] = Or(s));
    }
    const a = (s, l) => _.forEach(s, (c, u) => i(c, u, l));
    if (_.isPlainObject(t) || t instanceof this.constructor)
      a(t, n);
    else if (_.isString(t) && (t = t.trim()) && !e0(t))
      a(Jw(t), n);
    else if (_.isHeaders(t))
      for (const [s, l] of t.entries())
        i(l, s, r);
    else
      t != null && i(n, t, r);
    return this;
  }
  get(t, n) {
    if (t = xn(t), t) {
      const r = _.findKey(this, t);
      if (r) {
        const o = this[r];
        if (!n)
          return o;
        if (n === !0)
          return Qw(o);
        if (_.isFunction(n))
          return n.call(this, o, r);
        if (_.isRegExp(n))
          return n.exec(o);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, n) {
    if (t = xn(t), t) {
      const r = _.findKey(this, t);
      return !!(r && this[r] !== void 0 && (!n || Mo(this, this[r], r, n)));
    }
    return !1;
  }
  delete(t, n) {
    const r = this;
    let o = !1;
    function i(a) {
      if (a = xn(a), a) {
        const s = _.findKey(r, a);
        s && (!n || Mo(r, r[s], s, n)) && (delete r[s], o = !0);
      }
    }
    return _.isArray(t) ? t.forEach(i) : i(t), o;
  }
  clear(t) {
    const n = Object.keys(this);
    let r = n.length, o = !1;
    for (; r--; ) {
      const i = n[r];
      (!t || Mo(this, this[i], i, t, !0)) && (delete this[i], o = !0);
    }
    return o;
  }
  normalize(t) {
    const n = this, r = {};
    return _.forEach(this, (o, i) => {
      const a = _.findKey(r, i);
      if (a) {
        n[a] = Or(o), delete n[i];
        return;
      }
      const s = t ? t0(i) : String(i).trim();
      s !== i && delete n[i], n[s] = Or(o), r[s] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const n = /* @__PURE__ */ Object.create(null);
    return _.forEach(this, (r, o) => {
      r != null && r !== !1 && (n[o] = t && _.isArray(r) ? r.join(", ") : r);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, n]) => t + ": " + n).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...n) {
    const r = new this(t);
    return n.forEach((o) => r.set(o)), r;
  }
  static accessor(t) {
    const r = (this[cs] = this[cs] = {
      accessors: {}
    }).accessors, o = this.prototype;
    function i(a) {
      const s = xn(a);
      r[s] || (n0(o, a), r[s] = !0);
    }
    return _.isArray(t) ? t.forEach(i) : i(t), this;
  }
}
Te.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
_.reduceDescriptors(Te.prototype, ({ value: e }, t) => {
  let n = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(r) {
      this[n] = r;
    }
  };
});
_.freezeMethods(Te);
function $o(e, t) {
  const n = this || er, r = t || n, o = Te.from(r.headers);
  let i = r.data;
  return _.forEach(e, function(s) {
    i = s.call(n, i, o.normalize(), t ? t.status : void 0);
  }), o.normalize(), i;
}
function cu(e) {
  return !!(e && e.__CANCEL__);
}
function cn(e, t, n) {
  X.call(this, e ?? "canceled", X.ERR_CANCELED, t, n), this.name = "CanceledError";
}
_.inherits(cn, X, {
  __CANCEL__: !0
});
function uu(e, t, n) {
  const r = n.config.validateStatus;
  !n.status || !r || r(n.status) ? e(n) : t(new X(
    "Request failed with status code " + n.status,
    [X.ERR_BAD_REQUEST, X.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
    n.config,
    n.request,
    n
  ));
}
function r0(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function o0(e, t) {
  e = e || 10;
  const n = new Array(e), r = new Array(e);
  let o = 0, i = 0, a;
  return t = t !== void 0 ? t : 1e3, function(l) {
    const c = Date.now(), u = r[i];
    a || (a = c), n[o] = l, r[o] = c;
    let d = i, h = 0;
    for (; d !== o; )
      h += n[d++], d = d % e;
    if (o = (o + 1) % e, o === i && (i = (i + 1) % e), c - a < t)
      return;
    const p = u && c - u;
    return p ? Math.round(h * 1e3 / p) : void 0;
  };
}
function i0(e, t) {
  let n = 0, r = 1e3 / t, o, i;
  const a = (c, u = Date.now()) => {
    n = u, o = null, i && (clearTimeout(i), i = null), e.apply(null, c);
  };
  return [(...c) => {
    const u = Date.now(), d = u - n;
    d >= r ? a(c, u) : (o = c, i || (i = setTimeout(() => {
      i = null, a(o);
    }, r - d)));
  }, () => o && a(o)];
}
const $r = (e, t, n = 3) => {
  let r = 0;
  const o = o0(50, 250);
  return i0((i) => {
    const a = i.loaded, s = i.lengthComputable ? i.total : void 0, l = a - r, c = o(l), u = a <= s;
    r = a;
    const d = {
      loaded: a,
      total: s,
      progress: s ? a / s : void 0,
      bytes: l,
      rate: c || void 0,
      estimated: c && s && u ? (s - a) / c : void 0,
      event: i,
      lengthComputable: s != null,
      [t ? "download" : "upload"]: !0
    };
    e(d);
  }, n);
}, us = (e, t) => {
  const n = e != null;
  return [(r) => t[0]({
    lengthComputable: n,
    total: e,
    loaded: r
  }), t[1]];
}, ds = (e) => (...t) => _.asap(() => e(...t)), a0 = Ce.hasStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function() {
    const t = Ce.navigator && /(msie|trident)/i.test(Ce.navigator.userAgent), n = document.createElement("a");
    let r;
    function o(i) {
      let a = i;
      return t && (n.setAttribute("href", a), a = n.href), n.setAttribute("href", a), {
        href: n.href,
        protocol: n.protocol ? n.protocol.replace(/:$/, "") : "",
        host: n.host,
        search: n.search ? n.search.replace(/^\?/, "") : "",
        hash: n.hash ? n.hash.replace(/^#/, "") : "",
        hostname: n.hostname,
        port: n.port,
        pathname: n.pathname.charAt(0) === "/" ? n.pathname : "/" + n.pathname
      };
    }
    return r = o(window.location.href), function(a) {
      const s = _.isString(a) ? o(a) : a;
      return s.protocol === r.protocol && s.host === r.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  /* @__PURE__ */ function() {
    return function() {
      return !0;
    };
  }()
), s0 = Ce.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, n, r, o, i) {
      const a = [e + "=" + encodeURIComponent(t)];
      _.isNumber(n) && a.push("expires=" + new Date(n).toGMTString()), _.isString(r) && a.push("path=" + r), _.isString(o) && a.push("domain=" + o), i === !0 && a.push("secure"), document.cookie = a.join("; ");
    },
    read(e) {
      const t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return t ? decodeURIComponent(t[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function l0(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function c0(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function du(e, t) {
  return e && !l0(t) ? c0(e, t) : t;
}
const fs = (e) => e instanceof Te ? { ...e } : e;
function Mt(e, t) {
  t = t || {};
  const n = {};
  function r(c, u, d) {
    return _.isPlainObject(c) && _.isPlainObject(u) ? _.merge.call({ caseless: d }, c, u) : _.isPlainObject(u) ? _.merge({}, u) : _.isArray(u) ? u.slice() : u;
  }
  function o(c, u, d) {
    if (_.isUndefined(u)) {
      if (!_.isUndefined(c))
        return r(void 0, c, d);
    } else return r(c, u, d);
  }
  function i(c, u) {
    if (!_.isUndefined(u))
      return r(void 0, u);
  }
  function a(c, u) {
    if (_.isUndefined(u)) {
      if (!_.isUndefined(c))
        return r(void 0, c);
    } else return r(void 0, u);
  }
  function s(c, u, d) {
    if (d in t)
      return r(c, u);
    if (d in e)
      return r(void 0, c);
  }
  const l = {
    url: i,
    method: i,
    data: i,
    baseURL: a,
    transformRequest: a,
    transformResponse: a,
    paramsSerializer: a,
    timeout: a,
    timeoutMessage: a,
    withCredentials: a,
    withXSRFToken: a,
    adapter: a,
    responseType: a,
    xsrfCookieName: a,
    xsrfHeaderName: a,
    onUploadProgress: a,
    onDownloadProgress: a,
    decompress: a,
    maxContentLength: a,
    maxBodyLength: a,
    beforeRedirect: a,
    transport: a,
    httpAgent: a,
    httpsAgent: a,
    cancelToken: a,
    socketPath: a,
    responseEncoding: a,
    validateStatus: s,
    headers: (c, u) => o(fs(c), fs(u), !0)
  };
  return _.forEach(Object.keys(Object.assign({}, e, t)), function(u) {
    const d = l[u] || o, h = d(e[u], t[u], u);
    _.isUndefined(h) && d !== s || (n[u] = h);
  }), n;
}
const fu = (e) => {
  const t = Mt({}, e);
  let { data: n, withXSRFToken: r, xsrfHeaderName: o, xsrfCookieName: i, headers: a, auth: s } = t;
  t.headers = a = Te.from(a), t.url = au(du(t.baseURL, t.url), e.params, e.paramsSerializer), s && a.set(
    "Authorization",
    "Basic " + btoa((s.username || "") + ":" + (s.password ? unescape(encodeURIComponent(s.password)) : ""))
  );
  let l;
  if (_.isFormData(n)) {
    if (Ce.hasStandardBrowserEnv || Ce.hasStandardBrowserWebWorkerEnv)
      a.setContentType(void 0);
    else if ((l = a.getContentType()) !== !1) {
      const [c, ...u] = l ? l.split(";").map((d) => d.trim()).filter(Boolean) : [];
      a.setContentType([c || "multipart/form-data", ...u].join("; "));
    }
  }
  if (Ce.hasStandardBrowserEnv && (r && _.isFunction(r) && (r = r(t)), r || r !== !1 && a0(t.url))) {
    const c = o && i && s0.read(i);
    c && a.set(o, c);
  }
  return t;
}, u0 = typeof XMLHttpRequest < "u", d0 = u0 && function(e) {
  return new Promise(function(n, r) {
    const o = fu(e);
    let i = o.data;
    const a = Te.from(o.headers).normalize();
    let { responseType: s, onUploadProgress: l, onDownloadProgress: c } = o, u, d, h, p, m;
    function v() {
      p && p(), m && m(), o.cancelToken && o.cancelToken.unsubscribe(u), o.signal && o.signal.removeEventListener("abort", u);
    }
    let f = new XMLHttpRequest();
    f.open(o.method.toUpperCase(), o.url, !0), f.timeout = o.timeout;
    function y() {
      if (!f)
        return;
      const C = Te.from(
        "getAllResponseHeaders" in f && f.getAllResponseHeaders()
      ), A = {
        data: !s || s === "text" || s === "json" ? f.responseText : f.response,
        status: f.status,
        statusText: f.statusText,
        headers: C,
        config: e,
        request: f
      };
      uu(function(L) {
        n(L), v();
      }, function(L) {
        r(L), v();
      }, A), f = null;
    }
    "onloadend" in f ? f.onloadend = y : f.onreadystatechange = function() {
      !f || f.readyState !== 4 || f.status === 0 && !(f.responseURL && f.responseURL.indexOf("file:") === 0) || setTimeout(y);
    }, f.onabort = function() {
      f && (r(new X("Request aborted", X.ECONNABORTED, e, f)), f = null);
    }, f.onerror = function() {
      r(new X("Network Error", X.ERR_NETWORK, e, f)), f = null;
    }, f.ontimeout = function() {
      let T = o.timeout ? "timeout of " + o.timeout + "ms exceeded" : "timeout exceeded";
      const A = o.transitional || su;
      o.timeoutErrorMessage && (T = o.timeoutErrorMessage), r(new X(
        T,
        A.clarifyTimeoutError ? X.ETIMEDOUT : X.ECONNABORTED,
        e,
        f
      )), f = null;
    }, i === void 0 && a.setContentType(null), "setRequestHeader" in f && _.forEach(a.toJSON(), function(T, A) {
      f.setRequestHeader(A, T);
    }), _.isUndefined(o.withCredentials) || (f.withCredentials = !!o.withCredentials), s && s !== "json" && (f.responseType = o.responseType), c && ([h, m] = $r(c, !0), f.addEventListener("progress", h)), l && f.upload && ([d, p] = $r(l), f.upload.addEventListener("progress", d), f.upload.addEventListener("loadend", p)), (o.cancelToken || o.signal) && (u = (C) => {
      f && (r(!C || C.type ? new cn(null, e, f) : C), f.abort(), f = null);
    }, o.cancelToken && o.cancelToken.subscribe(u), o.signal && (o.signal.aborted ? u() : o.signal.addEventListener("abort", u)));
    const S = r0(o.url);
    if (S && Ce.protocols.indexOf(S) === -1) {
      r(new X("Unsupported protocol " + S + ":", X.ERR_BAD_REQUEST, e));
      return;
    }
    f.send(i || null);
  });
}, f0 = (e, t) => {
  const { length: n } = e = e ? e.filter(Boolean) : [];
  if (t || n) {
    let r = new AbortController(), o;
    const i = function(c) {
      if (!o) {
        o = !0, s();
        const u = c instanceof Error ? c : this.reason;
        r.abort(u instanceof X ? u : new cn(u instanceof Error ? u.message : u));
      }
    };
    let a = t && setTimeout(() => {
      a = null, i(new X(`timeout ${t} of ms exceeded`, X.ETIMEDOUT));
    }, t);
    const s = () => {
      e && (a && clearTimeout(a), a = null, e.forEach((c) => {
        c.unsubscribe ? c.unsubscribe(i) : c.removeEventListener("abort", i);
      }), e = null);
    };
    e.forEach((c) => c.addEventListener("abort", i));
    const { signal: l } = r;
    return l.unsubscribe = () => _.asap(s), l;
  }
}, p0 = function* (e, t) {
  let n = e.byteLength;
  if (n < t) {
    yield e;
    return;
  }
  let r = 0, o;
  for (; r < n; )
    o = r + t, yield e.slice(r, o), r = o;
}, h0 = async function* (e, t) {
  for await (const n of m0(e))
    yield* p0(n, t);
}, m0 = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const t = e.getReader();
  try {
    for (; ; ) {
      const { done: n, value: r } = await t.read();
      if (n)
        break;
      yield r;
    }
  } finally {
    await t.cancel();
  }
}, ps = (e, t, n, r) => {
  const o = h0(e, t);
  let i = 0, a, s = (l) => {
    a || (a = !0, r && r(l));
  };
  return new ReadableStream({
    async pull(l) {
      try {
        const { done: c, value: u } = await o.next();
        if (c) {
          s(), l.close();
          return;
        }
        let d = u.byteLength;
        if (n) {
          let h = i += d;
          n(h);
        }
        l.enqueue(new Uint8Array(u));
      } catch (c) {
        throw s(c), c;
      }
    },
    cancel(l) {
      return s(l), o.return();
    }
  }, {
    highWaterMark: 2
  });
}, co = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", pu = co && typeof ReadableStream == "function", v0 = co && (typeof TextEncoder == "function" ? /* @__PURE__ */ ((e) => (t) => e.encode(t))(new TextEncoder()) : async (e) => new Uint8Array(await new Response(e).arrayBuffer())), hu = (e, ...t) => {
  try {
    return !!e(...t);
  } catch {
    return !1;
  }
}, g0 = pu && hu(() => {
  let e = !1;
  const t = new Request(Ce.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return e = !0, "half";
    }
  }).headers.has("Content-Type");
  return e && !t;
}), hs = 64 * 1024, di = pu && hu(() => _.isReadableStream(new Response("").body)), Br = {
  stream: di && ((e) => e.body)
};
co && ((e) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((t) => {
    !Br[t] && (Br[t] = _.isFunction(e[t]) ? (n) => n[t]() : (n, r) => {
      throw new X(`Response type '${t}' is not supported`, X.ERR_NOT_SUPPORT, r);
    });
  });
})(new Response());
const b0 = async (e) => {
  if (e == null)
    return 0;
  if (_.isBlob(e))
    return e.size;
  if (_.isSpecCompliantForm(e))
    return (await new Request(Ce.origin, {
      method: "POST",
      body: e
    }).arrayBuffer()).byteLength;
  if (_.isArrayBufferView(e) || _.isArrayBuffer(e))
    return e.byteLength;
  if (_.isURLSearchParams(e) && (e = e + ""), _.isString(e))
    return (await v0(e)).byteLength;
}, y0 = async (e, t) => {
  const n = _.toFiniteNumber(e.getContentLength());
  return n ?? b0(t);
}, w0 = co && (async (e) => {
  let {
    url: t,
    method: n,
    data: r,
    signal: o,
    cancelToken: i,
    timeout: a,
    onDownloadProgress: s,
    onUploadProgress: l,
    responseType: c,
    headers: u,
    withCredentials: d = "same-origin",
    fetchOptions: h
  } = fu(e);
  c = c ? (c + "").toLowerCase() : "text";
  let p = f0([o, i && i.toAbortSignal()], a), m;
  const v = p && p.unsubscribe && (() => {
    p.unsubscribe();
  });
  let f;
  try {
    if (l && g0 && n !== "get" && n !== "head" && (f = await y0(u, r)) !== 0) {
      let A = new Request(t, {
        method: "POST",
        body: r,
        duplex: "half"
      }), U;
      if (_.isFormData(r) && (U = A.headers.get("content-type")) && u.setContentType(U), A.body) {
        const [L, H] = us(
          f,
          $r(ds(l))
        );
        r = ps(A.body, hs, L, H);
      }
    }
    _.isString(d) || (d = d ? "include" : "omit");
    const y = "credentials" in Request.prototype;
    m = new Request(t, {
      ...h,
      signal: p,
      method: n.toUpperCase(),
      headers: u.normalize().toJSON(),
      body: r,
      duplex: "half",
      credentials: y ? d : void 0
    });
    let S = await fetch(m);
    const C = di && (c === "stream" || c === "response");
    if (di && (s || C && v)) {
      const A = {};
      ["status", "statusText", "headers"].forEach((G) => {
        A[G] = S[G];
      });
      const U = _.toFiniteNumber(S.headers.get("content-length")), [L, H] = s && us(
        U,
        $r(ds(s), !0)
      ) || [];
      S = new Response(
        ps(S.body, hs, L, () => {
          H && H(), v && v();
        }),
        A
      );
    }
    c = c || "text";
    let T = await Br[_.findKey(Br, c) || "text"](S, e);
    return !C && v && v(), await new Promise((A, U) => {
      uu(A, U, {
        data: T,
        headers: Te.from(S.headers),
        status: S.status,
        statusText: S.statusText,
        config: e,
        request: m
      });
    });
  } catch (y) {
    throw v && v(), y && y.name === "TypeError" && /fetch/i.test(y.message) ? Object.assign(
      new X("Network Error", X.ERR_NETWORK, e, m),
      {
        cause: y.cause || y
      }
    ) : X.from(y, y && y.code, e, m);
  }
}), fi = {
  http: Iw,
  xhr: d0,
  fetch: w0
};
_.forEach(fi, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const ms = (e) => `- ${e}`, x0 = (e) => _.isFunction(e) || e === null || e === !1, mu = {
  getAdapter: (e) => {
    e = _.isArray(e) ? e : [e];
    const { length: t } = e;
    let n, r;
    const o = {};
    for (let i = 0; i < t; i++) {
      n = e[i];
      let a;
      if (r = n, !x0(n) && (r = fi[(a = String(n)).toLowerCase()], r === void 0))
        throw new X(`Unknown adapter '${a}'`);
      if (r)
        break;
      o[a || "#" + i] = r;
    }
    if (!r) {
      const i = Object.entries(o).map(
        ([s, l]) => `adapter ${s} ` + (l === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let a = t ? i.length > 1 ? `since :
` + i.map(ms).join(`
`) : " " + ms(i[0]) : "as no adapter specified";
      throw new X(
        "There is no suitable adapter to dispatch the request " + a,
        "ERR_NOT_SUPPORT"
      );
    }
    return r;
  },
  adapters: fi
};
function Bo(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new cn(null, e);
}
function vs(e) {
  return Bo(e), e.headers = Te.from(e.headers), e.data = $o.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), mu.getAdapter(e.adapter || er.adapter)(e).then(function(r) {
    return Bo(e), r.data = $o.call(
      e,
      e.transformResponse,
      r
    ), r.headers = Te.from(r.headers), r;
  }, function(r) {
    return cu(r) || (Bo(e), r && r.response && (r.response.data = $o.call(
      e,
      e.transformResponse,
      r.response
    ), r.response.headers = Te.from(r.response.headers))), Promise.reject(r);
  });
}
const vu = "1.7.7", Zi = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  Zi[e] = function(r) {
    return typeof r === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const gs = {};
Zi.transitional = function(t, n, r) {
  function o(i, a) {
    return "[Axios v" + vu + "] Transitional option '" + i + "'" + a + (r ? ". " + r : "");
  }
  return (i, a, s) => {
    if (t === !1)
      throw new X(
        o(a, " has been removed" + (n ? " in " + n : "")),
        X.ERR_DEPRECATED
      );
    return n && !gs[a] && (gs[a] = !0, console.warn(
      o(
        a,
        " has been deprecated since v" + n + " and will be removed in the near future"
      )
    )), t ? t(i, a, s) : !0;
  };
};
function E0(e, t, n) {
  if (typeof e != "object")
    throw new X("options must be an object", X.ERR_BAD_OPTION_VALUE);
  const r = Object.keys(e);
  let o = r.length;
  for (; o-- > 0; ) {
    const i = r[o], a = t[i];
    if (a) {
      const s = e[i], l = s === void 0 || a(s, i, e);
      if (l !== !0)
        throw new X("option " + i + " must be " + l, X.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0)
      throw new X("Unknown option " + i, X.ERR_BAD_OPTION);
  }
}
const pi = {
  assertOptions: E0,
  validators: Zi
}, pt = pi.validators;
class Lt {
  constructor(t) {
    this.defaults = t, this.interceptors = {
      request: new ls(),
      response: new ls()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(t, n) {
    try {
      return await this._request(t, n);
    } catch (r) {
      if (r instanceof Error) {
        let o;
        Error.captureStackTrace ? Error.captureStackTrace(o = {}) : o = new Error();
        const i = o.stack ? o.stack.replace(/^.+\n/, "") : "";
        try {
          r.stack ? i && !String(r.stack).endsWith(i.replace(/^.+\n.+\n/, "")) && (r.stack += `
` + i) : r.stack = i;
        } catch {
        }
      }
      throw r;
    }
  }
  _request(t, n) {
    typeof t == "string" ? (n = n || {}, n.url = t) : n = t || {}, n = Mt(this.defaults, n);
    const { transitional: r, paramsSerializer: o, headers: i } = n;
    r !== void 0 && pi.assertOptions(r, {
      silentJSONParsing: pt.transitional(pt.boolean),
      forcedJSONParsing: pt.transitional(pt.boolean),
      clarifyTimeoutError: pt.transitional(pt.boolean)
    }, !1), o != null && (_.isFunction(o) ? n.paramsSerializer = {
      serialize: o
    } : pi.assertOptions(o, {
      encode: pt.function,
      serialize: pt.function
    }, !0)), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let a = i && _.merge(
      i.common,
      i[n.method]
    );
    i && _.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (m) => {
        delete i[m];
      }
    ), n.headers = Te.concat(a, i);
    const s = [];
    let l = !0;
    this.interceptors.request.forEach(function(v) {
      typeof v.runWhen == "function" && v.runWhen(n) === !1 || (l = l && v.synchronous, s.unshift(v.fulfilled, v.rejected));
    });
    const c = [];
    this.interceptors.response.forEach(function(v) {
      c.push(v.fulfilled, v.rejected);
    });
    let u, d = 0, h;
    if (!l) {
      const m = [vs.bind(this), void 0];
      for (m.unshift.apply(m, s), m.push.apply(m, c), h = m.length, u = Promise.resolve(n); d < h; )
        u = u.then(m[d++], m[d++]);
      return u;
    }
    h = s.length;
    let p = n;
    for (d = 0; d < h; ) {
      const m = s[d++], v = s[d++];
      try {
        p = m(p);
      } catch (f) {
        v.call(this, f);
        break;
      }
    }
    try {
      u = vs.call(this, p);
    } catch (m) {
      return Promise.reject(m);
    }
    for (d = 0, h = c.length; d < h; )
      u = u.then(c[d++], c[d++]);
    return u;
  }
  getUri(t) {
    t = Mt(this.defaults, t);
    const n = du(t.baseURL, t.url);
    return au(n, t.params, t.paramsSerializer);
  }
}
_.forEach(["delete", "get", "head", "options"], function(t) {
  Lt.prototype[t] = function(n, r) {
    return this.request(Mt(r || {}, {
      method: t,
      url: n,
      data: (r || {}).data
    }));
  };
});
_.forEach(["post", "put", "patch"], function(t) {
  function n(r) {
    return function(i, a, s) {
      return this.request(Mt(s || {}, {
        method: t,
        headers: r ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: i,
        data: a
      }));
    };
  }
  Lt.prototype[t] = n(), Lt.prototype[t + "Form"] = n(!0);
});
class Ji {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(i) {
      n = i;
    });
    const r = this;
    this.promise.then((o) => {
      if (!r._listeners) return;
      let i = r._listeners.length;
      for (; i-- > 0; )
        r._listeners[i](o);
      r._listeners = null;
    }), this.promise.then = (o) => {
      let i;
      const a = new Promise((s) => {
        r.subscribe(s), i = s;
      }).then(o);
      return a.cancel = function() {
        r.unsubscribe(i);
      }, a;
    }, t(function(i, a, s) {
      r.reason || (r.reason = new cn(i, a, s), n(r.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const n = this._listeners.indexOf(t);
    n !== -1 && this._listeners.splice(n, 1);
  }
  toAbortSignal() {
    const t = new AbortController(), n = (r) => {
      t.abort(r);
    };
    return this.subscribe(n), t.signal.unsubscribe = () => this.unsubscribe(n), t.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new Ji(function(o) {
        t = o;
      }),
      cancel: t
    };
  }
}
function S0(e) {
  return function(n) {
    return e.apply(null, n);
  };
}
function _0(e) {
  return _.isObject(e) && e.isAxiosError === !0;
}
const hi = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(hi).forEach(([e, t]) => {
  hi[t] = e;
});
function gu(e) {
  const t = new Lt(e), n = Gc(Lt.prototype.request, t);
  return _.extend(n, Lt.prototype, t, { allOwnKeys: !0 }), _.extend(n, t, null, { allOwnKeys: !0 }), n.create = function(o) {
    return gu(Mt(e, o));
  }, n;
}
const ge = gu(er);
ge.Axios = Lt;
ge.CanceledError = cn;
ge.CancelToken = Ji;
ge.isCancel = cu;
ge.VERSION = vu;
ge.toFormData = lo;
ge.AxiosError = X;
ge.Cancel = ge.CanceledError;
ge.all = function(t) {
  return Promise.all(t);
};
ge.spread = S0;
ge.isAxiosError = _0;
ge.mergeConfig = Mt;
ge.AxiosHeaders = Te;
ge.formToJSON = (e) => lu(_.isHTMLForm(e) ? new FormData(e) : e);
ge.getAdapter = mu.getAdapter;
ge.HttpStatusCode = hi;
ge.default = ge;
function R0(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var bu = { exports: {} }, En = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var bs;
function O0() {
  if (bs) return En;
  bs = 1;
  var e = z, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function a(s, l, c) {
    var u, d = {}, h = null, p = null;
    c !== void 0 && (h = "" + c), l.key !== void 0 && (h = "" + l.key), l.ref !== void 0 && (p = l.ref);
    for (u in l) r.call(l, u) && !i.hasOwnProperty(u) && (d[u] = l[u]);
    if (s && s.defaultProps) for (u in l = s.defaultProps, l) d[u] === void 0 && (d[u] = l[u]);
    return { $$typeof: t, type: s, key: h, ref: p, props: d, _owner: o.current };
  }
  return En.Fragment = n, En.jsx = a, En.jsxs = a, En;
}
bu.exports = O0();
var Pt = bu.exports, yu = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function n() {
      for (var i = "", a = 0; a < arguments.length; a++) {
        var s = arguments[a];
        s && (i = o(i, r(s)));
      }
      return i;
    }
    function r(i) {
      if (typeof i == "string" || typeof i == "number")
        return i;
      if (typeof i != "object")
        return "";
      if (Array.isArray(i))
        return n.apply(null, i);
      if (i.toString !== Object.prototype.toString && !i.toString.toString().includes("[native code]"))
        return i.toString();
      var a = "";
      for (var s in i)
        t.call(i, s) && i[s] && (a = o(a, s));
      return a;
    }
    function o(i, a) {
      return a ? i ? i + " " + a : i + a : i;
    }
    e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
  })();
})(yu);
var N0 = yu.exports;
const zr = /* @__PURE__ */ R0(N0);
var Pn = /* @__PURE__ */ ((e) => (e.xsmall = "xs", e.small = "sm", e.medium = "md", e.large = "lg", e.xlarge = "xl", e))(Pn || {});
const C0 = "_container_1g94w_1", T0 = "_stack_1g94w_14", j0 = "_circle_1g94w_24", k0 = "_svg_1g94w_40", P0 = "_spin_1g94w_47", Sn = {
  container: C0,
  stack: T0,
  circle: j0,
  svg: k0,
  spin: P0
}, A0 = ({ size: e = Pn.small, variant: t, stack: n = !1, spin: r = !0, title: o, ...i }, a) => {
  le(() => {
    if (!Object.values(Pn).includes(e))
      throw new Error(
        `You must provide a valid size from the SIZES enum: ${Object.keys(Pn).join(", ")}`
      );
  }, [e]);
  const s = zr(i.className, Sn.container, n && Sn.stack, {
    [`text-${t}`]: !n && t !== "secondary",
    "text-gray-900": t === "secondary",
    [Sn.spin]: r
  }), l = zr(Sn.circle, {
    [`bg-${t}`]: n && t !== "secondary",
    "bg-gray-100": n && t === "secondary"
  }), c = { "--size": `var(--icon-size-${e})` };
  return /* @__PURE__ */ Pt.jsxs(
    "div",
    {
      className: s,
      style: c,
      title: o,
      "aria-hidden": o ? void 0 : !0,
      children: [
        n && /* @__PURE__ */ Pt.jsx("span", { className: l, "aria-hidden": "true", "data-circle": !0 }),
        /* @__PURE__ */ Pt.jsx(
          "svg",
          {
            viewBox: "0 0 512 512",
            xmlns: "http://www.w3.org/2000/svg",
            ...i,
            className: Sn.svg,
            ref: a,
            children: /* @__PURE__ */ Pt.jsx(
              "path",
              {
                fill: "currentColor",
                d: "m304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm-368 48c0-26.51-21.49-48-48-48s-48 21.49-48 48 21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zm-294.156-294.156c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"
              }
            )
          }
        )
      ]
    }
  );
}, L0 = We(A0), I0 = vi(L0), D0 = ({
  centered: e,
  className: t,
  color: n = "text-muted",
  icon: r = "spinner",
  iconSize: o = Pn.large,
  text: i = "Loading…",
  ...a
}) => {
  const s = zr(t, "loading-state", {
    "text-center": e,
    [n]: n
  });
  return /* @__PURE__ */ Pt.jsxs("div", { ...a, className: s, children: [
    /* @__PURE__ */ Pt.jsx(
      I0,
      {
        size: o,
        className: zr({
          "mb-3": i
        })
      }
    ),
    i ? /* @__PURE__ */ Pt.jsx("p", { className: "h4 font-weight-normal", children: i }) : null
  ] });
}, Ct = {
  IDLE: "idle",
  LOADING: "loading",
  READY: "ready",
  ERROR: "error"
}, Qt = {
  LOAD: "load",
  READY: "ready",
  ERROR: "error"
}, F0 = {
  state: Ct.IDLE
}, M0 = ({
  className: e = "",
  children: t = null,
  certificateUrl: n = "",
  downloadUrl: r = "",
  loadingLabel: o = "Loading…",
  errorContent: i = "Oops! Something went wrong loading the finisher certificate. Please try again.",
  downloadLabel: a = "Download certificate"
}) => {
  const [s, l] = gi((c, u) => c.state === Ct.IDLE && u.type === Qt.LOAD ? {
    ...c,
    state: Ct.LOADING,
    url: u.url,
    async effect() {
      try {
        await ge.get(u.url), l({ type: Qt.READY });
      } catch {
        l({ type: Qt.ERROR });
      }
    }
  } : c.state === Ct.LOADING && [Qt.READY, Qt.ERROR].includes(u.type) ? { ...c, state: u.type } : c, F0);
  return le(() => {
    if (s.effect) {
      const c = s.effect;
      delete s.effect, c();
    }
  }, [s]), le(() => {
    n != null && n !== "" && l({ type: Qt.LOAD, url: n });
  }, [n]), s.state === Ct.LOADING ? /* @__PURE__ */ R.jsx("div", { className: "finisher-certificate-loader my-2 text-center", children: /* @__PURE__ */ R.jsx(D0, { text: o }) }) : s.state === Ct.ERROR ? /* @__PURE__ */ R.jsx("div", { className: "finisher-certificate-error my-2 text-center", children: i }) : s.state === Ct.READY ? /* @__PURE__ */ R.jsxs("div", { className: `finisher-certificate-container ${e}`, children: [
    /* @__PURE__ */ R.jsx("img", { src: n, alt: "", className: "finisher-certificate-image d-block w-100" }),
    /* @__PURE__ */ R.jsxs("div", { className: "d-flex align-items-center mt-3", children: [
      r !== "" && /* @__PURE__ */ R.jsxs("a", { href: r, className: "btn btn-link p-0 mr-auto", children: [
        /* @__PURE__ */ R.jsx(mt, { className: "mr-2", icon: "download" }),
        a
      ] }),
      t
    ] })
  ] }) : null;
};
M0.propTypes = {
  className: x.string,
  children: x.node,
  certificateUrl: x.string,
  downloadUrl: x.string,
  loadingLabel: x.string,
  errorContent: x.oneOfType([x.string, x.node]),
  downloadLabel: x.string
};
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var wu = ["input:not([inert])", "select:not([inert])", "textarea:not([inert])", "a[href]:not([inert])", "button:not([inert])", "[tabindex]:not(slot):not([inert])", "audio[controls]:not([inert])", "video[controls]:not([inert])", '[contenteditable]:not([contenteditable="false"]):not([inert])', "details>summary:first-of-type:not([inert])", "details:not([inert])"], Ur = /* @__PURE__ */ wu.join(","), xu = typeof Element > "u", $t = xu ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, Wr = !xu && Element.prototype.getRootNode ? function(e) {
  var t;
  return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
} : function(e) {
  return e == null ? void 0 : e.ownerDocument;
}, Hr = function e(t, n) {
  var r;
  n === void 0 && (n = !0);
  var o = t == null || (r = t.getAttribute) === null || r === void 0 ? void 0 : r.call(t, "inert"), i = o === "" || o === "true", a = i || n && t && e(t.parentNode);
  return a;
}, $0 = function(t) {
  var n, r = t == null || (n = t.getAttribute) === null || n === void 0 ? void 0 : n.call(t, "contenteditable");
  return r === "" || r === "true";
}, Eu = function(t, n, r) {
  if (Hr(t))
    return [];
  var o = Array.prototype.slice.apply(t.querySelectorAll(Ur));
  return n && $t.call(t, Ur) && o.unshift(t), o = o.filter(r), o;
}, Su = function e(t, n, r) {
  for (var o = [], i = Array.from(t); i.length; ) {
    var a = i.shift();
    if (!Hr(a, !1))
      if (a.tagName === "SLOT") {
        var s = a.assignedElements(), l = s.length ? s : a.children, c = e(l, !0, r);
        r.flatten ? o.push.apply(o, c) : o.push({
          scopeParent: a,
          candidates: c
        });
      } else {
        var u = $t.call(a, Ur);
        u && r.filter(a) && (n || !t.includes(a)) && o.push(a);
        var d = a.shadowRoot || // check for an undisclosed shadow
        typeof r.getShadowRoot == "function" && r.getShadowRoot(a), h = !Hr(d, !1) && (!r.shadowRootFilter || r.shadowRootFilter(a));
        if (d && h) {
          var p = e(d === !0 ? a.children : d.children, !0, r);
          r.flatten ? o.push.apply(o, p) : o.push({
            scopeParent: a,
            candidates: p
          });
        } else
          i.unshift.apply(i, a.children);
      }
  }
  return o;
}, _u = function(t) {
  return !isNaN(parseInt(t.getAttribute("tabindex"), 10));
}, jt = function(t) {
  if (!t)
    throw new Error("No node provided");
  return t.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(t.tagName) || $0(t)) && !_u(t) ? 0 : t.tabIndex;
}, B0 = function(t, n) {
  var r = jt(t);
  return r < 0 && n && !_u(t) ? 0 : r;
}, z0 = function(t, n) {
  return t.tabIndex === n.tabIndex ? t.documentOrder - n.documentOrder : t.tabIndex - n.tabIndex;
}, Ru = function(t) {
  return t.tagName === "INPUT";
}, U0 = function(t) {
  return Ru(t) && t.type === "hidden";
}, W0 = function(t) {
  var n = t.tagName === "DETAILS" && Array.prototype.slice.apply(t.children).some(function(r) {
    return r.tagName === "SUMMARY";
  });
  return n;
}, H0 = function(t, n) {
  for (var r = 0; r < t.length; r++)
    if (t[r].checked && t[r].form === n)
      return t[r];
}, K0 = function(t) {
  if (!t.name)
    return !0;
  var n = t.form || Wr(t), r = function(s) {
    return n.querySelectorAll('input[type="radio"][name="' + s + '"]');
  }, o;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    o = r(window.CSS.escape(t.name));
  else
    try {
      o = r(t.name);
    } catch (a) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", a.message), !1;
    }
  var i = H0(o, t.form);
  return !i || i === t;
}, q0 = function(t) {
  return Ru(t) && t.type === "radio";
}, V0 = function(t) {
  return q0(t) && !K0(t);
}, G0 = function(t) {
  var n, r = t && Wr(t), o = (n = r) === null || n === void 0 ? void 0 : n.host, i = !1;
  if (r && r !== t) {
    var a, s, l;
    for (i = !!((a = o) !== null && a !== void 0 && (s = a.ownerDocument) !== null && s !== void 0 && s.contains(o) || t != null && (l = t.ownerDocument) !== null && l !== void 0 && l.contains(t)); !i && o; ) {
      var c, u, d;
      r = Wr(o), o = (c = r) === null || c === void 0 ? void 0 : c.host, i = !!((u = o) !== null && u !== void 0 && (d = u.ownerDocument) !== null && d !== void 0 && d.contains(o));
    }
  }
  return i;
}, ys = function(t) {
  var n = t.getBoundingClientRect(), r = n.width, o = n.height;
  return r === 0 && o === 0;
}, Y0 = function(t, n) {
  var r = n.displayCheck, o = n.getShadowRoot;
  if (getComputedStyle(t).visibility === "hidden")
    return !0;
  var i = $t.call(t, "details>summary:first-of-type"), a = i ? t.parentElement : t;
  if ($t.call(a, "details:not([open]) *"))
    return !0;
  if (!r || r === "full" || r === "legacy-full") {
    if (typeof o == "function") {
      for (var s = t; t; ) {
        var l = t.parentElement, c = Wr(t);
        if (l && !l.shadowRoot && o(l) === !0)
          return ys(t);
        t.assignedSlot ? t = t.assignedSlot : !l && c !== t.ownerDocument ? t = c.host : t = l;
      }
      t = s;
    }
    if (G0(t))
      return !t.getClientRects().length;
    if (r !== "legacy-full")
      return !0;
  } else if (r === "non-zero-area")
    return ys(t);
  return !1;
}, X0 = function(t) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(t.tagName))
    for (var n = t.parentElement; n; ) {
      if (n.tagName === "FIELDSET" && n.disabled) {
        for (var r = 0; r < n.children.length; r++) {
          var o = n.children.item(r);
          if (o.tagName === "LEGEND")
            return $t.call(n, "fieldset[disabled] *") ? !0 : !o.contains(t);
        }
        return !0;
      }
      n = n.parentElement;
    }
  return !1;
}, Kr = function(t, n) {
  return !(n.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  Hr(n) || U0(n) || Y0(n, t) || // For a details element with a summary, the summary element gets the focus
  W0(n) || X0(n));
}, mi = function(t, n) {
  return !(V0(n) || jt(n) < 0 || !Kr(t, n));
}, Z0 = function(t) {
  var n = parseInt(t.getAttribute("tabindex"), 10);
  return !!(isNaN(n) || n >= 0);
}, J0 = function e(t) {
  var n = [], r = [];
  return t.forEach(function(o, i) {
    var a = !!o.scopeParent, s = a ? o.scopeParent : o, l = B0(s, a), c = a ? e(o.candidates) : s;
    l === 0 ? a ? n.push.apply(n, c) : n.push(s) : r.push({
      documentOrder: i,
      tabIndex: l,
      item: o,
      isScope: a,
      content: c
    });
  }), r.sort(z0).reduce(function(o, i) {
    return i.isScope ? o.push.apply(o, i.content) : o.push(i.content), o;
  }, []).concat(n);
}, Q0 = function(t, n) {
  n = n || {};
  var r;
  return n.getShadowRoot ? r = Su([t], n.includeContainer, {
    filter: mi.bind(null, n),
    flatten: !1,
    getShadowRoot: n.getShadowRoot,
    shadowRootFilter: Z0
  }) : r = Eu(t, n.includeContainer, mi.bind(null, n)), J0(r);
}, ex = function(t, n) {
  n = n || {};
  var r;
  return n.getShadowRoot ? r = Su([t], n.includeContainer, {
    filter: Kr.bind(null, n),
    flatten: !0,
    getShadowRoot: n.getShadowRoot
  }) : r = Eu(t, n.includeContainer, Kr.bind(null, n)), r;
}, en = function(t, n) {
  if (n = n || {}, !t)
    throw new Error("No node provided");
  return $t.call(t, Ur) === !1 ? !1 : mi(n, t);
}, tx = /* @__PURE__ */ wu.concat("iframe").join(","), zo = function(t, n) {
  if (n = n || {}, !t)
    throw new Error("No node provided");
  return $t.call(t, tx) === !1 ? !1 : Kr(n, t);
};
/*!
* focus-trap 7.6.0
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/
function nx(e, t, n) {
  return (t = ox(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function ws(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function xs(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ws(Object(n), !0).forEach(function(r) {
      nx(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ws(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function rx(e, t) {
  if (typeof e != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (typeof r != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function ox(e) {
  var t = rx(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
var Es = {
  activateTrap: function(t, n) {
    if (t.length > 0) {
      var r = t[t.length - 1];
      r !== n && r.pause();
    }
    var o = t.indexOf(n);
    o === -1 || t.splice(o, 1), t.push(n);
  },
  deactivateTrap: function(t, n) {
    var r = t.indexOf(n);
    r !== -1 && t.splice(r, 1), t.length > 0 && t[t.length - 1].unpause();
  }
}, ix = function(t) {
  return t.tagName && t.tagName.toLowerCase() === "input" && typeof t.select == "function";
}, ax = function(t) {
  return (t == null ? void 0 : t.key) === "Escape" || (t == null ? void 0 : t.key) === "Esc" || (t == null ? void 0 : t.keyCode) === 27;
}, An = function(t) {
  return (t == null ? void 0 : t.key) === "Tab" || (t == null ? void 0 : t.keyCode) === 9;
}, sx = function(t) {
  return An(t) && !t.shiftKey;
}, lx = function(t) {
  return An(t) && t.shiftKey;
}, Ss = function(t) {
  return setTimeout(t, 0);
}, _s = function(t, n) {
  var r = -1;
  return t.every(function(o, i) {
    return n(o) ? (r = i, !1) : !0;
  }), r;
}, _n = function(t) {
  for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)
    r[o - 1] = arguments[o];
  return typeof t == "function" ? t.apply(void 0, r) : t;
}, wr = function(t) {
  return t.target.shadowRoot && typeof t.composedPath == "function" ? t.composedPath()[0] : t.target;
}, cx = [], ux = function(t, n) {
  var r = (n == null ? void 0 : n.document) || document, o = (n == null ? void 0 : n.trapStack) || cx, i = xs({
    returnFocusOnDeactivate: !0,
    escapeDeactivates: !0,
    delayInitialFocus: !0,
    isKeyForward: sx,
    isKeyBackward: lx
  }, n), a = {
    // containers given to createFocusTrap()
    // @type {Array<HTMLElement>}
    containers: [],
    // list of objects identifying tabbable nodes in `containers` in the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    // @type {Array<{
    //   container: HTMLElement,
    //   tabbableNodes: Array<HTMLElement>, // empty if none
    //   focusableNodes: Array<HTMLElement>, // empty if none
    //   posTabIndexesFound: boolean,
    //   firstTabbableNode: HTMLElement|undefined,
    //   lastTabbableNode: HTMLElement|undefined,
    //   firstDomTabbableNode: HTMLElement|undefined,
    //   lastDomTabbableNode: HTMLElement|undefined,
    //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
    // }>}
    containerGroups: [],
    // same order/length as `containers` list
    // references to objects in `containerGroups`, but only those that actually have
    //  tabbable nodes in them
    // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
    //  the same length
    tabbableGroups: [],
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: !1,
    paused: !1,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: void 0,
    // the most recent KeyboardEvent for the configured nav key (typically [SHIFT+]TAB), if any
    recentNavEvent: void 0
  }, s, l = function(N, O, E) {
    return N && N[O] !== void 0 ? N[O] : i[E || O];
  }, c = function(N, O) {
    var E = typeof (O == null ? void 0 : O.composedPath) == "function" ? O.composedPath() : void 0;
    return a.containerGroups.findIndex(function(M) {
      var $ = M.container, I = M.tabbableNodes;
      return $.contains(N) || // fall back to explicit tabbable search which will take into consideration any
      //  web components if the `tabbableOptions.getShadowRoot` option was used for
      //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
      //  look inside web components even if open)
      (E == null ? void 0 : E.includes($)) || I.find(function(P) {
        return P === N;
      });
    });
  }, u = function(N) {
    var O = i[N];
    if (typeof O == "function") {
      for (var E = arguments.length, M = new Array(E > 1 ? E - 1 : 0), $ = 1; $ < E; $++)
        M[$ - 1] = arguments[$];
      O = O.apply(void 0, M);
    }
    if (O === !0 && (O = void 0), !O) {
      if (O === void 0 || O === !1)
        return O;
      throw new Error("`".concat(N, "` was specified but was not a node, or did not return a node"));
    }
    var I = O;
    if (typeof O == "string" && (I = r.querySelector(O), !I))
      throw new Error("`".concat(N, "` as selector refers to no known node"));
    return I;
  }, d = function() {
    var N = u("initialFocus");
    if (N === !1)
      return !1;
    if (N === void 0 || !zo(N, i.tabbableOptions))
      if (c(r.activeElement) >= 0)
        N = r.activeElement;
      else {
        var O = a.tabbableGroups[0], E = O && O.firstTabbableNode;
        N = E || u("fallbackFocus");
      }
    if (!N)
      throw new Error("Your focus-trap needs to have at least one focusable element");
    return N;
  }, h = function() {
    if (a.containerGroups = a.containers.map(function(N) {
      var O = Q0(N, i.tabbableOptions), E = ex(N, i.tabbableOptions), M = O.length > 0 ? O[0] : void 0, $ = O.length > 0 ? O[O.length - 1] : void 0, I = E.find(function(J) {
        return en(J);
      }), P = E.slice().reverse().find(function(J) {
        return en(J);
      }), q = !!O.find(function(J) {
        return jt(J) > 0;
      });
      return {
        container: N,
        tabbableNodes: O,
        focusableNodes: E,
        /** True if at least one node with positive `tabindex` was found in this container. */
        posTabIndexesFound: q,
        /** First tabbable node in container, __tabindex__ order; `undefined` if none. */
        firstTabbableNode: M,
        /** Last tabbable node in container, __tabindex__ order; `undefined` if none. */
        lastTabbableNode: $,
        // NOTE: DOM order is NOT NECESSARILY "document position" order, but figuring that out
        //  would require more than just https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
        //  because that API doesn't work with Shadow DOM as well as it should (@see
        //  https://github.com/whatwg/dom/issues/320) and since this first/last is only needed, so far,
        //  to address an edge case related to positive tabindex support, this seems like a much easier,
        //  "close enough most of the time" alternative for positive tabindexes which should generally
        //  be avoided anyway...
        /** First tabbable node in container, __DOM__ order; `undefined` if none. */
        firstDomTabbableNode: I,
        /** Last tabbable node in container, __DOM__ order; `undefined` if none. */
        lastDomTabbableNode: P,
        /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */
        nextTabbableNode: function(me) {
          var de = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, se = O.indexOf(me);
          return se < 0 ? de ? E.slice(E.indexOf(me) + 1).find(function(Y) {
            return en(Y);
          }) : E.slice(0, E.indexOf(me)).reverse().find(function(Y) {
            return en(Y);
          }) : O[se + (de ? 1 : -1)];
        }
      };
    }), a.tabbableGroups = a.containerGroups.filter(function(N) {
      return N.tabbableNodes.length > 0;
    }), a.tabbableGroups.length <= 0 && !u("fallbackFocus"))
      throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
    if (a.containerGroups.find(function(N) {
      return N.posTabIndexesFound;
    }) && a.containerGroups.length > 1)
      throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
  }, p = function(N) {
    var O = N.activeElement;
    if (O)
      return O.shadowRoot && O.shadowRoot.activeElement !== null ? p(O.shadowRoot) : O;
  }, m = function(N) {
    if (N !== !1 && N !== p(document)) {
      if (!N || !N.focus) {
        m(d());
        return;
      }
      N.focus({
        preventScroll: !!i.preventScroll
      }), a.mostRecentlyFocusedNode = N, ix(N) && N.select();
    }
  }, v = function(N) {
    var O = u("setReturnFocus", N);
    return O || (O === !1 ? !1 : N);
  }, f = function(N) {
    var O = N.target, E = N.event, M = N.isBackward, $ = M === void 0 ? !1 : M;
    O = O || wr(E), h();
    var I = null;
    if (a.tabbableGroups.length > 0) {
      var P = c(O, E), q = P >= 0 ? a.containerGroups[P] : void 0;
      if (P < 0)
        $ ? I = a.tabbableGroups[a.tabbableGroups.length - 1].lastTabbableNode : I = a.tabbableGroups[0].firstTabbableNode;
      else if ($) {
        var J = _s(a.tabbableGroups, function(Ee) {
          var ve = Ee.firstTabbableNode;
          return O === ve;
        });
        if (J < 0 && (q.container === O || zo(O, i.tabbableOptions) && !en(O, i.tabbableOptions) && !q.nextTabbableNode(O, !1)) && (J = P), J >= 0) {
          var me = J === 0 ? a.tabbableGroups.length - 1 : J - 1, de = a.tabbableGroups[me];
          I = jt(O) >= 0 ? de.lastTabbableNode : de.lastDomTabbableNode;
        } else An(E) || (I = q.nextTabbableNode(O, !1));
      } else {
        var se = _s(a.tabbableGroups, function(Ee) {
          var ve = Ee.lastTabbableNode;
          return O === ve;
        });
        if (se < 0 && (q.container === O || zo(O, i.tabbableOptions) && !en(O, i.tabbableOptions) && !q.nextTabbableNode(O)) && (se = P), se >= 0) {
          var Y = se === a.tabbableGroups.length - 1 ? 0 : se + 1, He = a.tabbableGroups[Y];
          I = jt(O) >= 0 ? He.firstTabbableNode : He.firstDomTabbableNode;
        } else An(E) || (I = q.nextTabbableNode(O));
      }
    } else
      I = u("fallbackFocus");
    return I;
  }, y = function(N) {
    var O = wr(N);
    if (!(c(O, N) >= 0)) {
      if (_n(i.clickOutsideDeactivates, N)) {
        s.deactivate({
          // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
          //  which will result in the outside click setting focus to the node
          //  that was clicked (and if not focusable, to "nothing"); by setting
          //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
          //  on activation (or the configured `setReturnFocus` node), whether the
          //  outside click was on a focusable node or not
          returnFocus: i.returnFocusOnDeactivate
        });
        return;
      }
      _n(i.allowOutsideClick, N) || N.preventDefault();
    }
  }, S = function(N) {
    var O = wr(N), E = c(O, N) >= 0;
    if (E || O instanceof Document)
      E && (a.mostRecentlyFocusedNode = O);
    else {
      N.stopImmediatePropagation();
      var M, $ = !0;
      if (a.mostRecentlyFocusedNode)
        if (jt(a.mostRecentlyFocusedNode) > 0) {
          var I = c(a.mostRecentlyFocusedNode), P = a.containerGroups[I].tabbableNodes;
          if (P.length > 0) {
            var q = P.findIndex(function(J) {
              return J === a.mostRecentlyFocusedNode;
            });
            q >= 0 && (i.isKeyForward(a.recentNavEvent) ? q + 1 < P.length && (M = P[q + 1], $ = !1) : q - 1 >= 0 && (M = P[q - 1], $ = !1));
          }
        } else
          a.containerGroups.some(function(J) {
            return J.tabbableNodes.some(function(me) {
              return jt(me) > 0;
            });
          }) || ($ = !1);
      else
        $ = !1;
      $ && (M = f({
        // move FROM the MRU node, not event-related node (which will be the node that is
        //  outside the trap causing the focus escape we're trying to fix)
        target: a.mostRecentlyFocusedNode,
        isBackward: i.isKeyBackward(a.recentNavEvent)
      })), m(M || a.mostRecentlyFocusedNode || d());
    }
    a.recentNavEvent = void 0;
  }, C = function(N) {
    var O = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    a.recentNavEvent = N;
    var E = f({
      event: N,
      isBackward: O
    });
    E && (An(N) && N.preventDefault(), m(E));
  }, T = function(N) {
    (i.isKeyForward(N) || i.isKeyBackward(N)) && C(N, i.isKeyBackward(N));
  }, A = function(N) {
    ax(N) && _n(i.escapeDeactivates, N) !== !1 && (N.preventDefault(), s.deactivate());
  }, U = function(N) {
    var O = wr(N);
    c(O, N) >= 0 || _n(i.clickOutsideDeactivates, N) || _n(i.allowOutsideClick, N) || (N.preventDefault(), N.stopImmediatePropagation());
  }, L = function() {
    if (a.active)
      return Es.activateTrap(o, s), a.delayInitialFocusTimer = i.delayInitialFocus ? Ss(function() {
        m(d());
      }) : m(d()), r.addEventListener("focusin", S, !0), r.addEventListener("mousedown", y, {
        capture: !0,
        passive: !1
      }), r.addEventListener("touchstart", y, {
        capture: !0,
        passive: !1
      }), r.addEventListener("click", U, {
        capture: !0,
        passive: !1
      }), r.addEventListener("keydown", T, {
        capture: !0,
        passive: !1
      }), r.addEventListener("keydown", A), s;
  }, H = function() {
    if (a.active)
      return r.removeEventListener("focusin", S, !0), r.removeEventListener("mousedown", y, !0), r.removeEventListener("touchstart", y, !0), r.removeEventListener("click", U, !0), r.removeEventListener("keydown", T, !0), r.removeEventListener("keydown", A), s;
  }, G = function(N) {
    var O = N.some(function(E) {
      var M = Array.from(E.removedNodes);
      return M.some(function($) {
        return $ === a.mostRecentlyFocusedNode;
      });
    });
    O && m(d());
  }, W = typeof window < "u" && "MutationObserver" in window ? new MutationObserver(G) : void 0, K = function() {
    W && (W.disconnect(), a.active && !a.paused && a.containers.map(function(N) {
      W.observe(N, {
        subtree: !0,
        childList: !0
      });
    }));
  };
  return s = {
    get active() {
      return a.active;
    },
    get paused() {
      return a.paused;
    },
    activate: function(N) {
      if (a.active)
        return this;
      var O = l(N, "onActivate"), E = l(N, "onPostActivate"), M = l(N, "checkCanFocusTrap");
      M || h(), a.active = !0, a.paused = !1, a.nodeFocusedBeforeActivation = r.activeElement, O == null || O();
      var $ = function() {
        M && h(), L(), K(), E == null || E();
      };
      return M ? (M(a.containers.concat()).then($, $), this) : ($(), this);
    },
    deactivate: function(N) {
      if (!a.active)
        return this;
      var O = xs({
        onDeactivate: i.onDeactivate,
        onPostDeactivate: i.onPostDeactivate,
        checkCanReturnFocus: i.checkCanReturnFocus
      }, N);
      clearTimeout(a.delayInitialFocusTimer), a.delayInitialFocusTimer = void 0, H(), a.active = !1, a.paused = !1, K(), Es.deactivateTrap(o, s);
      var E = l(O, "onDeactivate"), M = l(O, "onPostDeactivate"), $ = l(O, "checkCanReturnFocus"), I = l(O, "returnFocus", "returnFocusOnDeactivate");
      E == null || E();
      var P = function() {
        Ss(function() {
          I && m(v(a.nodeFocusedBeforeActivation)), M == null || M();
        });
      };
      return I && $ ? ($(v(a.nodeFocusedBeforeActivation)).then(P, P), this) : (P(), this);
    },
    pause: function(N) {
      if (a.paused || !a.active)
        return this;
      var O = l(N, "onPause"), E = l(N, "onPostPause");
      return a.paused = !0, O == null || O(), H(), K(), E == null || E(), this;
    },
    unpause: function(N) {
      if (!a.paused || !a.active)
        return this;
      var O = l(N, "onUnpause"), E = l(N, "onPostUnpause");
      return a.paused = !1, O == null || O(), h(), L(), K(), E == null || E(), this;
    },
    updateContainerElements: function(N) {
      var O = [].concat(N).filter(Boolean);
      return a.containers = O.map(function(E) {
        return typeof E == "string" ? r.querySelector(E) : E;
      }), a.active && h(), K(), this;
    }
  }, s.updateContainerElements(t), s;
};
const Rn = document.querySelector("html"), dx = ({
  show: e = !1,
  onDismiss: t,
  mainSelector: n = "body",
  className: r = "",
  children: o = null
}) => {
  const i = ae(), a = document.querySelector(n), s = () => Rn.classList.contains("sideNavigationIn"), [l, c] = Ue(!1);
  let u;
  i.current != null && (u = ux(i.current, {
    clickOutsideDeactivates: !0,
    initialFocus: !1
  }));
  const d = (p) => {
    s() && p.key === "Escape" && (p.stopPropagation(), t());
  }, h = (p) => {
    s() && p.target !== i.current && (i.current.contains(p.target) || t());
  };
  return le(() => {
    a && a.classList.add("navigationOverlay"), Rn.addEventListener("keyup", (p) => d(p)), Rn.addEventListener("click", (p) => h(p)), e && c(e);
  }, []), le(() => {
    let p;
    return e ? p = setTimeout(() => {
      c(!0), u && (u.activate(), Rn.classList.add("sideNavigationIn"));
    }) : u && (u.deactivate(), Rn.classList.remove("sideNavigationIn"), p = setTimeout(() => {
      c(!1);
    }, 300)), () => {
      clearTimeout(p);
    };
  }, [e]), /* @__PURE__ */ R.jsx(
    "nav",
    {
      ref: i,
      className: _e(
        `sideNavigation${l ? " sideNavigation__active" : ""}`,
        r
      ),
      children: o
    }
  );
};
dx.propTypes = {
  show: x.bool.isRequired,
  onDismiss: x.func.isRequired,
  mainSelector: x.string.isRequired,
  className: x.string,
  children: x.node
};
const fx = ({ label: e = "Menu", onClick: t, className: n = "", ...r }) => /* @__PURE__ */ R.jsxs(
  "button",
  {
    className: _e("sideNavigationToggler", "btn", "btn-unstyled", "navbar-btn", n),
    ...r,
    onClick: t,
    children: [
      /* @__PURE__ */ R.jsx("span", { className: "sideNavigationToggler__text", children: e }),
      /* @__PURE__ */ R.jsxs("div", { className: "sideNavigationToggler__icon", children: [
        /* @__PURE__ */ R.jsx("span", { className: "sideNavigationToggler__iconBar" }),
        /* @__PURE__ */ R.jsx("span", { className: "sideNavigationToggler__iconBar" }),
        /* @__PURE__ */ R.jsx("span", { className: "sideNavigationToggler__iconBar" })
      ] })
    ]
  }
);
fx.propTypes = {
  label: x.string,
  onClick: x.func,
  className: x.string
};
const Ou = ({
  icon: e = null,
  title: t = null,
  links: n = null,
  children: r = null,
  className: o = ""
}) => /* @__PURE__ */ R.jsxs("div", { className: _e("sideNavigation__menuSection", o), children: [
  t && /* @__PURE__ */ R.jsxs("h2", { className: "sideNavigation__menuSectionHeading", children: [
    e && /* @__PURE__ */ R.jsx(
      "span",
      {
        className: `sideNavigation__menuSectionHeadingIcon fa ${e}`,
        "aria-hidden": "true"
      }
    ),
    t
  ] }),
  n ? /* @__PURE__ */ R.jsx("ul", { className: "sideNavigation__menuSectionLinks", children: n.map((i, a) => /* @__PURE__ */ R.jsx("li", { children: /* @__PURE__ */ R.jsx("a", { href: i.url, ...i.params, children: i.label }) }, `link_${a}`)) }) : r
] });
Ou.propTypes = {
  icon: x.string,
  title: x.string,
  links: x.arrayOf(
    x.shape({
      label: x.string,
      url: x.string,
      params: x.object
    })
  ),
  children: x.node,
  className: x.string
};
const px = ({ title: e = null, url: t = null }) => /* @__PURE__ */ R.jsx("footer", { className: "sideNavigation__footer", children: /* @__PURE__ */ R.jsx("a", { href: t, children: e }) });
px.propTypes = {
  title: x.string.isRequired,
  url: x.string.isRequired
};
const hx = ({
  logged: e = !1,
  profileImage: t = null,
  profileImageAlt: n = "",
  fullName: r = "",
  onSignOut: o,
  signOutLabel: i = "Sign out",
  onSignIn: a,
  signInLabel: s = "Sign in"
}) => e ? /* @__PURE__ */ R.jsxs("div", { className: "sideNavigation__user", children: [
  t && /* @__PURE__ */ R.jsx(
    "img",
    {
      className: "sideNavigation__userPicture img-circle",
      src: t,
      alt: n || r
    }
  ),
  /* @__PURE__ */ R.jsxs("div", { className: "sideNavigation__userContent", children: [
    r && /* @__PURE__ */ R.jsx("h2", { className: "sideNavigation__userRealName", "aria-label": "User name", children: r }),
    /* @__PURE__ */ R.jsx("ul", { className: "sideNavigation__userMenu", children: /* @__PURE__ */ R.jsx("li", { children: /* @__PURE__ */ R.jsxs("button", { className: "sideNavigation__signOutButton", onClick: o, children: [
      /* @__PURE__ */ R.jsx("span", { className: "fa fa-sign-out-alt", "aria-hidden": "true" }),
      i
    ] }) }) })
  ] })
] }) : /* @__PURE__ */ R.jsx("div", { className: "sideNavigation__authentication", children: /* @__PURE__ */ R.jsx("button", { className: "sideNavigation__signInButton", onClick: a, children: s }) });
hx.propTypes = {
  fullName: x.string,
  logged: x.bool,
  signInLabel: x.string,
  onSignIn: x.func.isRequired,
  signOutLabel: x.string,
  onSignOut: x.func.isRequired,
  profileImage: x.string,
  profileImageAlt: x.string
};
const mx = ({
  locale: e,
  locales: t,
  sectionLabel: n = "Language",
  sectionIcon: r = "fa-globe",
  changeLocaleLabel: o = "Change language",
  className: i = ""
}) => /* @__PURE__ */ R.jsx(Ou, { title: n, icon: r, className: i, children: /* @__PURE__ */ R.jsx(
  Gr,
  {
    locale: e,
    locales: t,
    changeLocaleLabel: o,
    className: "locale_selector__side_navigation"
  }
) });
mx.propTypes = {
  changeLocaleLabel: x.string,
  sectionIcon: x.string,
  sectionLabel: x.string,
  locale: x.string,
  locales: x.array,
  className: x.string
};
const vx = ({ shareLabel: e = "Share", useEventBranding: t = !1, className: n, ...r }) => {
  console.warn(
    "The SocialShare container is being deprecated in a future version. Check the README for new implementation."
  );
  const { event: o } = qc();
  return /* @__PURE__ */ R.jsx(
    Wc,
    {
      shareLabel: e,
      useEventBranding: t,
      facebookUrl: o == null ? void 0 : o.facebookUrl,
      twitterUrl: o == null ? void 0 : o.twitter,
      className: n,
      ...r
    }
  );
};
vx.propTypes = {
  shareLabel: x.string,
  useEventBranding: x.bool,
  className: x.string
};
export {
  Vc as ContextHeader,
  Is as EventDetails,
  Yy as EventProvider,
  M0 as FinisherCertificate,
  Vy as Footer,
  Fs as Header,
  Gr as LocaleSelector,
  Ds as PageHeader,
  Pv as RelatedResults,
  dx as SideNavigation,
  px as SideNavigationFooter,
  mx as SideNavigationLocaleSelector,
  Ou as SideNavigationSection,
  hx as SideNavigationSignIn,
  fx as SideNavigationToggler,
  vx as SocialShare,
  Wc as SocialShareComponent,
  qc as useEvent
};
